
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb0f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb0f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7xFrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = module.exports.VNodeMeta = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $gPvyW = parcelRequire("gPvyW");
var $57dbc414fa86987e$var$VNodeMeta = /** @class */ function() {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}();
module.exports.VNodeMeta = $57dbc414fa86987e$var$VNodeMeta;
var $57dbc414fa86987e$var$VNode = /** @class */ function(_super) {
    $ceFTv.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = $ceFTv.__rest(_b, [
            "children"
        ]);
        _this = _super.call(this) || this;
        Object.assign(_this, meta);
        try {
            for(var _f = $ceFTv.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()){
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, $ceFTv.__spreadArray([], $ceFTv.__read(_a.isFragment(vNode) ? vNode.children || [] : [
                    vNode
                ]), false));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _h = $ceFTv.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()){
                var child = _j.value;
                child.parent = _this;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, ".")),
            is && '[is="'.concat(is, '"]')
        ].filter(Boolean).join("");
        return _this;
    }
    VNode.prototype.walkUp = function() {
        var current;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        current
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.namespaceOf = function(tagName) {
        var e_3, _b;
        if ($gPvyW.XMLNamespace[tagName]) return $gPvyW.XMLNamespace[tagName];
        try {
            for(var _c = $ceFTv.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()){
                var namespace = _d.value.namespace;
                if (namespace) return namespace;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $gPvyW.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function(document) {
        if (document === void 0) document = globalThis.document;
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return this.node = text ? document.createTextNode(text) : !tagName ? document.createDocumentFragment() : document.createElementNS(this.namespace || (this.namespace = this.namespaceOf(tagName)), tagName, {
            is: is
        });
    };
    VNode.prototype.toJSON = function() {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({
            key: key,
            text: text,
            selector: selector,
            namespace: namespace,
            tagName: tagName,
            is: is,
            props: props,
            style: style,
            children: children
        }));
    };
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $ceFTv.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $gPvyW.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute("is")
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== "style" && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        className: "class",
        htmlFor: "for"
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}($57dbc414fa86987e$var$VNodeMeta);
module.exports.VNode = $57dbc414fa86987e$var$VNode;

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $8e874a2fb001c377$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $8e874a2fb001c377$export$3c9a16f847548506);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $8e874a2fb001c377$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("gPvyW", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $c409e47346e83e74$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $c409e47346e83e74$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $c409e47346e83e74$export$86f54f62aa7a7514);
$parcel$export(module.exports, "DiffStatus", () => $c409e47346e83e74$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $c409e47346e83e74$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $c409e47346e83e74$export$3f063810d7bf01bd);
$parcel$export(module.exports, "likeArray", () => $c409e47346e83e74$export$b5a4d6f439a5044d);
$parcel$export(module.exports, "isTypedArray", () => $c409e47346e83e74$export$b119cc7e1840e59c);
$parcel$export(module.exports, "createAsyncIterator", () => $c409e47346e83e74$export$86c18c6347f4a8c4);
$parcel$export(module.exports, "parseJSON", () => $c409e47346e83e74$export$27924e57e9afff7f);
$parcel$export(module.exports, "XMLNamespace", () => $c409e47346e83e74$export$f5a4056b78c72efa);
$parcel$export(module.exports, "templateOf", () => $c409e47346e83e74$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $c409e47346e83e74$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $c409e47346e83e74$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $c409e47346e83e74$export$b8a1af58c024fefd);
$parcel$export(module.exports, "stringifyDOM", () => $c409e47346e83e74$export$b0709844452f8b6b);
$parcel$export(module.exports, "importCSS", () => $c409e47346e83e74$export$7cd14c57bbb84350);
$parcel$export(module.exports, "formToJSON", () => $c409e47346e83e74$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "delegate", () => $c409e47346e83e74$export$10b1921597150314);
function $c409e47346e83e74$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c409e47346e83e74$var$$9b05bcda60cc529c$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $c409e47346e83e74$export$61cc6ed0f143570b;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $c409e47346e83e74$export$dd1bc94b04021eeb;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $c409e47346e83e74$export$a09f818797e212c4;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $c409e47346e83e74$export$170f4e08cad8229d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $c409e47346e83e74$export$2a489b3f92f4996a;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $c409e47346e83e74$export$67a6ce548ae77071;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $c409e47346e83e74$export$a48f0734ac7c2329;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $c409e47346e83e74$export$3f34ca2fef821bbd;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $c409e47346e83e74$export$86f54f62aa7a7514;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $c409e47346e83e74$export$89912e019eef22aa;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $c409e47346e83e74$export$1c8ba402144543e5;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $c409e47346e83e74$export$2ddabb89308e1a22;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $c409e47346e83e74$export$14527669107aa301;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $c409e47346e83e74$export$3f063810d7bf01bd;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $c409e47346e83e74$export$b5a4d6f439a5044d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $c409e47346e83e74$export$b119cc7e1840e59c;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $c409e47346e83e74$export$7b85fd78dd236198;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $c409e47346e83e74$export$697c3df919c0e61a;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $c409e47346e83e74$export$e6b5ff3168b5942b;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $c409e47346e83e74$export$1d012a0dff3dab06;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $c409e47346e83e74$export$69a3209f1a06c04d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $c409e47346e83e74$export$86c18c6347f4a8c4;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $c409e47346e83e74$export$dce9414bed0662c;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $c409e47346e83e74$export$271f7c16f175f804;
});
var $c409e47346e83e74$var$$6a9944941b4c1893$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "sum", function() {
    return $c409e47346e83e74$export$8a63f25cc62965f1;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $c409e47346e83e74$export$e1f36757ecda301d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $c409e47346e83e74$export$8e694e1eafd55acb;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $c409e47346e83e74$export$57d7c52a66287430;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $c409e47346e83e74$export$2b4693832ca3ce16;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $c409e47346e83e74$export$5b784e078da1ce6;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $c409e47346e83e74$export$17ec9c9f4f23588c;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $c409e47346e83e74$export$595dbf49c602a1f;
});
function $c409e47346e83e74$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $c409e47346e83e74$export$e1f36757ecda301d(...data) {
    return $c409e47346e83e74$export$8a63f25cc62965f1(...data) / data.length;
}
function $c409e47346e83e74$export$8e694e1eafd55acb(data, sample = false) {
    const average = $c409e47346e83e74$export$e1f36757ecda301d(...data);
    const summary = $c409e47346e83e74$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $c409e47346e83e74$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($c409e47346e83e74$export$8e694e1eafd55acb(data, sample));
}
function $c409e47346e83e74$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($c409e47346e83e74$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $c409e47346e83e74$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf(".") + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $c409e47346e83e74$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? `${text}.${"0".repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $c409e47346e83e74$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
class $c409e47346e83e74$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
function $c409e47346e83e74$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $c409e47346e83e74$export$dd1bc94b04021eeb(value) {
    return $c409e47346e83e74$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
const $c409e47346e83e74$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
function $c409e47346e83e74$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $c409e47346e83e74$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $c409e47346e83e74$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $c409e47346e83e74$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $c409e47346e83e74$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? "-" : ""}${(match[1] || match[0]).toLowerCase()}`);
}
function $c409e47346e83e74$export$86f54f62aa7a7514(raw, large = false) {
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
}
function $c409e47346e83e74$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $c409e47346e83e74$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
}
var $c409e47346e83e74$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($c409e47346e83e74$export$2ddabb89308e1a22 || ($c409e47346e83e74$export$2ddabb89308e1a22 = {}));
function $c409e47346e83e74$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $c409e47346e83e74$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $c409e47346e83e74$export$b5a4d6f439a5044d(data) {
    if ($c409e47346e83e74$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
const $c409e47346e83e74$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $c409e47346e83e74$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($c409e47346e83e74$export$61cc6ed0f143570b(data)) return [];
    if ($c409e47346e83e74$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $c409e47346e83e74$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $c409e47346e83e74$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $c409e47346e83e74$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $c409e47346e83e74$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $c409e47346e83e74$export$1d012a0dff3dab06(list, iteratee) {
    const group = $c409e47346e83e74$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $c409e47346e83e74$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $c409e47346e83e74$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol("done"), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $c409e47346e83e74$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $c409e47346e83e74$export$271f7c16f175f804 extends $c409e47346e83e74$export$595dbf49c602a1f {
    constructor(...args){
        super(...args);
        this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + "B"
            }));
    }
}
var $c409e47346e83e74$var$$f872d8bba1c0f79f$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $c409e47346e83e74$export$c489aa6f7fd82b1a;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $c409e47346e83e74$export$cbd942915f33be50;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $c409e47346e83e74$export$9b886f8493244014;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $c409e47346e83e74$export$e99cbb807a5bb10d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $c409e47346e83e74$export$7a9a31a911eb9a20;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $c409e47346e83e74$export$fca4f8121099df57;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $c409e47346e83e74$export$6ce2f08d515512;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $c409e47346e83e74$export$951c8378cdfec6e6;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $c409e47346e83e74$export$1a4097b876a13bf7;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $c409e47346e83e74$export$d9bcbd5e1ff81430;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $c409e47346e83e74$export$506c8e8f8c8edda;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $c409e47346e83e74$export$3ae94a2503e890a1;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $c409e47346e83e74$export$62ad822b3a5fd9a0;
});
const $c409e47346e83e74$export$c489aa6f7fd82b1a = 1000;
const $c409e47346e83e74$export$cbd942915f33be50 = $c409e47346e83e74$export$c489aa6f7fd82b1a * 60;
const $c409e47346e83e74$export$9b886f8493244014 = $c409e47346e83e74$export$cbd942915f33be50 * 15;
const $c409e47346e83e74$export$e99cbb807a5bb10d = $c409e47346e83e74$export$9b886f8493244014 * 4;
const $c409e47346e83e74$export$7a9a31a911eb9a20 = $c409e47346e83e74$export$e99cbb807a5bb10d * 24;
const $c409e47346e83e74$export$fca4f8121099df57 = $c409e47346e83e74$export$7a9a31a911eb9a20 * 7;
const $c409e47346e83e74$export$6ce2f08d515512 = $c409e47346e83e74$export$7a9a31a911eb9a20 * 365;
const $c409e47346e83e74$export$951c8378cdfec6e6 = $c409e47346e83e74$export$6ce2f08d515512 / 12;
const $c409e47346e83e74$export$1a4097b876a13bf7 = $c409e47346e83e74$export$951c8378cdfec6e6 * 3;
class $c409e47346e83e74$export$d9bcbd5e1ff81430 extends $c409e47346e83e74$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args);
        this.units = [
            {
                base: $c409e47346e83e74$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $c409e47346e83e74$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $c409e47346e83e74$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $c409e47346e83e74$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $c409e47346e83e74$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $c409e47346e83e74$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $c409e47346e83e74$export$6ce2f08d515512,
                name: "Y"
            }
        ];
    }
}
function $c409e47346e83e74$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $c409e47346e83e74$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return (template)=>(value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
}
function $c409e47346e83e74$export$3ae94a2503e890a1(time = new Date(), template = "YYYY-MM-DD HH:mm:ss") {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $c409e47346e83e74$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $c409e47346e83e74$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $c409e47346e83e74$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $c409e47346e83e74$var$$ba0e5dc395660a7c$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $c409e47346e83e74$export$27924e57e9afff7f;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $c409e47346e83e74$export$7ea17d45ecdcf634;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $c409e47346e83e74$export$bb8626e4916f587b;
});
function $c409e47346e83e74$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== "string" || $c409e47346e83e74$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $c409e47346e83e74$export$7ea17d45ecdcf634(raw) {
    const parsed = $c409e47346e83e74$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $c409e47346e83e74$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $c409e47346e83e74$export$bb8626e4916f587b(raw, header, separator = ",") {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>{
        const list = [];
        do {
            let value;
            if (row[0] === '"' || row[0] === "'") {
                value = $c409e47346e83e74$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                const index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($c409e47346e83e74$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map((row)=>row.reduce((object, item, index)=>{
            object[data[0][index]] = item;
            return object;
        }, {}));
}
var $c409e47346e83e74$var$$083124ac4b1a50a0$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $c409e47346e83e74$export$71e6483fc2b024eb;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $c409e47346e83e74$export$eb9b2aadbe449a20;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $c409e47346e83e74$export$13397a83aa5915d6;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $c409e47346e83e74$export$fd89523fba250fa4;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $c409e47346e83e74$export$504fbde693c1771c;
});
function $c409e47346e83e74$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $c409e47346e83e74$export$eb9b2aadbe449a20(raw = globalThis.location?.search, toBuiltIn = true) {
    const list = raw.split(/\?|#/);
    const data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($c409e47346e83e74$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $c409e47346e83e74$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === "string" ? value : $c409e47346e83e74$export$b5a4d6f439a5044d(value) ? $c409e47346e83e74$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
function $c409e47346e83e74$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$c409e47346e83e74$export$dd1bc94b04021eeb(value) && [
            key,
            $c409e47346e83e74$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
async function $c409e47346e83e74$export$fd89523fba250fa4(URI) {
    return (await fetch(URI + "")).blob();
}
const $c409e47346e83e74$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $c409e47346e83e74$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $c409e47346e83e74$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = new ArrayBuffer(data.length);
    const uBuffer = new Uint8Array(aBuffer);
    for(let i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $c409e47346e83e74$var$$50872bf213056663$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $c409e47346e83e74$export$1b9ac4d3de3ffd2e;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$50872bf213056663$exports, "makeSHA", function() {
    return $c409e47346e83e74$export$d51f3b55e8d1aa73;
});
const $c409e47346e83e74$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $c409e47346e83e74$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $c409e47346e83e74$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.["webkitSubtle"]) crypto1.subtle = crypto1["webkitSubtle"];
}
async function $c409e47346e83e74$export$d51f3b55e8d1aa73(raw, algorithm = "SHA-1") {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
var $c409e47346e83e74$var$$93a3089d2937b23f$exports = {};
var $c409e47346e83e74$var$$3e0a089cc13f69ad$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $c409e47346e83e74$export$f5a4056b78c72efa;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $c409e47346e83e74$export$2ee022bbbc550b25;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $c409e47346e83e74$export$a549dd5cef7f8327;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $c409e47346e83e74$export$8eece510bcb9c62c;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $c409e47346e83e74$export$b8a1af58c024fefd;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $c409e47346e83e74$export$a2cf0d4bb6e06de4;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $c409e47346e83e74$export$d66b332881d9723f;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $c409e47346e83e74$export$b0709844452f8b6b;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $c409e47346e83e74$export$5118471ee5d5453b;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $c409e47346e83e74$export$be4650432daa84fd;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $c409e47346e83e74$export$578e38b4a3e0b255;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $c409e47346e83e74$export$7cd14c57bbb84350;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $c409e47346e83e74$export$5100419dfae0456d;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $c409e47346e83e74$export$28d9d24a8cd0ffc2;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $c409e47346e83e74$export$3f99968195accfaf;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $c409e47346e83e74$export$eafdbaa868ea9975;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $c409e47346e83e74$export$36a0c1ca2ae264fa;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $c409e47346e83e74$export$86d7c59254d6a2c9;
});
const $c409e47346e83e74$export$f5a4056b78c72efa = {
    html: "http://www.w3.org/1999/xhtml",
    svg: "http://www.w3.org/2000/svg",
    math: "http://www.w3.org/1998/Math/MathML"
};
const $c409e47346e83e74$var$$3e0a089cc13f69ad$var$templateMap = {};
function $c409e47346e83e74$export$2ee022bbbc550b25(tagName) {
    if ($c409e47346e83e74$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $c409e47346e83e74$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement("template");
    spawn.innerHTML = `<${tagName} />`;
    return $c409e47346e83e74$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $c409e47346e83e74$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes("-")) return "html";
    const [prefix, localName] = tagName.split(":");
    if (localName) return prefix === "html" ? "html" : "xml";
    const node = $c409e47346e83e74$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $c409e47346e83e74$export$8eece510bcb9c62c(Class) {
    return $c409e47346e83e74$export$170f4e08cad8229d(Class, HTMLElement);
}
const $c409e47346e83e74$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $c409e47346e83e74$export$b8a1af58c024fefd(Class) {
    const name = $c409e47346e83e74$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $c409e47346e83e74$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $c409e47346e83e74$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    const template = $c409e47346e83e74$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $c409e47346e83e74$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
function $c409e47346e83e74$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function* $c409e47346e83e74$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($c409e47346e83e74$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $c409e47346e83e74$export$5118471ee5d5453b(node, type);
}
function $c409e47346e83e74$export$be4650432daa84fd(root) {
    var text = "";
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $c409e47346e83e74$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
    }
    return text;
}
function $c409e47346e83e74$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $c409e47346e83e74$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement("link");
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $c409e47346e83e74$export$5100419dfae0456d(data, depth = 0, indent = "    ") {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== "object" ? `${padding}${$c409e47346e83e74$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$c409e47346e83e74$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join("\n");
}
function $c409e47346e83e74$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $c409e47346e83e74$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        "meta",
        "title",
        "link",
        "script"
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $c409e47346e83e74$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $c409e47346e83e74$export$eafdbaa868ea9975(box, handler, depth = 6) {
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ""), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $c409e47346e83e74$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener("visibilitychange", ()=>change(document.visibilityState === "visible" ? last | 1 : last & 2));
}
function $c409e47346e83e74$export$86d7c59254d6a2c9(form) {
    const data = {};
    for (const field of form.elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === "") continue;
        const box = type !== "fieldset" && field.closest("fieldset");
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case "radio":
            case "checkbox":
                if (checked) parsedValue = defaultValue ? $c409e47346e83e74$export$7ea17d45ecdcf634(defaultValue) : true;
                else continue;
                break;
            case "select-multiple":
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$c409e47346e83e74$export$7ea17d45ecdcf634(value));
                break;
            case "fieldset":
                parsedValue = $c409e47346e83e74$export$86d7c59254d6a2c9(field);
                break;
            case "file":
                parsedValue = files && Array.from(files);
                break;
            case "date":
            case "datetime-local":
            case "month":
            case "hidden":
            case "number":
            case "range":
            case "select-one":
                parsedValue = $c409e47346e83e74$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$c409e47346e83e74$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $c409e47346e83e74$var$$bb23e0c794fefbef$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $c409e47346e83e74$export$e772c8ff12451969;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $c409e47346e83e74$export$57207d71b8c929c8;
});
function $c409e47346e83e74$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $c409e47346e83e74$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $c409e47346e83e74$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $c409e47346e83e74$var$$19ed8aeb7905a045$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $c409e47346e83e74$export$10b1921597150314;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $c409e47346e83e74$export$3e2b244719956741;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $c409e47346e83e74$export$1d1d2ed6b55cf67f;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $c409e47346e83e74$export$2155c0b5a4b77fb8;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $c409e47346e83e74$export$9d97473344489dfc;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $c409e47346e83e74$export$d635d04af3887bbe;
});
function $c409e47346e83e74$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $c409e47346e83e74$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    document?.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        document?.readyState === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $c409e47346e83e74$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $c409e47346e83e74$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener("message", server);
    return ()=>globalThis.removeEventListener("message", server);
}
function $c409e47346e83e74$export$9d97473344489dfc(target, origin = "*") {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $c409e47346e83e74$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $c409e47346e83e74$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $c409e47346e83e74$var$$7a08303ce13c49c5$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $c409e47346e83e74$export$1b88f6b6d432a52a;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $c409e47346e83e74$export$b70f6380221b1350;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $c409e47346e83e74$export$75d6cbe4503e149;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $c409e47346e83e74$export$b2618d51188815c2;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $c409e47346e83e74$export$490814474ddbb428;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $c409e47346e83e74$export$3ea201dffb50dfef;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $c409e47346e83e74$export$d1012c7198c6b460;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $c409e47346e83e74$export$a35a418b7b17958e;
});
class $c409e47346e83e74$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? "right" : "left";
            case YL:
                return YD > 0 ? "forward" : "backward";
            case ZL:
                return ZD > 0 ? "up" : "down";
        }
    }
}
function $c409e47346e83e74$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $c409e47346e83e74$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $c409e47346e83e74$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $c409e47346e83e74$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $c409e47346e83e74$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $c409e47346e83e74$export$75d6cbe4503e149(type, element)))
    ]);
}
function $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $c409e47346e83e74$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $c409e47346e83e74$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = "none";
}
function $c409e47346e83e74$export$490814474ddbb428(element, className, display = "block") {
    return $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $c409e47346e83e74$export$3ea201dffb50dfef(element, className, display = "block") {
    return $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $c409e47346e83e74$export$d1012c7198c6b460(element, className, remove) {
    return $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $c409e47346e83e74$export$a35a418b7b17958e(element, className, remove) {
    return $c409e47346e83e74$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $c409e47346e83e74$var$$69bd9f0117925302$exports = {};
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$69bd9f0117925302$exports, "describe", function() {
    return $c409e47346e83e74$export$cd5450f3a47e3789;
});
$c409e47346e83e74$var$$parcel$export($c409e47346e83e74$var$$69bd9f0117925302$exports, "it", function() {
    return $c409e47346e83e74$export$3486a10f30cf1ee4;
});
async function $c409e47346e83e74$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $c409e47346e83e74$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = "    " + title;
    console.time(title);
    async function timeOut() {
        await $c409e47346e83e74$export$e772c8ff12451969(secondsOut);
        throw new RangeError("Timed out");
    }
    try {
        return await Promise.race([
            userCase((status)=>console.assert(status, title)),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("5IMDh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $iYM07 = parcelRequire("iYM07");

var $i3JFt = parcelRequire("i3JFt");

var $gPvyW = parcelRequire("gPvyW");

var $7xFrO = parcelRequire("7xFrO");
var $42a6c93431292c4b$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || "") + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith("aria-") ? (0, $gPvyW.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
        this.removeProperty = function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $gPvyW.toHyphenCase)(key) : $7xFrO.VNode.propsMap[key] || key);
        };
        this.setProperty = function(node, key, value) {
            var isXML = (0, $gPvyW.templateOf)(node.tagName) && (0, $gPvyW.elementTypeOf)(node.tagName) === "xml";
            if (isXML || key.includes("-")) node.setAttribute(key, value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(key, value);
            }
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $gPvyW.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $ceFTv.__values(group[$gPvyW.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $ceFTv.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $ceFTv.__values($ceFTv.__spreadArray($ceFTv.__spreadArray([], $ceFTv.__read(group[$gPvyW.DiffStatus.Same] || []), false), $ceFTv.__read(group[$gPvyW.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $ceFTv.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.createNode = function(vNode, reusedVNodes) {
        var _a;
        if (vNode.text) return vNode.createDOM(this.document);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || vNode.createDOM(this.document);
        var node = this.patch(reusedVNode || new $7xFrO.VNode({
            tagName: vNode.tagName,
            node: vNode.node
        }), vNode).node;
        return node;
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function(root, newNodes) {
        var e_3, _a;
        try {
            for(var _b = $ceFTv.__values($ceFTv.__spreadArray([], $ceFTv.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()){
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0) continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0]) continue;
                oldNode.before.apply(oldNode, $ceFTv.__spreadArray([], $ceFTv.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (newNodes[0]) root.append.apply(root, $ceFTv.__spreadArray([], $ceFTv.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function(node, oldList, newList) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var _c = (0, $gPvyW.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _c.map, group = _c.group;
        var deletingGroup = group[$gPvyW.DiffStatus.Old] && (0, $gPvyW.groupBy)(group[$gPvyW.DiffStatus.Old].map(function(_a) {
            var _b = $ceFTv.__read(_a, 1), key = _b[0];
            return _this.vNodeOf(oldList, key);
        }), function(_a) {
            var selector = _a.selector;
            return selector + "";
        });
        var newNodes = newList.map(function(vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== $gPvyW.DiffStatus.Same) return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null ? vNode.node = oldVNode.node : _this.patch(oldVNode, vNode).node;
        });
        for(var selector in deletingGroup)try {
            for(var _d = (e_4 = void 0, $ceFTv.__values(deletingGroup[selector])), _e = _d.next(); !_e.done; _e = _d.next()){
                var vNode = _e.value;
                this.deleteNode(vNode);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.commitChildren(node, newNodes);
        try {
            for(var newList_1 = $ceFTv.__values(newList), newList_1_1 = newList_1.next(); !newList_1_1.done; newList_1_1 = newList_1.next()){
                var _f = newList_1_1.value, ref = _f.ref, node_1 = _f.node;
                ref === null || ref === void 0 || ref(node_1);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (newList_1_1 && !newList_1_1.done && (_b = newList_1.return)) _b.call(newList_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVNode, newVNode) {
        var _a;
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, this.removeProperty, this.setProperty);
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(node, key) {
            return node.removeProperty((0, $gPvyW.toHyphenCase)(key));
        }, function(node, key, value) {
            return node.setProperty((0, $gPvyW.toHyphenCase)(key), value);
        });
        this.updateChildren(oldVNode.node, oldVNode.children || [], newVNode.children = ((_a = newVNode.children) === null || _a === void 0 ? void 0 : _a.map(function(vNode) {
            return new $7xFrO.VNode(vNode);
        })) || []);
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function(vNode, node) {
        var _a;
        if (node === void 0) node = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.body;
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || $7xFrO.VNode.fromDOM(node);
        root = this.patch(root, new $7xFrO.VNode($ceFTv.__assign($ceFTv.__assign({}, root), {
            children: [
                vNode
            ]
        })));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.buildRenderTree = function(tree) {
        var body = this.document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        var shadowRoots = $ceFTv.__spreadArray([], $ceFTv.__read((0, $iYM07.findShadowRoots)(body)), false);
        return {
            body: body,
            shadowRoots: shadowRoots
        };
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return body.getHTML({
            serializableShadowRoots: true,
            shadowRoots: shadowRoots
        });
    };
    DOMRenderer.prototype.renderToReadableStream = function(tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return $i3JFt.ReadableStream.from((0, $iYM07.generateHTML)(body, {
            serializableShadowRoots: true,
            shadowRoots: shadowRoots
        }));
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $42a6c93431292c4b$var$DOMRenderer;

});
parcelRegister("iYM07", function(module, exports) {
var $dd13108d31ab34bb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dd13108d31ab34bb$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $dd13108d31ab34bb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $dd13108d31ab34bb$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $dd13108d31ab34bb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $dd13108d31ab34bb$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $dd13108d31ab34bb$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $dd13108d31ab34bb$var$__spreadArray([], $dd13108d31ab34bb$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=").concat(JSON.parse(value));
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($dd13108d31ab34bb$var$__spreadArray([
                            tagName
                        ], $dd13108d31ab34bb$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $dd13108d31ab34bb$var$__spreadArray([], $dd13108d31ab34bb$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        '<template shadowrootmode="'.concat(shadowRoot.mode, '">').concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $dd13108d31ab34bb$var$__spreadArray([], $dd13108d31ab34bb$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $dd13108d31ab34bb$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});

parcelRegister("i3JFt", function(module, exports) {

$parcel$export(module.exports, "ReadableStream", () => $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76);
/**
 * @license
 * web-streams-polyfill v4.0.0
 * Copyright 2024 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $33f07bbd4ddcb7b3$var$e() {}
function $33f07bbd4ddcb7b3$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $33f07bbd4ddcb7b3$var$r = $33f07bbd4ddcb7b3$var$e;
function $33f07bbd4ddcb7b3$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $33f07bbd4ddcb7b3$var$n = Promise, $33f07bbd4ddcb7b3$var$a = Promise.resolve.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$i = Promise.prototype.then, $33f07bbd4ddcb7b3$var$l = Promise.reject.bind($33f07bbd4ddcb7b3$var$n), $33f07bbd4ddcb7b3$var$s = $33f07bbd4ddcb7b3$var$a;
function $33f07bbd4ddcb7b3$var$u(e) {
    return new $33f07bbd4ddcb7b3$var$n(e);
}
function $33f07bbd4ddcb7b3$var$c(e) {
    return $33f07bbd4ddcb7b3$var$u((t)=>t(e));
}
function $33f07bbd4ddcb7b3$var$d(e) {
    return $33f07bbd4ddcb7b3$var$l(e);
}
function $33f07bbd4ddcb7b3$var$f(e, t, r) {
    return $33f07bbd4ddcb7b3$var$i.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$b(e, t, o) {
    $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$f(e, t, o), void 0, $33f07bbd4ddcb7b3$var$r);
}
function $33f07bbd4ddcb7b3$var$h(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, t);
}
function $33f07bbd4ddcb7b3$var$m(e, t) {
    $33f07bbd4ddcb7b3$var$b(e, void 0, t);
}
function $33f07bbd4ddcb7b3$var$_(e, t, r) {
    return $33f07bbd4ddcb7b3$var$f(e, t, r);
}
function $33f07bbd4ddcb7b3$var$p(e) {
    $33f07bbd4ddcb7b3$var$f(e, void 0, $33f07bbd4ddcb7b3$var$r);
}
let $33f07bbd4ddcb7b3$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $33f07bbd4ddcb7b3$var$y = queueMicrotask;
    else {
        const e = $33f07bbd4ddcb7b3$var$c(void 0);
        $33f07bbd4ddcb7b3$var$y = (t)=>$33f07bbd4ddcb7b3$var$f(e, t);
    }
    return $33f07bbd4ddcb7b3$var$y(e);
};
function $33f07bbd4ddcb7b3$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $33f07bbd4ddcb7b3$var$g(e, t, r) {
    try {
        return $33f07bbd4ddcb7b3$var$c($33f07bbd4ddcb7b3$var$S(e, t, r));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
class $33f07bbd4ddcb7b3$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, a = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $33f07bbd4ddcb7b3$var$w = Symbol("[[AbortSteps]]"), $33f07bbd4ddcb7b3$var$R = Symbol("[[ErrorSteps]]"), $33f07bbd4ddcb7b3$var$T = Symbol("[[CancelSteps]]"), $33f07bbd4ddcb7b3$var$C = Symbol("[[PullSteps]]"), $33f07bbd4ddcb7b3$var$P = Symbol("[[ReleaseSteps]]");
function $33f07bbd4ddcb7b3$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $33f07bbd4ddcb7b3$var$B(e) : "closed" === t._state ? function(e) {
        $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$A(e);
    }(e) : $33f07bbd4ddcb7b3$var$k(e, t._storedError);
}
function $33f07bbd4ddcb7b3$var$E(e, t) {
    return $33f07bbd4ddcb7b3$var$Or(e._ownerReadableStream, t);
}
function $33f07bbd4ddcb7b3$var$W(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $33f07bbd4ddcb7b3$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $33f07bbd4ddcb7b3$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$33f07bbd4ddcb7b3$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $33f07bbd4ddcb7b3$var$B(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $33f07bbd4ddcb7b3$var$k(e, t) {
    $33f07bbd4ddcb7b3$var$B(e), $33f07bbd4ddcb7b3$var$j(e, t);
}
function $33f07bbd4ddcb7b3$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $33f07bbd4ddcb7b3$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $33f07bbd4ddcb7b3$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $33f07bbd4ddcb7b3$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $33f07bbd4ddcb7b3$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $33f07bbd4ddcb7b3$var$I(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $33f07bbd4ddcb7b3$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $33f07bbd4ddcb7b3$var$Y(e) {
    return Number(e);
}
function $33f07bbd4ddcb7b3$var$x(e) {
    return 0 === e ? 0 : e;
}
function $33f07bbd4ddcb7b3$var$Q(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $33f07bbd4ddcb7b3$var$x(o), !$33f07bbd4ddcb7b3$var$z(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $33f07bbd4ddcb7b3$var$x($33f07bbd4ddcb7b3$var$D(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $33f07bbd4ddcb7b3$var$z(o) && 0 !== o ? o : 0;
}
function $33f07bbd4ddcb7b3$var$N(e, t) {
    if (!$33f07bbd4ddcb7b3$var$Er(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $33f07bbd4ddcb7b3$var$H(e) {
    return new $33f07bbd4ddcb7b3$export$a890bf36e2af9168(e);
}
function $33f07bbd4ddcb7b3$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$U(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $33f07bbd4ddcb7b3$var$G(e) {
    return e._reader._readRequests.length;
}
function $33f07bbd4ddcb7b3$var$X(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$J(t);
}
class $33f07bbd4ddcb7b3$export$a890bf36e2af9168 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamDefaultReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$J(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$J(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("cancel"));
    }
    read() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$ee("read"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let e, t;
        const r = $33f07bbd4ddcb7b3$var$u((r, o)=>{
            e = r, t = o;
        });
        return $33f07bbd4ddcb7b3$var$K(this, {
            _chunkSteps: (t)=>e({
                    value: t,
                    done: !1
                }),
            _closeSteps: ()=>e({
                    value: void 0,
                    done: !0
                }),
            _errorSteps: (e)=>t(e)
        }), r;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$J(this)) throw $33f07bbd4ddcb7b3$var$ee("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$Z(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$J(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $33f07bbd4ddcb7b3$export$a890bf36e2af9168;
}
function $33f07bbd4ddcb7b3$var$K(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$33f07bbd4ddcb7b3$var$C](t);
}
function $33f07bbd4ddcb7b3$var$Z(e, t) {
    const r = e._readRequests;
    e._readRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$ee(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $33f07bbd4ddcb7b3$var$te, $33f07bbd4ddcb7b3$var$re, $33f07bbd4ddcb7b3$var$oe;
function $33f07bbd4ddcb7b3$var$ne(e) {
    return e.slice();
}
function $33f07bbd4ddcb7b3$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
let $33f07bbd4ddcb7b3$var$ie = (e)=>($33f07bbd4ddcb7b3$var$ie = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $33f07bbd4ddcb7b3$var$ie(e)), $33f07bbd4ddcb7b3$var$le = (e)=>($33f07bbd4ddcb7b3$var$le = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $33f07bbd4ddcb7b3$var$le(e));
function $33f07bbd4ddcb7b3$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $33f07bbd4ddcb7b3$var$ae(n, 0, e, t, o), n;
}
function $33f07bbd4ddcb7b3$var$ue(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $33f07bbd4ddcb7b3$var$ce(e) {
    try {
        const t = e.done, r = e.value;
        return $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$s(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $33f07bbd4ddcb7b3$var$d(e);
    }
}
const $33f07bbd4ddcb7b3$var$de = null !== ($33f07bbd4ddcb7b3$var$oe = null !== ($33f07bbd4ddcb7b3$var$te = Symbol.asyncIterator) && void 0 !== $33f07bbd4ddcb7b3$var$te ? $33f07bbd4ddcb7b3$var$te : null === ($33f07bbd4ddcb7b3$var$re = Symbol.for) || void 0 === $33f07bbd4ddcb7b3$var$re ? void 0 : $33f07bbd4ddcb7b3$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $33f07bbd4ddcb7b3$var$oe ? $33f07bbd4ddcb7b3$var$oe : "@@asyncIterator";
function $33f07bbd4ddcb7b3$var$fe(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $33f07bbd4ddcb7b3$var$ue(e, $33f07bbd4ddcb7b3$var$de))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $33f07bbd4ddcb7b3$var$be(e);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$ce(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $33f07bbd4ddcb7b3$var$ue(e.iterator, "return");
                            if (void 0 === t) return $33f07bbd4ddcb7b3$var$c({
                                done: !0,
                                value: r
                            });
                            o = $33f07bbd4ddcb7b3$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $33f07bbd4ddcb7b3$var$d(e);
                        }
                        return $33f07bbd4ddcb7b3$var$t(o) ? $33f07bbd4ddcb7b3$var$ce(o) : $33f07bbd4ddcb7b3$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($33f07bbd4ddcb7b3$var$fe(e, "sync", $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator)));
        } else o = $33f07bbd4ddcb7b3$var$ue(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $33f07bbd4ddcb7b3$var$S(o, e, []);
    if (!$33f07bbd4ddcb7b3$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $33f07bbd4ddcb7b3$var$be(e) {
    const r = $33f07bbd4ddcb7b3$var$S(e.nextMethod, e.iterator, []);
    if (!$33f07bbd4ddcb7b3$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $33f07bbd4ddcb7b3$var$he {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise ? $33f07bbd4ddcb7b3$var$_(this._ongoingPromise, t, t) : t();
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader;
        let t, r;
        const o = $33f07bbd4ddcb7b3$var$u((e, o)=>{
            t = e, r = o;
        });
        return $33f07bbd4ddcb7b3$var$K(e, {
            _chunkSteps: (e)=>{
                this._ongoingPromise = void 0, $33f07bbd4ddcb7b3$var$y(()=>t({
                        value: e,
                        done: !1
                    }));
            },
            _closeSteps: ()=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), t({
                    value: void 0,
                    done: !0
                });
            },
            _errorSteps: (t)=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $33f07bbd4ddcb7b3$var$W(e), r(t);
            }
        }), o;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $33f07bbd4ddcb7b3$var$E(t, e);
            return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$_(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $33f07bbd4ddcb7b3$var$W(t), $33f07bbd4ddcb7b3$var$c({
            value: e,
            done: !0
        });
    }
}
const $33f07bbd4ddcb7b3$var$me = {
    next () {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.next() : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("next"));
    },
    return (e) {
        return $33f07bbd4ddcb7b3$var$_e(this) ? this._asyncIteratorImpl.return(e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$pe("return"));
    },
    [$33f07bbd4ddcb7b3$var$de] () {
        return this;
    }
};
function $33f07bbd4ddcb7b3$var$_e(e) {
    if (!$33f07bbd4ddcb7b3$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $33f07bbd4ddcb7b3$var$he;
    } catch (e) {
        return !1;
    }
}
function $33f07bbd4ddcb7b3$var$pe(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($33f07bbd4ddcb7b3$var$me, $33f07bbd4ddcb7b3$var$de, {
    enumerable: !1
});
const $33f07bbd4ddcb7b3$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $33f07bbd4ddcb7b3$var$Se(e) {
    const t = $33f07bbd4ddcb7b3$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $33f07bbd4ddcb7b3$var$ge(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $33f07bbd4ddcb7b3$var$ve(e, t, r) {
    if ("number" != typeof (o = r) || $33f07bbd4ddcb7b3$var$ye(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $33f07bbd4ddcb7b3$var$we(e) {
    e._queue = new $33f07bbd4ddcb7b3$var$v, e._queueTotalSize = 0;
}
function $33f07bbd4ddcb7b3$var$Re(e) {
    return e === DataView;
}
class $33f07bbd4ddcb7b3$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("view");
        return this._view;
    }
    respond(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respond");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respond"), e = $33f07bbd4ddcb7b3$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ue(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$33f07bbd4ddcb7b3$var$Ce(this)) throw $33f07bbd4ddcb7b3$var$Je("respondWithNewView");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $33f07bbd4ddcb7b3$var$Ge(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respond, "respond"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("byobRequest");
        return $33f07bbd4ddcb7b3$var$He(this);
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("desiredSize");
        return $33f07bbd4ddcb7b3$var$Ve(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $33f07bbd4ddcb7b3$var$Ye(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("enqueue");
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $33f07bbd4ddcb7b3$var$xe(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Te(this)) throw $33f07bbd4ddcb7b3$var$Ke("error");
        $33f07bbd4ddcb7b3$var$Qe(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$qe(this), $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$Me(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $33f07bbd4ddcb7b3$var$Ne(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$Pe(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $33f07bbd4ddcb7b3$var$Te(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $33f07bbd4ddcb7b3$export$2047cf34091e94ac;
}
function $33f07bbd4ddcb7b3$var$Ce(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $33f07bbd4ddcb7b3$export$fbcf11583158d2c;
}
function $33f07bbd4ddcb7b3$var$Pe(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($33f07bbd4ddcb7b3$var$X(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
        if ($33f07bbd4ddcb7b3$var$ot(t) && $33f07bbd4ddcb7b3$var$rt(t) > 0) return !0;
        const r = $33f07bbd4ddcb7b3$var$Ve(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$Pe(e)), null), (t)=>($33f07bbd4ddcb7b3$var$Qe(e, t), null));
}
function $33f07bbd4ddcb7b3$var$qe(e) {
    $33f07bbd4ddcb7b3$var$De(e), e._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v;
}
function $33f07bbd4ddcb7b3$var$Ee(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $33f07bbd4ddcb7b3$var$We(t);
    "default" === t.readerType ? $33f07bbd4ddcb7b3$var$U(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $33f07bbd4ddcb7b3$var$We(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $33f07bbd4ddcb7b3$var$Oe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $33f07bbd4ddcb7b3$var$Be(e, t, r, o) {
    let n;
    try {
        n = $33f07bbd4ddcb7b3$var$se(t, r, r + o);
    } catch (t) {
        throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
    }
    $33f07bbd4ddcb7b3$var$Oe(e, n, 0, o);
}
function $33f07bbd4ddcb7b3$var$ke(e, t) {
    t.bytesFilled > 0 && $33f07bbd4ddcb7b3$var$Be(e, t.buffer, t.byteOffset, t.bytesFilled), $33f07bbd4ddcb7b3$var$$e(e);
}
function $33f07bbd4ddcb7b3$var$je(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, a = !1;
    const i = o - o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    const l = e._queue;
    for(; n > 0;){
        const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
        $33f07bbd4ddcb7b3$var$ae(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $33f07bbd4ddcb7b3$var$Ae(e, o, t), n -= o;
    }
    return a;
}
function $33f07bbd4ddcb7b3$var$Ae(e, t, r) {
    r.bytesFilled += t;
}
function $33f07bbd4ddcb7b3$var$ze(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(e._controlledReadableByteStream)) : $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$De(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $33f07bbd4ddcb7b3$var$Le(e) {
    for(; e._pendingPullIntos.length > 0;){
        if (0 === e._queueTotalSize) return;
        const t = e._pendingPullIntos.peek();
        $33f07bbd4ddcb7b3$var$je(e, t) && ($33f07bbd4ddcb7b3$var$$e(e), $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, t));
    }
}
function $33f07bbd4ddcb7b3$var$Fe(e, t, r, o) {
    const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $33f07bbd4ddcb7b3$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
    let c;
    try {
        c = $33f07bbd4ddcb7b3$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    const d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $33f07bbd4ddcb7b3$var$tt(n, o);
    if ("closed" !== n._state) {
        if (e._queueTotalSize > 0) {
            if ($33f07bbd4ddcb7b3$var$je(e, d)) {
                const t = $33f07bbd4ddcb7b3$var$We(d);
                return $33f07bbd4ddcb7b3$var$ze(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $33f07bbd4ddcb7b3$var$Qe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $33f07bbd4ddcb7b3$var$tt(n, o), $33f07bbd4ddcb7b3$var$Pe(e);
    } else {
        const e = new a(d.buffer, d.byteOffset, 0);
        o._closeSteps(e);
    }
}
function $33f07bbd4ddcb7b3$var$Ie(e, t) {
    const r = e._pendingPullIntos.peek();
    $33f07bbd4ddcb7b3$var$De(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $33f07bbd4ddcb7b3$var$$e(e);
        const r = e._controlledReadableByteStream;
        if ($33f07bbd4ddcb7b3$var$ot(r)) for(; $33f07bbd4ddcb7b3$var$rt(r) > 0;)$33f07bbd4ddcb7b3$var$Ee(r, $33f07bbd4ddcb7b3$var$$e(e));
    }(e, r) : function(e, t, r) {
        if ($33f07bbd4ddcb7b3$var$Ae(0, t, r), "none" === r.readerType) return $33f07bbd4ddcb7b3$var$ke(e, r), void $33f07bbd4ddcb7b3$var$Le(e);
        if (r.bytesFilled < r.minimumFill) return;
        $33f07bbd4ddcb7b3$var$$e(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $33f07bbd4ddcb7b3$var$Be(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o, $33f07bbd4ddcb7b3$var$Ee(e._controlledReadableByteStream, r), $33f07bbd4ddcb7b3$var$Le(e);
    }(e, t, r), $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$$e(e) {
    return e._pendingPullIntos.shift();
}
function $33f07bbd4ddcb7b3$var$Me(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Ye(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize != 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $33f07bbd4ddcb7b3$var$Qe(e, t), t;
                }
            }
            $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$Br(t);
        }
    }
}
function $33f07bbd4ddcb7b3$var$xe(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: a } = t;
    if ($33f07bbd4ddcb7b3$var$le(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const i = $33f07bbd4ddcb7b3$var$ie(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($33f07bbd4ddcb7b3$var$le(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $33f07bbd4ddcb7b3$var$De(e), t.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), "none" === t.readerType && $33f07bbd4ddcb7b3$var$ke(e, t);
    }
    if ($33f07bbd4ddcb7b3$var$X(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $33f07bbd4ddcb7b3$var$Ne(e, t._readRequests.shift());
            }
        }(e), 0 === $33f07bbd4ddcb7b3$var$G(r)) $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$$e(e);
            $33f07bbd4ddcb7b3$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else $33f07bbd4ddcb7b3$var$ot(r) ? ($33f07bbd4ddcb7b3$var$Oe(e, i, n, a), $33f07bbd4ddcb7b3$var$Le(e)) : $33f07bbd4ddcb7b3$var$Oe(e, i, n, a);
    $33f07bbd4ddcb7b3$var$Pe(e);
}
function $33f07bbd4ddcb7b3$var$Qe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$qe(e), $33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$Me(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$Ne(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $33f07bbd4ddcb7b3$var$ze(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $33f07bbd4ddcb7b3$var$He(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($33f07bbd4ddcb7b3$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $33f07bbd4ddcb7b3$var$Ve(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Ue(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $33f07bbd4ddcb7b3$var$ie(r.buffer), $33f07bbd4ddcb7b3$var$Ie(e, t);
}
function $33f07bbd4ddcb7b3$var$Ge(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $33f07bbd4ddcb7b3$var$ie(t.buffer), $33f07bbd4ddcb7b3$var$Ie(e, o);
}
function $33f07bbd4ddcb7b3$var$Xe(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $33f07bbd4ddcb7b3$var$v, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Pe(t), null), (e)=>($33f07bbd4ddcb7b3$var$Qe(t, e), null));
}
function $33f07bbd4ddcb7b3$var$Je(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $33f07bbd4ddcb7b3$var$Ke(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $33f07bbd4ddcb7b3$var$Ze(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $33f07bbd4ddcb7b3$var$et(e) {
    return new $33f07bbd4ddcb7b3$export$20068a30393fcc28(e);
}
function $33f07bbd4ddcb7b3$var$tt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $33f07bbd4ddcb7b3$var$rt(e) {
    return e._reader._readIntoRequests.length;
}
function $33f07bbd4ddcb7b3$var$ot(e) {
    const t = e._reader;
    return void 0 !== t && !!$33f07bbd4ddcb7b3$var$nt(t);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$20068a30393fcc28 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "ReadableStreamBYOBReader"), $33f07bbd4ddcb7b3$var$N(e, "First parameter"), $33f07bbd4ddcb7b3$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$33f07bbd4ddcb7b3$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $33f07bbd4ddcb7b3$var$q(this, e), this._readIntoRequests = new $33f07bbd4ddcb7b3$var$v;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$nt(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("closed"));
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$nt(this) ? void 0 === this._ownerReadableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("cancel")) : $33f07bbd4ddcb7b3$var$E(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("cancel"));
    }
    read(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$lt("read"));
        if (!ArrayBuffer.isView(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($33f07bbd4ddcb7b3$var$le(e.buffer)) return $33f07bbd4ddcb7b3$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $33f07bbd4ddcb7b3$var$L(e, t), {
                    min: $33f07bbd4ddcb7b3$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $33f07bbd4ddcb7b3$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $33f07bbd4ddcb7b3$var$Re(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $33f07bbd4ddcb7b3$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$O("read from"));
        let n, a;
        const i = $33f07bbd4ddcb7b3$var$u((e, t)=>{
            n = e, a = t;
        });
        return $33f07bbd4ddcb7b3$var$at(this, e, o, {
            _chunkSteps: (e)=>n({
                    value: e,
                    done: !1
                }),
            _closeSteps: (e)=>n({
                    value: e,
                    done: !0
                }),
            _errorSteps: (e)=>a(e)
        }), i;
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$nt(this)) throw $33f07bbd4ddcb7b3$var$lt("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $33f07bbd4ddcb7b3$var$W(e);
            const t = new TypeError("Reader was released");
            $33f07bbd4ddcb7b3$var$it(e, t);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$nt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $33f07bbd4ddcb7b3$export$20068a30393fcc28;
}
function $33f07bbd4ddcb7b3$var$at(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $33f07bbd4ddcb7b3$var$Fe(n._readableStreamController, t, r, o);
}
function $33f07bbd4ddcb7b3$var$it(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $33f07bbd4ddcb7b3$var$lt(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $33f07bbd4ddcb7b3$var$st(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($33f07bbd4ddcb7b3$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $33f07bbd4ddcb7b3$var$ut(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $33f07bbd4ddcb7b3$var$ct(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Y(r),
        size: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$dt(o, `${t} has member 'size' that`)
    };
}
function $33f07bbd4ddcb7b3$var$dt(e, t) {
    return $33f07bbd4ddcb7b3$var$F(e, t), (t)=>$33f07bbd4ddcb7b3$var$Y(e(t));
}
function $33f07bbd4ddcb7b3$var$ft(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$bt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), ()=>$33f07bbd4ddcb7b3$var$g(e, t, []);
}
function $33f07bbd4ddcb7b3$var$ht(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$mt(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$_t(e, t) {
    if (!$33f07bbd4ddcb7b3$var$gt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.read, "read"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$pt = "function" == typeof AbortController;
class $33f07bbd4ddcb7b3$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$ft(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$bt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$ht(n, e, `${t} has member 'start' that`),
                write: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$mt(i, e, `${t} has member 'write' that`),
                type: a
            };
        }(e, "First parameter");
        $33f07bbd4ddcb7b3$var$St(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $33f07bbd4ddcb7b3$var$ut(r);
        !function(e, t, r, o) {
            const n = Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype);
            let a, i, l, s;
            a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            l = void 0 !== t.close ? ()=>t.close() : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            $33f07bbd4ddcb7b3$var$Ft(e, n, a, i, l, s, r, o);
        }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), n);
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("locked");
        return $33f07bbd4ddcb7b3$var$vt(this);
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$wt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("abort"));
    }
    close() {
        return $33f07bbd4ddcb7b3$var$gt(this) ? $33f07bbd4ddcb7b3$var$vt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close a stream that already has a writer")) : $33f07bbd4ddcb7b3$var$qt(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Rt(this) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Nt("close"));
    }
    getWriter() {
        if (!$33f07bbd4ddcb7b3$var$gt(this)) throw $33f07bbd4ddcb7b3$var$Nt("getWriter");
        return $33f07bbd4ddcb7b3$var$yt(this);
    }
}
function $33f07bbd4ddcb7b3$var$yt(e) {
    return new $33f07bbd4ddcb7b3$export$9295348f005d6054(e);
}
function $33f07bbd4ddcb7b3$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $33f07bbd4ddcb7b3$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $33f07bbd4ddcb7b3$var$gt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$826849241f7970f8;
}
function $33f07bbd4ddcb7b3$var$vt(e) {
    return void 0 !== e._writer;
}
function $33f07bbd4ddcb7b3$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $33f07bbd4ddcb7b3$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const a = $33f07bbd4ddcb7b3$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $33f07bbd4ddcb7b3$var$Ct(e, t), a;
}
function $33f07bbd4ddcb7b3$var$Rt(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $33f07bbd4ddcb7b3$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $33f07bbd4ddcb7b3$var$or(o), $33f07bbd4ddcb7b3$var$ve(n = e._writableStreamController, $33f07bbd4ddcb7b3$var$Dt, 0), $33f07bbd4ddcb7b3$var$Mt(n), r;
}
function $33f07bbd4ddcb7b3$var$Tt(e, t) {
    "writable" !== e._state ? $33f07bbd4ddcb7b3$var$Pt(e) : $33f07bbd4ddcb7b3$var$Ct(e, t);
}
function $33f07bbd4ddcb7b3$var$Ct(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $33f07bbd4ddcb7b3$var$jt(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $33f07bbd4ddcb7b3$var$Pt(e);
}
function $33f07bbd4ddcb7b3$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$33f07bbd4ddcb7b3$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $33f07bbd4ddcb7b3$var$v, void 0 === e._pendingAbortRequest) return void $33f07bbd4ddcb7b3$var$Et(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $33f07bbd4ddcb7b3$var$Et(e);
    $33f07bbd4ddcb7b3$var$b(e._writableStreamController[$33f07bbd4ddcb7b3$var$w](r._reason), ()=>(r._resolve(), $33f07bbd4ddcb7b3$var$Et(e), null), (t)=>(r._reject(t), $33f07bbd4ddcb7b3$var$Et(e), null));
}
function $33f07bbd4ddcb7b3$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $33f07bbd4ddcb7b3$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $33f07bbd4ddcb7b3$var$Jt(t, e._storedError);
}
function $33f07bbd4ddcb7b3$var$Wt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $33f07bbd4ddcb7b3$var$Zt(e);
    }(r) : $33f07bbd4ddcb7b3$var$or(r)), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$9295348f005d6054 {
    constructor(e){
        if ($33f07bbd4ddcb7b3$var$$(e, 1, "WritableStreamDefaultWriter"), $33f07bbd4ddcb7b3$var$_t(e, "First parameter"), $33f07bbd4ddcb7b3$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$33f07bbd4ddcb7b3$var$qt(e) && e._backpressure ? $33f07bbd4ddcb7b3$var$Zt(this) : $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("erroring" === t) $33f07bbd4ddcb7b3$var$er(this, e._storedError), $33f07bbd4ddcb7b3$var$Gt(this);
        else if ("closed" === t) $33f07bbd4ddcb7b3$var$tr(this), $33f07bbd4ddcb7b3$var$Gt(r = this), $33f07bbd4ddcb7b3$var$Kt(r);
        else {
            const t = e._storedError;
            $33f07bbd4ddcb7b3$var$er(this, t), $33f07bbd4ddcb7b3$var$Xt(this, t);
        }
        var r;
    }
    get closed() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._closedPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("closed"));
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $33f07bbd4ddcb7b3$var$Ut("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $33f07bbd4ddcb7b3$var$$t(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? this._readyPromise : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("ready"));
    }
    abort(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("abort")) : function(e, t) {
            return $33f07bbd4ddcb7b3$var$wt(e._ownerWritableStream, t);
        }(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("abort"));
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("close")) : $33f07bbd4ddcb7b3$var$qt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot close an already-closing stream")) : $33f07bbd4ddcb7b3$var$Bt(this);
    }
    releaseLock() {
        if (!$33f07bbd4ddcb7b3$var$Ot(this)) throw $33f07bbd4ddcb7b3$var$Vt("releaseLock");
        void 0 !== this._ownerWritableStream && $33f07bbd4ddcb7b3$var$At(this);
    }
    write(e) {
        return $33f07bbd4ddcb7b3$var$Ot(this) ? void 0 === this._ownerWritableStream ? $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to")) : $33f07bbd4ddcb7b3$var$zt(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Vt("write"));
    }
}
function $33f07bbd4ddcb7b3$var$Ot(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9295348f005d6054;
}
function $33f07bbd4ddcb7b3$var$Bt(e) {
    return $33f07bbd4ddcb7b3$var$Rt(e._ownerWritableStream);
}
function $33f07bbd4ddcb7b3$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $33f07bbd4ddcb7b3$var$Jt(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$Xt(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $33f07bbd4ddcb7b3$var$rr(e, t) : function(e, t) {
        $33f07bbd4ddcb7b3$var$er(e, t);
    }(e, t);
}
function $33f07bbd4ddcb7b3$var$At(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $33f07bbd4ddcb7b3$var$jt(e, r), $33f07bbd4ddcb7b3$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $33f07bbd4ddcb7b3$var$zt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $33f07bbd4ddcb7b3$var$Yt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$Ut("write to"));
    const a = r._state;
    if ("errored" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    if ($33f07bbd4ddcb7b3$var$qt(r) || "closed" === a) return $33f07bbd4ddcb7b3$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $33f07bbd4ddcb7b3$var$d(r._storedError);
    const i = function(e) {
        return $33f07bbd4ddcb7b3$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            return void $33f07bbd4ddcb7b3$var$Yt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$33f07bbd4ddcb7b3$var$qt(o) && "writable" === o._state) $33f07bbd4ddcb7b3$var$Wt(o, $33f07bbd4ddcb7b3$var$xt(e));
        $33f07bbd4ddcb7b3$var$Mt(e);
    }(o, t, n), i;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.abort, "abort"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Dt = {};
class $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Lt(this)) throw $33f07bbd4ddcb7b3$var$Ht("error");
        "writable" === this._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(this, e);
    }
    [$33f07bbd4ddcb7b3$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$It(this), t;
    }
    [$33f07bbd4ddcb7b3$var$R]() {
        $33f07bbd4ddcb7b3$var$we(this);
    }
}
function $33f07bbd4ddcb7b3$var$Lt(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2;
}
function $33f07bbd4ddcb7b3$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ($33f07bbd4ddcb7b3$var$pt) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    const s = $33f07bbd4ddcb7b3$var$xt(t);
    $33f07bbd4ddcb7b3$var$Wt(e, s);
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$Mt(t), null), (r)=>(t._started = !0, $33f07bbd4ddcb7b3$var$Tt(e, r), null));
}
function $33f07bbd4ddcb7b3$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$Mt(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $33f07bbd4ddcb7b3$var$Pt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $33f07bbd4ddcb7b3$var$Dt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $33f07bbd4ddcb7b3$var$ge(e);
        const r = e._closeAlgorithm();
        $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$b(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $33f07bbd4ddcb7b3$var$Kt(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $33f07bbd4ddcb7b3$var$Tt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $33f07bbd4ddcb7b3$var$b(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($33f07bbd4ddcb7b3$var$ge(e), !$33f07bbd4ddcb7b3$var$qt(r) && "writable" === t) {
                const t = $33f07bbd4ddcb7b3$var$xt(e);
                $33f07bbd4ddcb7b3$var$Wt(r, t);
            }
            return $33f07bbd4ddcb7b3$var$Mt(e), null;
        }, (t)=>("writable" === r._state && $33f07bbd4ddcb7b3$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $33f07bbd4ddcb7b3$var$Tt(e, t);
            }(r, t), null));
    }(e, r);
}
function $33f07bbd4ddcb7b3$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $33f07bbd4ddcb7b3$var$Qt(e, t);
}
function $33f07bbd4ddcb7b3$var$xt(e) {
    return $33f07bbd4ddcb7b3$var$$t(e) <= 0;
}
function $33f07bbd4ddcb7b3$var$Qt(e, t) {
    const r = e._controlledWritableStream;
    $33f07bbd4ddcb7b3$var$It(e), $33f07bbd4ddcb7b3$var$Ct(r, t);
}
function $33f07bbd4ddcb7b3$var$Nt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $33f07bbd4ddcb7b3$var$Ht(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$Vt(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $33f07bbd4ddcb7b3$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $33f07bbd4ddcb7b3$var$Gt(e) {
    e._closedPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $33f07bbd4ddcb7b3$var$Xt(e, t) {
    $33f07bbd4ddcb7b3$var$Gt(e), $33f07bbd4ddcb7b3$var$Jt(e, t);
}
function $33f07bbd4ddcb7b3$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $33f07bbd4ddcb7b3$var$Zt(e) {
    e._readyPromise = $33f07bbd4ddcb7b3$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $33f07bbd4ddcb7b3$var$er(e, t) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$rr(e, t);
}
function $33f07bbd4ddcb7b3$var$tr(e) {
    $33f07bbd4ddcb7b3$var$Zt(e), $33f07bbd4ddcb7b3$var$or(e);
}
function $33f07bbd4ddcb7b3$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $33f07bbd4ddcb7b3$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $33f07bbd4ddcb7b3$var$ar = function() {
    const e = null == $33f07bbd4ddcb7b3$var$nr ? void 0 : $33f07bbd4ddcb7b3$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $33f07bbd4ddcb7b3$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $33f07bbd4ddcb7b3$var$ir(t, r, o, n, a, i) {
    const l = $33f07bbd4ddcb7b3$var$H(t), s = $33f07bbd4ddcb7b3$var$yt(r);
    t._disturbed = !0;
    let _ = !1, y = $33f07bbd4ddcb7b3$var$c(void 0);
    return $33f07bbd4ddcb7b3$var$u((S, g)=>{
        let v;
        if (void 0 !== i) {
            if (v = ()=>{
                const e = void 0 !== i.reason ? i.reason : new $33f07bbd4ddcb7b3$var$ar("Aborted", "AbortError"), o = [];
                n || o.push(()=>"writable" === r._state ? $33f07bbd4ddcb7b3$var$wt(r, e) : $33f07bbd4ddcb7b3$var$c(void 0)), a || o.push(()=>"readable" === t._state ? $33f07bbd4ddcb7b3$var$Or(t, e) : $33f07bbd4ddcb7b3$var$c(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$wt(r, e), !0, e), null)), P(r, s._closedPromise, (e)=>(a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e), null)), w = t, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $33f07bbd4ddcb7b3$var$qt(t) || "closed" === r ? $33f07bbd4ddcb7b3$var$c(void 0) : "errored" === r ? $33f07bbd4ddcb7b3$var$d(t._storedError) : $33f07bbd4ddcb7b3$var$Bt(e);
                })(s)), null), "closed" === w._state ? T() : $33f07bbd4ddcb7b3$var$h(R, T), $33f07bbd4ddcb7b3$var$qt(r) || "closed" === r._state) {
            const e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, e) : q(()=>$33f07bbd4ddcb7b3$var$Or(t, e), !0, e);
        }
        function C() {
            const e = y;
            return $33f07bbd4ddcb7b3$var$f(y, ()=>e !== y ? C() : void 0);
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $33f07bbd4ddcb7b3$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $33f07bbd4ddcb7b3$var$b(e(), ()=>O(t, o), (e)=>O(!0, e)), null;
            }
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? n() : $33f07bbd4ddcb7b3$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $33f07bbd4ddcb7b3$var$qt(r) ? O(e, t) : $33f07bbd4ddcb7b3$var$h(C(), ()=>O(e, t)));
        }
        function O(e, t) {
            return $33f07bbd4ddcb7b3$var$At(s), $33f07bbd4ddcb7b3$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$u((t, r)=>{
            !function o(n) {
                n ? t() : $33f07bbd4ddcb7b3$var$f(_ ? $33f07bbd4ddcb7b3$var$c(!0) : $33f07bbd4ddcb7b3$var$f(s._readyPromise, ()=>$33f07bbd4ddcb7b3$var$u((t, r)=>{
                        $33f07bbd4ddcb7b3$var$K(l, {
                            _chunkSteps: (r)=>{
                                y = $33f07bbd4ddcb7b3$var$f($33f07bbd4ddcb7b3$var$zt(s, r), void 0, $33f07bbd4ddcb7b3$var$e), t(!1);
                            },
                            _closeSteps: ()=>t(!0),
                            _errorSteps: r
                        });
                    })), o, r);
            }(!1);
        }));
    });
}
class $33f07bbd4ddcb7b3$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this);
    }
    close() {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("close");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
        $33f07bbd4ddcb7b3$var$dr(this);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("enqueue");
        if (!$33f07bbd4ddcb7b3$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $33f07bbd4ddcb7b3$var$fr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$lr(this)) throw $33f07bbd4ddcb7b3$var$pr("error");
        $33f07bbd4ddcb7b3$var$br(this, e);
    }
    [$33f07bbd4ddcb7b3$var$T](e) {
        $33f07bbd4ddcb7b3$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $33f07bbd4ddcb7b3$var$cr(this), t;
    }
    [$33f07bbd4ddcb7b3$var$C](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $33f07bbd4ddcb7b3$var$ge(this);
            this._closeRequested && 0 === this._queue.length ? ($33f07bbd4ddcb7b3$var$cr(this), $33f07bbd4ddcb7b3$var$Br(t)) : $33f07bbd4ddcb7b3$var$sr(this), e._chunkSteps(r);
        } else $33f07bbd4ddcb7b3$var$V(t, e), $33f07bbd4ddcb7b3$var$sr(this);
    }
    [$33f07bbd4ddcb7b3$var$P]() {}
}
function $33f07bbd4ddcb7b3$var$lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $33f07bbd4ddcb7b3$export$b0bb6d0989d67700;
}
function $33f07bbd4ddcb7b3$var$sr(e) {
    if (!$33f07bbd4ddcb7b3$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $33f07bbd4ddcb7b3$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $33f07bbd4ddcb7b3$var$sr(e)), null), (t)=>($33f07bbd4ddcb7b3$var$br(e, t), null));
}
function $33f07bbd4ddcb7b3$var$ur(e) {
    const t = e._controlledReadableStream;
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($33f07bbd4ddcb7b3$var$Wr(t) && $33f07bbd4ddcb7b3$var$G(t) > 0) return !0;
    return $33f07bbd4ddcb7b3$var$hr(e) > 0;
}
function $33f07bbd4ddcb7b3$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$dr(e) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$Br(t));
}
function $33f07bbd4ddcb7b3$var$fr(e, t) {
    if (!$33f07bbd4ddcb7b3$var$mr(e)) return;
    const r = e._controlledReadableStream;
    if ($33f07bbd4ddcb7b3$var$Wr(r) && $33f07bbd4ddcb7b3$var$G(r) > 0) $33f07bbd4ddcb7b3$var$U(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
        try {
            $33f07bbd4ddcb7b3$var$ve(e, t, r);
        } catch (t) {
            throw $33f07bbd4ddcb7b3$var$br(e, t), t;
        }
    }
    $33f07bbd4ddcb7b3$var$sr(e);
}
function $33f07bbd4ddcb7b3$var$br(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($33f07bbd4ddcb7b3$var$we(e), $33f07bbd4ddcb7b3$var$cr(e), $33f07bbd4ddcb7b3$var$kr(r, t));
}
function $33f07bbd4ddcb7b3$var$hr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $33f07bbd4ddcb7b3$var$mr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $33f07bbd4ddcb7b3$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $33f07bbd4ddcb7b3$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $33f07bbd4ddcb7b3$var$b($33f07bbd4ddcb7b3$var$c(r()), ()=>(t._started = !0, $33f07bbd4ddcb7b3$var$sr(t), null), (e)=>($33f07bbd4ddcb7b3$var$br(t, e), null));
}
function $33f07bbd4ddcb7b3$var$pr(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$yr(e, t) {
    return $33f07bbd4ddcb7b3$var$Te(e._readableStreamController) ? function(e) {
        let t, r, o, n, a, i = $33f07bbd4ddcb7b3$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            a = e;
        });
        function _(e) {
            $33f07bbd4ddcb7b3$var$m(e._closedPromise, (t)=>(e !== i || ($33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), f && b || a(void 0)), null));
        }
        function p() {
            $33f07bbd4ddcb7b3$var$nt(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$H(e), _(i));
            $33f07bbd4ddcb7b3$var$K(i, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const r = t;
                        let i = t;
                        if (!f && !b) try {
                            i = $33f07bbd4ddcb7b3$var$Se(t);
                        } catch (t) {
                            return $33f07bbd4ddcb7b3$var$Qe(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(n._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                        }
                        f || $33f07bbd4ddcb7b3$var$xe(o._readableStreamController, r), b || $33f07bbd4ddcb7b3$var$xe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, f || $33f07bbd4ddcb7b3$var$Ye(o._readableStreamController), b || $33f07bbd4ddcb7b3$var$Ye(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $33f07bbd4ddcb7b3$var$J(i) && ($33f07bbd4ddcb7b3$var$W(i), i = $33f07bbd4ddcb7b3$var$et(e), _(i));
            const u = r ? n : o, c = r ? o : n;
            $33f07bbd4ddcb7b3$var$at(i, t, 1, {
                _chunkSteps: (t)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        s = !1, d = !1;
                        const o = r ? b : f;
                        if (r ? f : b) o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $33f07bbd4ddcb7b3$var$Se(t);
                            } catch (t) {
                                return $33f07bbd4ddcb7b3$var$Qe(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$Qe(c._readableStreamController, t), void a($33f07bbd4ddcb7b3$var$Or(e, t));
                            }
                            o || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, t), $33f07bbd4ddcb7b3$var$xe(c._readableStreamController, r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    l = !1;
                    const t = r ? b : f, o = r ? f : b;
                    t || $33f07bbd4ddcb7b3$var$Ye(u._readableStreamController), o || $33f07bbd4ddcb7b3$var$Ye(c._readableStreamController), void 0 !== e && (t || $33f07bbd4ddcb7b3$var$Ge(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $33f07bbd4ddcb7b3$var$Ue(c._readableStreamController, 0)), t && o || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            l = !0;
            const e = $33f07bbd4ddcb7b3$var$He(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                const o = $33f07bbd4ddcb7b3$var$ne([
                    t,
                    r
                ]), n = $33f07bbd4ddcb7b3$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function T() {}
        return o = $33f07bbd4ddcb7b3$var$Pr(T, g, w), n = $33f07bbd4ddcb7b3$var$Pr(T, v, R), _(i), [
            o,
            n
        ];
    }(e) : function(e, t) {
        const r = $33f07bbd4ddcb7b3$var$H(e);
        let o, n, a, i, l, s = !1, d = !1, f = !1, b = !1;
        const h = $33f07bbd4ddcb7b3$var$u((e)=>{
            l = e;
        });
        function _() {
            if (s) return d = !0, $33f07bbd4ddcb7b3$var$c(void 0);
            s = !0;
            return $33f07bbd4ddcb7b3$var$K(r, {
                _chunkSteps: (e)=>{
                    $33f07bbd4ddcb7b3$var$y(()=>{
                        d = !1;
                        const t = e, r = e;
                        f || $33f07bbd4ddcb7b3$var$fr(a._readableStreamController, t), b || $33f07bbd4ddcb7b3$var$fr(i._readableStreamController, r), s = !1, d && _();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $33f07bbd4ddcb7b3$var$dr(a._readableStreamController), b || $33f07bbd4ddcb7b3$var$dr(i._readableStreamController), f && b || l(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $33f07bbd4ddcb7b3$var$c(void 0);
        }
        function p(t) {
            if (f = !0, o = t, b) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function S(t) {
            if (b = !0, n = t, f) {
                const t = $33f07bbd4ddcb7b3$var$ne([
                    o,
                    n
                ]), r = $33f07bbd4ddcb7b3$var$Or(e, t);
                l(r);
            }
            return h;
        }
        function g() {}
        return a = $33f07bbd4ddcb7b3$var$Cr(g, _, p), i = $33f07bbd4ddcb7b3$var$Cr(g, _, S), $33f07bbd4ddcb7b3$var$m(r._closedPromise, (e)=>($33f07bbd4ddcb7b3$var$br(a._readableStreamController, e), $33f07bbd4ddcb7b3$var$br(i._readableStreamController, e), f && b || l(void 0), null)), [
            a,
            i
        ];
    }(e);
}
function $33f07bbd4ddcb7b3$var$Sr(r) {
    var o;
    return $33f07bbd4ddcb7b3$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_(e, (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            try {
                return $33f07bbd4ddcb7b3$var$c(r.cancel(e));
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, n, a, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $33f07bbd4ddcb7b3$var$fe(r, "async");
        function a() {
            let e;
            try {
                e = $33f07bbd4ddcb7b3$var$be(n);
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$c(e), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $33f07bbd4ddcb7b3$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $33f07bbd4ddcb7b3$var$fr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            const r = n.iterator;
            let o;
            try {
                o = $33f07bbd4ddcb7b3$var$ue(r, "return");
            } catch (e) {
                return $33f07bbd4ddcb7b3$var$d(e);
            }
            if (void 0 === o) return $33f07bbd4ddcb7b3$var$c(void 0);
            return $33f07bbd4ddcb7b3$var$_($33f07bbd4ddcb7b3$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$33f07bbd4ddcb7b3$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $33f07bbd4ddcb7b3$var$Cr($33f07bbd4ddcb7b3$var$e, a, i, 0), o;
    }(r);
}
function $33f07bbd4ddcb7b3$var$gr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$vr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$wr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Rr(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $33f07bbd4ddcb7b3$var$Tr(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(a, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.close, "close"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $33f07bbd4ddcb7b3$var$I(e, "First parameter");
        const r = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), o = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Q(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $33f07bbd4ddcb7b3$var$gr(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$vr(a, r, `${t} has member 'pull' that`),
                start: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$wr(i, r, `${t} has member 'start' that`),
                type: void 0 === l ? void 0 : $33f07bbd4ddcb7b3$var$Rr(l, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($33f07bbd4ddcb7b3$var$qr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype);
                let n, a, i;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
                const l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $33f07bbd4ddcb7b3$var$Xe(e, o, n, a, i, r, l);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 0));
        } else {
            const e = $33f07bbd4ddcb7b3$var$ut(r);
            !function(e, t, r, o) {
                const n = Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype);
                let a, i, l;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0), $33f07bbd4ddcb7b3$var$_r(e, n, a, i, l, r, o);
            }(this, o, $33f07bbd4ddcb7b3$var$st(r, 1), e);
        }
    }
    get locked() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("locked");
        return $33f07bbd4ddcb7b3$var$Wr(this);
    }
    cancel(e) {
        return $33f07bbd4ddcb7b3$var$Er(this) ? $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $33f07bbd4ddcb7b3$var$Or(this, e) : $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("cancel"));
    }
    getReader(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("getReader");
        return void 0 === function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Ze(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $33f07bbd4ddcb7b3$var$H(this) : $33f07bbd4ddcb7b3$var$et(this);
    }
    pipeThrough(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("pipeThrough");
        $33f07bbd4ddcb7b3$var$$(e, 1, "pipeThrough");
        const r = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $33f07bbd4ddcb7b3$var$M(r, "readable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$N(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $33f07bbd4ddcb7b3$var$M(o, "writable", "ReadableWritablePair"), $33f07bbd4ddcb7b3$var$_t(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        if ($33f07bbd4ddcb7b3$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($33f07bbd4ddcb7b3$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $33f07bbd4ddcb7b3$var$p($33f07bbd4ddcb7b3$var$ir(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) return $33f07bbd4ddcb7b3$var$d($33f07bbd4ddcb7b3$var$jr("pipeTo"));
        if (void 0 === e) return $33f07bbd4ddcb7b3$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$33f07bbd4ddcb7b3$var$gt(e)) return $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $33f07bbd4ddcb7b3$var$Tr(t, "Second parameter");
        } catch (e) {
            return $33f07bbd4ddcb7b3$var$d(e);
        }
        return $33f07bbd4ddcb7b3$var$Wr(this) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $33f07bbd4ddcb7b3$var$vt(e) ? $33f07bbd4ddcb7b3$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $33f07bbd4ddcb7b3$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("tee");
        return $33f07bbd4ddcb7b3$var$ne($33f07bbd4ddcb7b3$var$yr(this));
    }
    values(e) {
        if (!$33f07bbd4ddcb7b3$var$Er(this)) throw $33f07bbd4ddcb7b3$var$jr("values");
        return function(e, t) {
            const r = $33f07bbd4ddcb7b3$var$H(e), o = new $33f07bbd4ddcb7b3$var$he(r, t), n = Object.create($33f07bbd4ddcb7b3$var$me);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$33f07bbd4ddcb7b3$var$de](e) {
        return this.values(e);
    }
    static from(e) {
        return $33f07bbd4ddcb7b3$var$Sr(e);
    }
}
function $33f07bbd4ddcb7b3$var$Cr(e, t, r, o = 1, n = ()=>1) {
    const a = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(a);
    return $33f07bbd4ddcb7b3$var$_r(a, Object.create($33f07bbd4ddcb7b3$export$b0bb6d0989d67700.prototype), e, t, r, o, n), a;
}
function $33f07bbd4ddcb7b3$var$Pr(e, t, r) {
    const o = Object.create($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype);
    $33f07bbd4ddcb7b3$var$qr(o);
    return $33f07bbd4ddcb7b3$var$Xe(o, Object.create($33f07bbd4ddcb7b3$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $33f07bbd4ddcb7b3$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $33f07bbd4ddcb7b3$var$Er(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76;
}
function $33f07bbd4ddcb7b3$var$Wr(e) {
    return void 0 !== e._reader;
}
function $33f07bbd4ddcb7b3$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $33f07bbd4ddcb7b3$var$c(void 0);
    if ("errored" === t._state) return $33f07bbd4ddcb7b3$var$d(t._storedError);
    $33f07bbd4ddcb7b3$var$Br(t);
    const o = t._reader;
    if (void 0 !== o && $33f07bbd4ddcb7b3$var$nt(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $33f07bbd4ddcb7b3$var$_(t._readableStreamController[$33f07bbd4ddcb7b3$var$T](r), $33f07bbd4ddcb7b3$var$e);
}
function $33f07bbd4ddcb7b3$var$Br(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($33f07bbd4ddcb7b3$var$A(t), $33f07bbd4ddcb7b3$var$J(t))) {
        const e = t._readRequests;
        t._readRequests = new $33f07bbd4ddcb7b3$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $33f07bbd4ddcb7b3$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($33f07bbd4ddcb7b3$var$j(r, t), $33f07bbd4ddcb7b3$var$J(r) ? $33f07bbd4ddcb7b3$var$Z(r, t) : $33f07bbd4ddcb7b3$var$it(r, t));
}
function $33f07bbd4ddcb7b3$var$jr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $33f07bbd4ddcb7b3$var$Ar(e, t) {
    $33f07bbd4ddcb7b3$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $33f07bbd4ddcb7b3$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $33f07bbd4ddcb7b3$var$Y(r)
    };
}
Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.from, "from"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.tee, "tee"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype, $33f07bbd4ddcb7b3$var$de, {
    value: $33f07bbd4ddcb7b3$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$zr = (e)=>e.byteLength;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$zr, "size");
class $33f07bbd4ddcb7b3$export$d386b5f37d154119 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$Lr(this)) throw $33f07bbd4ddcb7b3$var$Dr("size");
        return $33f07bbd4ddcb7b3$var$zr;
    }
}
function $33f07bbd4ddcb7b3$var$Dr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$Lr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$d386b5f37d154119;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $33f07bbd4ddcb7b3$var$Fr = ()=>1;
$33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$var$Fr, "size");
class $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625 {
    constructor(e){
        $33f07bbd4ddcb7b3$var$$(e, 1, "CountQueuingStrategy"), e = $33f07bbd4ddcb7b3$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$33f07bbd4ddcb7b3$var$$r(this)) throw $33f07bbd4ddcb7b3$var$Ir("size");
        return $33f07bbd4ddcb7b3$var$Fr;
    }
}
function $33f07bbd4ddcb7b3$var$Ir(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $33f07bbd4ddcb7b3$var$$r(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $33f07bbd4ddcb7b3$export$9ebfec18c2dfc625;
}
function $33f07bbd4ddcb7b3$var$Mr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$Yr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$S(e, t, [
            r
        ]);
}
function $33f07bbd4ddcb7b3$var$xr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r, o)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r,
            o
        ]);
}
function $33f07bbd4ddcb7b3$var$Qr(e, t, r) {
    return $33f07bbd4ddcb7b3$var$F(e, r), (r)=>$33f07bbd4ddcb7b3$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $33f07bbd4ddcb7b3$var$ct(t, "Second parameter"), n = $33f07bbd4ddcb7b3$var$ct(r, "Third parameter"), a = function(e, t) {
            $33f07bbd4ddcb7b3$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $33f07bbd4ddcb7b3$var$Qr(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $33f07bbd4ddcb7b3$var$Mr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === a ? void 0 : $33f07bbd4ddcb7b3$var$Yr(a, e, `${t} has member 'start' that`),
                transform: void 0 === i ? void 0 : $33f07bbd4ddcb7b3$var$xr(i, e, `${t} has member 'transform' that`),
                writableType: l
            };
        }(e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        const i = $33f07bbd4ddcb7b3$var$st(n, 0), l = $33f07bbd4ddcb7b3$var$ut(n), s = $33f07bbd4ddcb7b3$var$st(o, 1), f = $33f07bbd4ddcb7b3$var$ut(o);
        let h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $33f07bbd4ddcb7b3$var$_(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $33f07bbd4ddcb7b3$var$Zr(r, t);
                    });
                    return $33f07bbd4ddcb7b3$var$Zr(r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$br(o._readableStreamController, t), $33f07bbd4ddcb7b3$var$to(r)), null), (e)=>($33f07bbd4ddcb7b3$var$br(o._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $33f07bbd4ddcb7b3$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $33f07bbd4ddcb7b3$var$Jr(t), $33f07bbd4ddcb7b3$var$b(o, ()=>("errored" === r._state ? $33f07bbd4ddcb7b3$var$ro(t, r._storedError) : ($33f07bbd4ddcb7b3$var$dr(r._readableStreamController), $33f07bbd4ddcb7b3$var$to(t)), null), (e)=>($33f07bbd4ddcb7b3$var$br(r._readableStreamController, e), $33f07bbd4ddcb7b3$var$ro(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $33f07bbd4ddcb7b3$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $33f07bbd4ddcb7b3$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $33f07bbd4ddcb7b3$var$Jr(r), $33f07bbd4ddcb7b3$var$b(n, ()=>("errored" === o._state ? $33f07bbd4ddcb7b3$var$ro(r, o._storedError) : ($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$to(r)), null), (t)=>($33f07bbd4ddcb7b3$var$Yt(o._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e), $33f07bbd4ddcb7b3$var$ro(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                const i = Object.create($33f07bbd4ddcb7b3$export$826849241f7970f8.prototype);
                return $33f07bbd4ddcb7b3$var$St(i), $33f07bbd4ddcb7b3$var$Ft(i, Object.create($33f07bbd4ddcb7b3$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, a), i;
            }(i, l, c, s, r, o), e._readable = $33f07bbd4ddcb7b3$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $33f07bbd4ddcb7b3$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $33f07bbd4ddcb7b3$var$u((e)=>{
            h = e;
        }), s, f, i, l), function(e, t) {
            const r = Object.create($33f07bbd4ddcb7b3$export$a55559184460222.prototype);
            let o, n, a;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $33f07bbd4ddcb7b3$var$Kr(r, e), $33f07bbd4ddcb7b3$var$c(void 0);
                } catch (e) {
                    return $33f07bbd4ddcb7b3$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$33f07bbd4ddcb7b3$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    get readable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("readable");
        return this._readable;
    }
    get writable() {
        if (!$33f07bbd4ddcb7b3$var$Nr(this)) throw $33f07bbd4ddcb7b3$var$oo("writable");
        return this._writable;
    }
}
function $33f07bbd4ddcb7b3$var$Nr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $33f07bbd4ddcb7b3$export$d102341634899398;
}
function $33f07bbd4ddcb7b3$var$Hr(e, t) {
    $33f07bbd4ddcb7b3$var$br(e._readable._readableStreamController, t), $33f07bbd4ddcb7b3$var$Vr(e, t);
}
function $33f07bbd4ddcb7b3$var$Vr(e, t) {
    $33f07bbd4ddcb7b3$var$Jr(e._transformStreamController), $33f07bbd4ddcb7b3$var$Yt(e._writable._writableStreamController, t), $33f07bbd4ddcb7b3$var$Ur(e);
}
function $33f07bbd4ddcb7b3$var$Ur(e) {
    e._backpressure && $33f07bbd4ddcb7b3$var$Gr(e, !1);
}
function $33f07bbd4ddcb7b3$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $33f07bbd4ddcb7b3$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($33f07bbd4ddcb7b3$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $33f07bbd4ddcb7b3$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("desiredSize");
        return $33f07bbd4ddcb7b3$var$hr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("enqueue");
        $33f07bbd4ddcb7b3$var$Kr(this, e);
    }
    error(e) {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("error");
        var t;
        t = e, $33f07bbd4ddcb7b3$var$Hr(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$33f07bbd4ddcb7b3$var$Xr(this)) throw $33f07bbd4ddcb7b3$var$eo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $33f07bbd4ddcb7b3$var$dr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $33f07bbd4ddcb7b3$var$Vr(t, r);
        }(this);
    }
}
function $33f07bbd4ddcb7b3$var$Xr(e) {
    return !!$33f07bbd4ddcb7b3$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $33f07bbd4ddcb7b3$export$a55559184460222;
}
function $33f07bbd4ddcb7b3$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $33f07bbd4ddcb7b3$var$Kr(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$33f07bbd4ddcb7b3$var$mr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $33f07bbd4ddcb7b3$var$fr(o, t);
    } catch (e) {
        throw $33f07bbd4ddcb7b3$var$Vr(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$33f07bbd4ddcb7b3$var$ur(e);
    }(o);
    n !== r._backpressure && $33f07bbd4ddcb7b3$var$Gr(r, !0);
}
function $33f07bbd4ddcb7b3$var$Zr(e, t) {
    return $33f07bbd4ddcb7b3$var$_(e._transformAlgorithm(t), void 0, (t)=>{
        throw $33f07bbd4ddcb7b3$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $33f07bbd4ddcb7b3$var$eo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $33f07bbd4ddcb7b3$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($33f07bbd4ddcb7b3$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $33f07bbd4ddcb7b3$var$oo(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($33f07bbd4ddcb7b3$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.enqueue, "enqueue"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.error, "error"), $33f07bbd4ddcb7b3$var$o($33f07bbd4ddcb7b3$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($33f07bbd4ddcb7b3$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});


parcelRegister("a2E6i", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterableForSet({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterableForSet({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    value: undefined,
                    done: true
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

var $81404cd24b820a12$exports = {};
"use strict";
Object.defineProperty($81404cd24b820a12$exports, "__esModule", {
    value: true
});
$81404cd24b820a12$exports.Fragment = $81404cd24b820a12$exports.jsxDEV = $81404cd24b820a12$exports.jsxs = void 0;
$81404cd24b820a12$exports.jsx = $81404cd24b820a12$var$jsx;

var $ceFTv = parcelRequire("ceFTv");

var $gPvyW = parcelRequire("gPvyW");

var $7xFrO = parcelRequire("7xFrO");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $81404cd24b820a12$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === "function" && (0, $gPvyW.isHTMLElementClass)(type)) type = (0, $gPvyW.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $7xFrO.VNode(node) : node === 0 || node ? new $7xFrO.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === "string" ? new $7xFrO.VNode($ceFTv.__assign($ceFTv.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($ceFTv.__assign($ceFTv.__assign({}, commonProps), props));
}
$81404cd24b820a12$exports.jsxs = $81404cd24b820a12$var$jsx;
$81404cd24b820a12$exports.jsxDEV = $81404cd24b820a12$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $81404cd24b820a12$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $7xFrO.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $gPvyW.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$81404cd24b820a12$exports.Fragment = $81404cd24b820a12$var$Fragment;


var $750599b2838f6371$exports = {};
"use strict";
Object.defineProperty($750599b2838f6371$exports, "__esModule", {
    value: true
});

var $ceFTv = parcelRequire("ceFTv");

$ceFTv.__exportStar((parcelRequire("7xFrO")), $750599b2838f6371$exports);

$ceFTv.__exportStar((parcelRequire("5IMDh")), $750599b2838f6371$exports);



var $a2E6i = parcelRequire("a2E6i");


var $a2E6i = parcelRequire("a2E6i");


var $a2E6i = parcelRequire("a2E6i");

var $gPvyW = parcelRequire("gPvyW");

function $5f04ae9df0cc484b$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $5f04ae9df0cc484b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $5f04ae9df0cc484b$export$2e9a7bb10257a509;
});
var $5f04ae9df0cc484b$var$$552a56cc5ff3f479$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $5f04ae9df0cc484b$export$c7e91f8aec23ae14;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $5f04ae9df0cc484b$export$b06b4c21253e26e2;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $5f04ae9df0cc484b$export$4077c0dfbe9c3861;
});
class $5f04ae9df0cc484b$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $5f04ae9df0cc484b$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $5f04ae9df0cc484b$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $gPvyW.delegate)(targetSelector, (event)=>{
            root.removeEventListener("animationend", ended);
            root.removeEventListener("animationcancel", ended);
            resolve(event);
        });
        root.addEventListener("animationend", ended);
        root.addEventListener("animationcancel", ended);
    });
var $5f04ae9df0cc484b$var$$317b1f21909c74b8$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$317b1f21909c74b8$exports, "component", function() {
    return $5f04ae9df0cc484b$export$d8556a2a8f973135;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$317b1f21909c74b8$exports, "on", function() {
    return $5f04ae9df0cc484b$export$af631764ddc44097;
});
const $5f04ae9df0cc484b$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $5f04ae9df0cc484b$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return (this.internals || this).shadowRoot || this;
            }
            constructor(){
                var _a;
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.tagName.includes("-") ? this.attachInternals() : undefined
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $750599b2838f6371$exports.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !((_a = this.internals) === null || _a === void 0 ? void 0 : _a.shadowRoot)) this.attachShadow(meta);
            }
            async connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $5f04ae9df0cc484b$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super["connectedCallback"]) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                await this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            async update() {
                var _a;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $gPvyW.isEmpty)(vNode) ? meta.mode ? (0, $81404cd24b820a12$exports.jsx)("slot", {}) : null : vNode;
                if (!(content != null)) return;
                const render = ()=>{
                    var _a;
                    this.renderer.render(content, this.root);
                    (_a = this.updatedCallback) === null || _a === void 0 || _a.call(this);
                };
                if (!meta.transitible || typeof document.startViewTransition !== "function") return render();
                const { updateCallbackDone: updateCallbackDone, finished: finished } = document.startViewTransition(render);
                try {
                    await finished;
                } catch (_b) {
                    return updateCallbackDone;
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $5f04ae9df0cc484b$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $5f04ae9df0cc484b$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $5f04ae9df0cc484b$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $gPvyW.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $5f04ae9df0cc484b$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
}
var $5f04ae9df0cc484b$var$$0c03e47eb1097734$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$0c03e47eb1097734$exports, "observer", function() {
    return $5f04ae9df0cc484b$export$b6ae1bc530f4c149;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$0c03e47eb1097734$exports, "attribute", function() {
    return $5f04ae9df0cc484b$export$af4b9a83f4b00434;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$0c03e47eb1097734$exports, "reaction", function() {
    return $5f04ae9df0cc484b$export$7203b476385689ae;
});
var $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
function $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$wrapFunction(func) {
    const renderer = new (0, $750599b2838f6371$exports.DOMRenderer)();
    return (props)=>{
        const tree = func(props);
        let disposer;
        const { ref: ref } = tree;
        tree.ref = (node)=>{
            disposer === null || disposer === void 0 || disposer();
            if (node) disposer = (0, $a2E6i.autorun)(()=>{
                const newTree = func(props);
                renderer.patch((0, $750599b2838f6371$exports.VNode).fromDOM(node), newTree);
            });
            ref === null || ref === void 0 || ref(node);
        };
        return tree;
    };
}
const $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$reactionMap = new WeakMap();
function $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return $5f04ae9df0cc484b$export$b06b4c21253e26e2(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { update: update } = Object.getPrototypeOf(this);
                    return new Promise((resolve)=>this.disposers.push((0, $a2E6i.autorun)(()=>update.call(this).then(resolve))));
                }
            });
            Promise.resolve().then(()=>$5f04ae9df0cc484b$var$$0c03e47eb1097734$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super["disconnectedCallback"]) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor["observedAttributes"];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $gPvyW.toCamelCase)(name)] = (0, $gPvyW.parseJSON)(value);
            (_a = super["attributeChangedCallback"]) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            let value = this[(0, $gPvyW.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === "object") {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === "object" ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor["observedAttributes"] || [], reactions = $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $a2E6i.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $a2E6i.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $5f04ae9df0cc484b$export$b6ae1bc530f4c149(func, _) {
    return (0, $gPvyW.isHTMLElementClass)(func) ? $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$wrapClass(func) : $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$wrapFunction(func);
}
function $5f04ae9df0cc484b$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor["observedAttributes"], attribute = (0, $gPvyW.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
function $5f04ae9df0cc484b$export$7203b476385689ae(expression) {
    return (effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $5f04ae9df0cc484b$var$$0c03e47eb1097734$var$reactionMap.set(this, reactions);
        });
}
var $5f04ae9df0cc484b$var$$819b340f625a29f4$exports = {};
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5f04ae9df0cc484b$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        $5f04ae9df0cc484b$export$d8556a2a8f973135({
            tagName: "animation-css"
        }),
        $5f04ae9df0cc484b$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _playing_extraInitializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(this, _instanceExtraInitializers), $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(this, _type_extraInitializers), $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_initializers, false)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_extraInitializers)
            });
        }
        get type() {
            return $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $gPvyW.importCSS)("https://unpkg.com/animate.css@4/animate.min.css");
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await $5f04ae9df0cc484b$export$4077c0dfbe9c3861(this, ".animate__animated");
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $81404cd24b820a12$exports.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes("Out") ? (0, $81404cd24b820a12$exports.jsx)((0, $81404cd24b820a12$exports.Fragment), {}) : (0, $81404cd24b820a12$exports.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $5f04ae9df0cc484b$export$af4b9a83f4b00434,
            (0, $a2E6i.observable)
        ];
        _playing_decorators = [
            $5f04ae9df0cc484b$export$af4b9a83f4b00434,
            (0, $a2E6i.observable)
        ];
        _typeChanged_decorators = [
            $5f04ae9df0cc484b$export$7203b476385689ae(({ type: type })=>type)
        ];
        $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5f04ae9df0cc484b$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();
$5f04ae9df0cc484b$var$$parcel$exportWildcard($5f04ae9df0cc484b$var$$d4436c849e74ae70$exports, $5f04ae9df0cc484b$var$$819b340f625a29f4$exports);
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$8acf79bd061a8fc3$exports, "AsyncCell", function() {
    return $5f04ae9df0cc484b$export$854a54a999c89982;
});
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $5f04ae9df0cc484b$export$488013bae63b21da;
});
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $5f04ae9df0cc484b$export$854a54a999c89982 = (()=>{
    var _AsyncCell_component_accessor_storage, _AsyncCell_delegatedProps_accessor_storage;
    let _classDecorators = [
        $5f04ae9df0cc484b$export$d8556a2a8f973135({
            tagName: "async-cell"
        }),
        $5f04ae9df0cc484b$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _component_decorators;
    let _component_initializers = [];
    let _component_extraInitializers = [];
    let _delegatedProps_decorators;
    let _delegatedProps_initializers = [];
    let _delegatedProps_extraInitializers = [];
    var AsyncCell = _classThis = class extends _classSuper {
        get component() {
            return $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_component_accessor_storage, "f");
        }
        set component(value) {
            $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_component_accessor_storage, value, "f");
        }
        get delegatedProps() {
            return $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _AsyncCell_delegatedProps_accessor_storage, "f");
        }
        set delegatedProps(value) {
            $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _AsyncCell_delegatedProps_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.load();
        }
        async load() {
            this.component = undefined;
            const Tag = await this.loader();
            this.component = (_a)=>{
                var { children: children } = _a, props = $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__rest(_a, [
                    "children"
                ]);
                return (0, $81404cd24b820a12$exports.jsx)(Tag, Object.assign({}, props, {
                    children: children
                }));
            };
            this.emit("load", this.component);
        }
        render() {
            const { component: Tag, props: props, delegatedProps: delegatedProps } = this;
            const _a = Object.assign(Object.assign({}, props), delegatedProps), { children: children } = _a, data = $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__rest(_a, [
                "children"
            ]);
            return Tag && (0, $81404cd24b820a12$exports.jsx)(Tag, Object.assign({}, data, {
                children: children
            }));
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "loader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AsyncCell_component_accessor_storage.set(this, $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_initializers, void 0));
            _AsyncCell_delegatedProps_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_extraInitializers), $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_initializers, void 0)));
            $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers(this, _delegatedProps_extraInitializers);
        }
    };
    _AsyncCell_component_accessor_storage = new WeakMap();
    _AsyncCell_delegatedProps_accessor_storage = new WeakMap();
    $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "AsyncCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $a2E6i.observable)
        ];
        _delegatedProps_decorators = [
            (0, $a2E6i.observable)
        ];
        $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _delegatedProps_decorators, {
            kind: "accessor",
            name: "delegatedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"delegatedProps" in obj,
                get: (obj)=>obj.delegatedProps,
                set: (obj, value)=>{
                    obj.delegatedProps = value;
                }
            },
            metadata: _metadata
        }, _delegatedProps_initializers, _delegatedProps_extraInitializers);
        $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AsyncCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5f04ae9df0cc484b$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AsyncCell = _classThis;
})();
function $5f04ae9df0cc484b$export$488013bae63b21da(loader) {
    return (props)=>(0, $81404cd24b820a12$exports.jsx)($5f04ae9df0cc484b$export$854a54a999c89982, {
            delegatedProps: props,
            loader: async ()=>(await loader()).default
        });
}
var $5f04ae9df0cc484b$var$$29675797ddd6c4f7$exports = {};
$5f04ae9df0cc484b$var$$parcel$export($5f04ae9df0cc484b$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $5f04ae9df0cc484b$export$2a668e8d088a0667;
});
var $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $5f04ae9df0cc484b$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _name_extraInitializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _value_extraInitializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _required_extraInitializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _disabled_extraInitializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        let _autofocus_extraInitializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute("value", raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute("value");
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _instanceExtraInitializers), $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_extraInitializers), $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_extraInitializers), $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_extraInitializers), $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set(this, ($5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_extraInitializers), $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_initializers, void 0)));
                $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_extraInitializers);
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $5f04ae9df0cc484b$export$7203b476385689ae(({ value: value })=>value)
            ];
            _name_decorators = [
                $5f04ae9df0cc484b$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _value_decorators = [
                (0, $a2E6i.observable)
            ];
            _required_decorators = [
                $5f04ae9df0cc484b$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _disabled_decorators = [
                $5f04ae9df0cc484b$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            _autofocus_decorators = [
                $5f04ae9df0cc484b$export$af4b9a83f4b00434,
                (0, $a2E6i.observable)
            ];
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $5f04ae9df0cc484b$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}


var $c16a839cb8b1bd69$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c16a839cb8b1bd69$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c16a839cb8b1bd69$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c16a839cb8b1bd69$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c16a839cb8b1bd69$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $c16a839cb8b1bd69$export$4e979e05ed1000ce = (()=>{
    var _CommandLine_active_accessor_storage, _CommandLine_shownIndex_accessor_storage, _CommandLine_text_accessor_storage;
    let _classDecorators = [
        (0, $5f04ae9df0cc484b$export$d8556a2a8f973135)({
            tagName: "command-line"
        }),
        (0, $5f04ae9df0cc484b$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _active_decorators;
    let _active_initializers = [];
    let _active_extraInitializers = [];
    let _shownIndex_decorators;
    let _shownIndex_initializers = [];
    let _shownIndex_extraInitializers = [];
    let _text_decorators;
    let _text_initializers = [];
    let _text_extraInitializers = [];
    var CommandLine = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CommandLine_active_accessor_storage.set(this, $c16a839cb8b1bd69$var$__runInitializers(this, _active_initializers, false));
            _CommandLine_shownIndex_accessor_storage.set(this, ($c16a839cb8b1bd69$var$__runInitializers(this, _active_extraInitializers), $c16a839cb8b1bd69$var$__runInitializers(this, _shownIndex_initializers, 0)));
            _CommandLine_text_accessor_storage.set(this, ($c16a839cb8b1bd69$var$__runInitializers(this, _shownIndex_extraInitializers), $c16a839cb8b1bd69$var$__runInitializers(this, _text_initializers, "")));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c16a839cb8b1bd69$var$__runInitializers(this, _text_extraInitializers)
            });
            Object.defineProperty(this, "autoCopy", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const target = this.querySelector("kbd");
                    self.getSelection().getRangeAt(0).selectNode(target);
                    document.execCommand("copy");
                }
            });
        }
        get active() {
            return $c16a839cb8b1bd69$var$__classPrivateFieldGet(this, _CommandLine_active_accessor_storage, "f");
        }
        set active(value) {
            $c16a839cb8b1bd69$var$__classPrivateFieldSet(this, _CommandLine_active_accessor_storage, value, "f");
        }
        get shownIndex() {
            return $c16a839cb8b1bd69$var$__classPrivateFieldGet(this, _CommandLine_shownIndex_accessor_storage, "f");
        }
        set shownIndex(value) {
            $c16a839cb8b1bd69$var$__classPrivateFieldSet(this, _CommandLine_shownIndex_accessor_storage, value, "f");
        }
        get text() {
            return $c16a839cb8b1bd69$var$__classPrivateFieldGet(this, _CommandLine_text_accessor_storage, "f");
        }
        set text(value) {
            $c16a839cb8b1bd69$var$__classPrivateFieldSet(this, _CommandLine_text_accessor_storage, value, "f");
        }
        mountedCallback() {
            this.classList.add("d-block", "rounded", "p-3", "bg-dark", "text-white");
            this.tabIndex = -1;
            this.addEventListener("click", this.autoCopy);
            this.addEventListener("focus", ()=>this.active = true);
            this.addEventListener("blur", ()=>this.active = false);
            this.boot();
        }
        boot() {
            this.timer = self.setInterval(()=>{
                const { text: text } = this;
                if (!text) return;
                const { shownIndex: shownIndex } = this;
                this.shownIndex++;
                if (shownIndex >= text.length) self.clearInterval(this.timer);
            }, 100);
        }
        disconnectedCallback() {
            self.clearInterval(this.timer);
        }
        render() {
            const { text: text } = this, { shownIndex: shownIndex, active: active } = this;
            return (0, $81404cd24b820a12$exports.jsxs)((0, $81404cd24b820a12$exports.Fragment), {
                children: [
                    (0, $81404cd24b820a12$exports.jsx)("span", {
                        className: "user-select-none",
                        children: "$"
                    }),
                    (0, $81404cd24b820a12$exports.jsx)("kbd", {
                        className: "bg-dark",
                        children: text.slice(0, shownIndex)
                    }),
                    (0, $81404cd24b820a12$exports.jsx)("small", {
                        className: "badge bg-success",
                        style: {
                            opacity: active ? "1" : "0",
                            transition: "0.25s"
                        },
                        children: "Copied !"
                    })
                ]
            });
        }
    };
    _CommandLine_active_accessor_storage = new WeakMap();
    _CommandLine_shownIndex_accessor_storage = new WeakMap();
    _CommandLine_text_accessor_storage = new WeakMap();
    $c16a839cb8b1bd69$var$__setFunctionName(_classThis, "CommandLine");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _active_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _shownIndex_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _text_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        $c16a839cb8b1bd69$var$__esDecorate(_classThis, null, _active_decorators, {
            kind: "accessor",
            name: "active",
            static: false,
            private: false,
            access: {
                has: (obj)=>"active" in obj,
                get: (obj)=>obj.active,
                set: (obj, value)=>{
                    obj.active = value;
                }
            },
            metadata: _metadata
        }, _active_initializers, _active_extraInitializers);
        $c16a839cb8b1bd69$var$__esDecorate(_classThis, null, _shownIndex_decorators, {
            kind: "accessor",
            name: "shownIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"shownIndex" in obj,
                get: (obj)=>obj.shownIndex,
                set: (obj, value)=>{
                    obj.shownIndex = value;
                }
            },
            metadata: _metadata
        }, _shownIndex_initializers, _shownIndex_extraInitializers);
        $c16a839cb8b1bd69$var$__esDecorate(_classThis, null, _text_decorators, {
            kind: "accessor",
            name: "text",
            static: false,
            private: false,
            access: {
                has: (obj)=>"text" in obj,
                get: (obj)=>obj.text,
                set: (obj, value)=>{
                    obj.text = value;
                }
            },
            metadata: _metadata
        }, _text_initializers, _text_extraInitializers);
        $c16a839cb8b1bd69$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CommandLine = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $c16a839cb8b1bd69$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CommandLine = _classThis;
})();




var $a2E6i = parcelRequire("a2E6i");

var $9bd74e182967b200$exports = {};
"use strict";
"use strict";
"use strict";
var $30d519aac5b45306$exports = {};
"use strict";
var $b1d7c5e53f116382$exports = {};
"use strict";
var $b1d7c5e53f116382$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$b1d7c5e53f116382$exports = // eslint-disable-next-line es/no-global-this -- safe
$b1d7c5e53f116382$var$check(typeof globalThis == "object" && globalThis) || $b1d7c5e53f116382$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$b1d7c5e53f116382$var$check(typeof self == "object" && self) || $b1d7c5e53f116382$var$check(typeof $parcel$global == "object" && $parcel$global) || $b1d7c5e53f116382$var$check(typeof $b1d7c5e53f116382$exports == "object" && $b1d7c5e53f116382$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $c70a379edcf167c9$export$2d1720544b23b823;
"use strict";
var $2b526490d9608540$exports = {};
"use strict";
var $3d081374f1421bdf$exports = {};
"use strict";
$3d081374f1421bdf$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$2b526490d9608540$exports = !$3d081374f1421bdf$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $f4e20e30bd7fe607$exports = {};
"use strict";
var $2f783e7f9db6c573$exports = {};
"use strict";

$2f783e7f9db6c573$exports = !$3d081374f1421bdf$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $f4e20e30bd7fe607$var$call = Function.prototype.call;
$f4e20e30bd7fe607$exports = $2f783e7f9db6c573$exports ? $f4e20e30bd7fe607$var$call.bind($f4e20e30bd7fe607$var$call) : function() {
    return $f4e20e30bd7fe607$var$call.apply($f4e20e30bd7fe607$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $b0cbfea0da53c0c6$export$2d1720544b23b823;
"use strict";
var $b0cbfea0da53c0c6$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b0cbfea0da53c0c6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $b0cbfea0da53c0c6$var$NASHORN_BUG = $b0cbfea0da53c0c6$var$getOwnPropertyDescriptor && !$b0cbfea0da53c0c6$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$b0cbfea0da53c0c6$export$2d1720544b23b823 = $b0cbfea0da53c0c6$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $b0cbfea0da53c0c6$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $b0cbfea0da53c0c6$var$$propertyIsEnumerable;


var $581f1281e2d25822$exports = {};
"use strict";
$581f1281e2d25822$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $5d5e7d3212673f76$exports = {};
"use strict";
var $ccbede5470f09bf1$exports = {};
"use strict";
var $0921ab61236602a6$exports = {};
"use strict";

var $0921ab61236602a6$var$FunctionPrototype = Function.prototype;
var $0921ab61236602a6$var$call = $0921ab61236602a6$var$FunctionPrototype.call;
var $0921ab61236602a6$var$uncurryThisWithBind = $2f783e7f9db6c573$exports && $0921ab61236602a6$var$FunctionPrototype.bind.bind($0921ab61236602a6$var$call, $0921ab61236602a6$var$call);
$0921ab61236602a6$exports = $2f783e7f9db6c573$exports ? $0921ab61236602a6$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $0921ab61236602a6$var$call.apply(fn, arguments);
    };
};



var $167287b07fd6053f$exports = {};
"use strict";

var $167287b07fd6053f$var$toString = $0921ab61236602a6$exports({}.toString);
var $167287b07fd6053f$var$stringSlice = $0921ab61236602a6$exports("".slice);
$167287b07fd6053f$exports = function(it) {
    return $167287b07fd6053f$var$stringSlice($167287b07fd6053f$var$toString(it), 8, -1);
};


var $ccbede5470f09bf1$var$$Object = Object;
var $ccbede5470f09bf1$var$split = $0921ab61236602a6$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$ccbede5470f09bf1$exports = $3d081374f1421bdf$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$ccbede5470f09bf1$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $167287b07fd6053f$exports(it) === "String" ? $ccbede5470f09bf1$var$split(it, "") : $ccbede5470f09bf1$var$$Object(it);
} : $ccbede5470f09bf1$var$$Object;


var $cede68d0bab9b76a$exports = {};
"use strict";
var $baca1174ca74a0d3$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$baca1174ca74a0d3$exports = function(it) {
    return it === null || it === undefined;
};


var $cede68d0bab9b76a$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$cede68d0bab9b76a$exports = function(it) {
    if ($baca1174ca74a0d3$exports(it)) throw new $cede68d0bab9b76a$var$$TypeError("Can't call method on " + it);
    return it;
};


$5d5e7d3212673f76$exports = function(it) {
    return $ccbede5470f09bf1$exports($cede68d0bab9b76a$exports(it));
};


var $e7336dfa600cd580$exports = {};
"use strict";
var $7b7d8f787c3d26a1$exports = {};
"use strict";

var $b561dc2cbc8c8dc5$exports = {};
"use strict";
var $6e7763f81bc2c10c$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $6e7763f81bc2c10c$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$6e7763f81bc2c10c$exports = typeof $6e7763f81bc2c10c$var$documentAll == "undefined" && $6e7763f81bc2c10c$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $6e7763f81bc2c10c$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$b561dc2cbc8c8dc5$exports = function(it) {
    return typeof it == "object" ? it !== null : $6e7763f81bc2c10c$exports(it);
};


var $c43511b35294c425$exports = {};
"use strict";
var $3119fc1b69447c5b$exports = {};
"use strict";


var $3119fc1b69447c5b$var$aFunction = function(argument) {
    return $6e7763f81bc2c10c$exports(argument) ? argument : undefined;
};
$3119fc1b69447c5b$exports = function(namespace, method) {
    return arguments.length < 2 ? $3119fc1b69447c5b$var$aFunction($b1d7c5e53f116382$exports[namespace]) : $b1d7c5e53f116382$exports[namespace] && $b1d7c5e53f116382$exports[namespace][method];
};



var $5cc1c8753672252f$exports = {};
"use strict";

$5cc1c8753672252f$exports = $0921ab61236602a6$exports({}.isPrototypeOf);


var $d02106fc7e85a89a$exports = {};
"use strict";
var $9cb7f8da5092bc32$exports = {};
"use strict";
var $95d4009bc473cf63$exports = {};
"use strict";

var $5f06ddb97583150b$exports = {};
"use strict";

var $5f06ddb97583150b$var$navigator = $b1d7c5e53f116382$exports.navigator;
var $5f06ddb97583150b$var$userAgent = $5f06ddb97583150b$var$navigator && $5f06ddb97583150b$var$navigator.userAgent;
$5f06ddb97583150b$exports = $5f06ddb97583150b$var$userAgent ? String($5f06ddb97583150b$var$userAgent) : "";


var $95d4009bc473cf63$var$process = $b1d7c5e53f116382$exports.process;
var $95d4009bc473cf63$var$Deno = $b1d7c5e53f116382$exports.Deno;
var $95d4009bc473cf63$var$versions = $95d4009bc473cf63$var$process && $95d4009bc473cf63$var$process.versions || $95d4009bc473cf63$var$Deno && $95d4009bc473cf63$var$Deno.version;
var $95d4009bc473cf63$var$v8 = $95d4009bc473cf63$var$versions && $95d4009bc473cf63$var$versions.v8;
var $95d4009bc473cf63$var$match, $95d4009bc473cf63$var$version;
if ($95d4009bc473cf63$var$v8) {
    $95d4009bc473cf63$var$match = $95d4009bc473cf63$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $95d4009bc473cf63$var$version = $95d4009bc473cf63$var$match[0] > 0 && $95d4009bc473cf63$var$match[0] < 4 ? 1 : +($95d4009bc473cf63$var$match[0] + $95d4009bc473cf63$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$95d4009bc473cf63$var$version && $5f06ddb97583150b$exports) {
    $95d4009bc473cf63$var$match = $5f06ddb97583150b$exports.match(/Edge\/(\d+)/);
    if (!$95d4009bc473cf63$var$match || $95d4009bc473cf63$var$match[1] >= 74) {
        $95d4009bc473cf63$var$match = $5f06ddb97583150b$exports.match(/Chrome\/(\d+)/);
        if ($95d4009bc473cf63$var$match) $95d4009bc473cf63$var$version = +$95d4009bc473cf63$var$match[1];
    }
}
$95d4009bc473cf63$exports = $95d4009bc473cf63$var$version;




var $9cb7f8da5092bc32$var$$String = $b1d7c5e53f116382$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$9cb7f8da5092bc32$exports = !!Object.getOwnPropertySymbols && !$3d081374f1421bdf$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$9cb7f8da5092bc32$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $95d4009bc473cf63$exports && $95d4009bc473cf63$exports < 41;
});


$d02106fc7e85a89a$exports = $9cb7f8da5092bc32$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $c43511b35294c425$var$$Object = Object;
$c43511b35294c425$exports = $d02106fc7e85a89a$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $3119fc1b69447c5b$exports("Symbol");
    return $6e7763f81bc2c10c$exports($Symbol) && $5cc1c8753672252f$exports($Symbol.prototype, $c43511b35294c425$var$$Object(it));
};


var $01f4d421549051f1$exports = {};
"use strict";
var $c211b3e7372074ff$exports = {};
"use strict";

var $e36a3ffa5631b1a9$exports = {};
"use strict";
var $e36a3ffa5631b1a9$var$$String = String;
$e36a3ffa5631b1a9$exports = function(argument) {
    try {
        return $e36a3ffa5631b1a9$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $c211b3e7372074ff$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$c211b3e7372074ff$exports = function(argument) {
    if ($6e7763f81bc2c10c$exports(argument)) return argument;
    throw new $c211b3e7372074ff$var$$TypeError($e36a3ffa5631b1a9$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$01f4d421549051f1$exports = function(V, P) {
    var func = V[P];
    return $baca1174ca74a0d3$exports(func) ? undefined : $c211b3e7372074ff$exports(func);
};


var $1980631c4e47dc16$exports = {};
"use strict";



var $1980631c4e47dc16$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$1980631c4e47dc16$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6e7763f81bc2c10c$exports(fn = input.toString) && !$b561dc2cbc8c8dc5$exports(val = $f4e20e30bd7fe607$exports(fn, input))) return val;
    if ($6e7763f81bc2c10c$exports(fn = input.valueOf) && !$b561dc2cbc8c8dc5$exports(val = $f4e20e30bd7fe607$exports(fn, input))) return val;
    if (pref !== "string" && $6e7763f81bc2c10c$exports(fn = input.toString) && !$b561dc2cbc8c8dc5$exports(val = $f4e20e30bd7fe607$exports(fn, input))) return val;
    throw new $1980631c4e47dc16$var$$TypeError("Can't convert object to primitive value");
};


var $2ea0e6681cf40c4a$exports = {};
"use strict";

var $cf189b598c14e119$exports = {};
"use strict";
var $b79ce54156f38fe7$exports = {};
"use strict";
var $e3ad2e7b360de895$exports = {};
"use strict";
$e3ad2e7b360de895$exports = false;



var $c93164414b9a83e2$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $c93164414b9a83e2$var$defineProperty = Object.defineProperty;
$c93164414b9a83e2$exports = function(key, value) {
    try {
        $c93164414b9a83e2$var$defineProperty($b1d7c5e53f116382$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $b1d7c5e53f116382$exports[key] = value;
    }
    return value;
};


var $b79ce54156f38fe7$var$SHARED = "__core-js_shared__";
var $b79ce54156f38fe7$var$store = $b79ce54156f38fe7$exports = $b1d7c5e53f116382$exports[$b79ce54156f38fe7$var$SHARED] || $c93164414b9a83e2$exports($b79ce54156f38fe7$var$SHARED, {});
($b79ce54156f38fe7$var$store.versions || ($b79ce54156f38fe7$var$store.versions = [])).push({
    version: "3.39.0",
    mode: $e3ad2e7b360de895$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$cf189b598c14e119$exports = function(key, value) {
    return $b79ce54156f38fe7$exports[key] || ($b79ce54156f38fe7$exports[key] = value || {});
};


var $8b34244876eaafc4$exports = {};
"use strict";

var $70aeed8a9f00604a$exports = {};
"use strict";

var $70aeed8a9f00604a$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$70aeed8a9f00604a$exports = function(argument) {
    return $70aeed8a9f00604a$var$$Object($cede68d0bab9b76a$exports(argument));
};


var $8b34244876eaafc4$var$hasOwnProperty = $0921ab61236602a6$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$8b34244876eaafc4$exports = Object.hasOwn || function hasOwn(it, key) {
    return $8b34244876eaafc4$var$hasOwnProperty($70aeed8a9f00604a$exports(it), key);
};


var $389694c028778195$exports = {};
"use strict";

var $389694c028778195$var$id = 0;
var $389694c028778195$var$postfix = Math.random();
var $389694c028778195$var$toString = $0921ab61236602a6$exports(1.0.toString);
$389694c028778195$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $389694c028778195$var$toString(++$389694c028778195$var$id + $389694c028778195$var$postfix, 36);
};




var $2ea0e6681cf40c4a$var$Symbol = $b1d7c5e53f116382$exports.Symbol;
var $2ea0e6681cf40c4a$var$WellKnownSymbolsStore = $cf189b598c14e119$exports("wks");
var $2ea0e6681cf40c4a$var$createWellKnownSymbol = $d02106fc7e85a89a$exports ? $2ea0e6681cf40c4a$var$Symbol["for"] || $2ea0e6681cf40c4a$var$Symbol : $2ea0e6681cf40c4a$var$Symbol && $2ea0e6681cf40c4a$var$Symbol.withoutSetter || $389694c028778195$exports;
$2ea0e6681cf40c4a$exports = function(name) {
    if (!$8b34244876eaafc4$exports($2ea0e6681cf40c4a$var$WellKnownSymbolsStore, name)) $2ea0e6681cf40c4a$var$WellKnownSymbolsStore[name] = $9cb7f8da5092bc32$exports && $8b34244876eaafc4$exports($2ea0e6681cf40c4a$var$Symbol, name) ? $2ea0e6681cf40c4a$var$Symbol[name] : $2ea0e6681cf40c4a$var$createWellKnownSymbol("Symbol." + name);
    return $2ea0e6681cf40c4a$var$WellKnownSymbolsStore[name];
};


var $7b7d8f787c3d26a1$var$$TypeError = TypeError;
var $7b7d8f787c3d26a1$var$TO_PRIMITIVE = $2ea0e6681cf40c4a$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$7b7d8f787c3d26a1$exports = function(input, pref) {
    if (!$b561dc2cbc8c8dc5$exports(input) || $c43511b35294c425$exports(input)) return input;
    var exoticToPrim = $01f4d421549051f1$exports(input, $7b7d8f787c3d26a1$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $f4e20e30bd7fe607$exports(exoticToPrim, input, pref);
        if (!$b561dc2cbc8c8dc5$exports(result) || $c43511b35294c425$exports(result)) return result;
        throw new $7b7d8f787c3d26a1$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $1980631c4e47dc16$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$e7336dfa600cd580$exports = function(argument) {
    var key = $7b7d8f787c3d26a1$exports(argument, "string");
    return $c43511b35294c425$exports(key) ? key : key + "";
};



var $602d98bac5a92fba$exports = {};
"use strict";


var $ca5ea25b1e9a59dc$exports = {};
"use strict";


var $ca5ea25b1e9a59dc$var$document = $b1d7c5e53f116382$exports.document;
// typeof document.createElement is 'object' in old IE
var $ca5ea25b1e9a59dc$var$EXISTS = $b561dc2cbc8c8dc5$exports($ca5ea25b1e9a59dc$var$document) && $b561dc2cbc8c8dc5$exports($ca5ea25b1e9a59dc$var$document.createElement);
$ca5ea25b1e9a59dc$exports = function(it) {
    return $ca5ea25b1e9a59dc$var$EXISTS ? $ca5ea25b1e9a59dc$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$602d98bac5a92fba$exports = !$2b526490d9608540$exports && !$3d081374f1421bdf$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($ca5ea25b1e9a59dc$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c70a379edcf167c9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$c70a379edcf167c9$export$2d1720544b23b823 = $2b526490d9608540$exports ? $c70a379edcf167c9$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $5d5e7d3212673f76$exports(O);
    P = $e7336dfa600cd580$exports(P);
    if ($602d98bac5a92fba$exports) try {
        return $c70a379edcf167c9$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8b34244876eaafc4$exports(O, P)) return $581f1281e2d25822$exports(!$f4e20e30bd7fe607$exports($b0cbfea0da53c0c6$export$2d1720544b23b823, O, P), O[P]);
};


var $30d519aac5b45306$require$getOwnPropertyDescriptor = $c70a379edcf167c9$export$2d1720544b23b823;
var $a56870826dd0a5c7$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $02b8c36721c2aeab$export$2d1720544b23b823;
"use strict";


var $2a5425cf0324baa2$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$2a5425cf0324baa2$exports = $2b526490d9608540$exports && $3d081374f1421bdf$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $6be50eb62e6ff895$exports = {};
"use strict";

var $6be50eb62e6ff895$var$$String = String;
var $6be50eb62e6ff895$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$6be50eb62e6ff895$exports = function(argument) {
    if ($b561dc2cbc8c8dc5$exports(argument)) return argument;
    throw new $6be50eb62e6ff895$var$$TypeError($6be50eb62e6ff895$var$$String(argument) + " is not an object");
};



var $02b8c36721c2aeab$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $02b8c36721c2aeab$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $02b8c36721c2aeab$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $02b8c36721c2aeab$var$ENUMERABLE = "enumerable";
var $02b8c36721c2aeab$var$CONFIGURABLE = "configurable";
var $02b8c36721c2aeab$var$WRITABLE = "writable";
$02b8c36721c2aeab$export$2d1720544b23b823 = $2b526490d9608540$exports ? $2a5425cf0324baa2$exports ? function defineProperty(O, P, Attributes) {
    $6be50eb62e6ff895$exports(O);
    P = $e7336dfa600cd580$exports(P);
    $6be50eb62e6ff895$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $02b8c36721c2aeab$var$WRITABLE in Attributes && !Attributes[$02b8c36721c2aeab$var$WRITABLE]) {
        var current = $02b8c36721c2aeab$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$02b8c36721c2aeab$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $02b8c36721c2aeab$var$CONFIGURABLE in Attributes ? Attributes[$02b8c36721c2aeab$var$CONFIGURABLE] : current[$02b8c36721c2aeab$var$CONFIGURABLE],
                enumerable: $02b8c36721c2aeab$var$ENUMERABLE in Attributes ? Attributes[$02b8c36721c2aeab$var$ENUMERABLE] : current[$02b8c36721c2aeab$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $02b8c36721c2aeab$var$$defineProperty(O, P, Attributes);
} : $02b8c36721c2aeab$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $6be50eb62e6ff895$exports(O);
    P = $e7336dfa600cd580$exports(P);
    $6be50eb62e6ff895$exports(Attributes);
    if ($602d98bac5a92fba$exports) try {
        return $02b8c36721c2aeab$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $02b8c36721c2aeab$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$a56870826dd0a5c7$exports = $2b526490d9608540$exports ? function(object, key, value) {
    return $02b8c36721c2aeab$export$2d1720544b23b823(object, key, $581f1281e2d25822$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $417ec99404391476$exports = {};
"use strict";


var $c6ea9f3177a80bb0$exports = {};
"use strict";





var $b535703b96c2e13e$exports = {};
"use strict";


var $b535703b96c2e13e$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b535703b96c2e13e$var$getDescriptor = $2b526490d9608540$exports && Object.getOwnPropertyDescriptor;
var $b535703b96c2e13e$var$EXISTS = $8b34244876eaafc4$exports($b535703b96c2e13e$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $b535703b96c2e13e$var$PROPER = $b535703b96c2e13e$var$EXISTS && (function something() {}).name === "something";
var $b535703b96c2e13e$var$CONFIGURABLE = $b535703b96c2e13e$var$EXISTS && (!$2b526490d9608540$exports || $2b526490d9608540$exports && $b535703b96c2e13e$var$getDescriptor($b535703b96c2e13e$var$FunctionPrototype, "name").configurable);
$b535703b96c2e13e$exports = {
    EXISTS: $b535703b96c2e13e$var$EXISTS,
    PROPER: $b535703b96c2e13e$var$PROPER,
    CONFIGURABLE: $b535703b96c2e13e$var$CONFIGURABLE
};


var $c6ea9f3177a80bb0$require$CONFIGURABLE_FUNCTION_NAME = $b535703b96c2e13e$exports.CONFIGURABLE;
var $23cfe148ce03f637$exports = {};
"use strict";



var $23cfe148ce03f637$var$functionToString = $0921ab61236602a6$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6e7763f81bc2c10c$exports($b79ce54156f38fe7$exports.inspectSource)) $b79ce54156f38fe7$exports.inspectSource = function(it) {
    return $23cfe148ce03f637$var$functionToString(it);
};
$23cfe148ce03f637$exports = $b79ce54156f38fe7$exports.inspectSource;


var $a5df62242719ee4c$exports = {};
"use strict";
var $be58b7ebb8af73de$exports = {};
"use strict";


var $be58b7ebb8af73de$var$WeakMap = $b1d7c5e53f116382$exports.WeakMap;
$be58b7ebb8af73de$exports = $6e7763f81bc2c10c$exports($be58b7ebb8af73de$var$WeakMap) && /native code/.test(String($be58b7ebb8af73de$var$WeakMap));







var $1c5e8f8028108ec8$exports = {};
"use strict";


var $1c5e8f8028108ec8$var$keys = $cf189b598c14e119$exports("keys");
$1c5e8f8028108ec8$exports = function(key) {
    return $1c5e8f8028108ec8$var$keys[key] || ($1c5e8f8028108ec8$var$keys[key] = $389694c028778195$exports(key));
};


var $5eadc740ac9c4d75$exports = {};
"use strict";
$5eadc740ac9c4d75$exports = {};


var $a5df62242719ee4c$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $a5df62242719ee4c$var$TypeError = $b1d7c5e53f116382$exports.TypeError;
var $a5df62242719ee4c$var$WeakMap = $b1d7c5e53f116382$exports.WeakMap;
var $a5df62242719ee4c$var$set, $a5df62242719ee4c$var$get, $a5df62242719ee4c$var$has;
var $a5df62242719ee4c$var$enforce = function(it) {
    return $a5df62242719ee4c$var$has(it) ? $a5df62242719ee4c$var$get(it) : $a5df62242719ee4c$var$set(it, {});
};
var $a5df62242719ee4c$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$b561dc2cbc8c8dc5$exports(it) || (state = $a5df62242719ee4c$var$get(it)).type !== TYPE) throw new $a5df62242719ee4c$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($be58b7ebb8af73de$exports || $b79ce54156f38fe7$exports.state) {
    var $a5df62242719ee4c$var$store = $b79ce54156f38fe7$exports.state || ($b79ce54156f38fe7$exports.state = new $a5df62242719ee4c$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $a5df62242719ee4c$var$store.get = $a5df62242719ee4c$var$store.get;
    $a5df62242719ee4c$var$store.has = $a5df62242719ee4c$var$store.has;
    $a5df62242719ee4c$var$store.set = $a5df62242719ee4c$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $a5df62242719ee4c$var$set = function(it, metadata) {
        if ($a5df62242719ee4c$var$store.has(it)) throw new $a5df62242719ee4c$var$TypeError($a5df62242719ee4c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $a5df62242719ee4c$var$store.set(it, metadata);
        return metadata;
    };
    $a5df62242719ee4c$var$get = function(it) {
        return $a5df62242719ee4c$var$store.get(it) || {};
    };
    $a5df62242719ee4c$var$has = function(it) {
        return $a5df62242719ee4c$var$store.has(it);
    };
} else {
    var $a5df62242719ee4c$var$STATE = $1c5e8f8028108ec8$exports("state");
    $5eadc740ac9c4d75$exports[$a5df62242719ee4c$var$STATE] = true;
    $a5df62242719ee4c$var$set = function(it, metadata) {
        if ($8b34244876eaafc4$exports(it, $a5df62242719ee4c$var$STATE)) throw new $a5df62242719ee4c$var$TypeError($a5df62242719ee4c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $a56870826dd0a5c7$exports(it, $a5df62242719ee4c$var$STATE, metadata);
        return metadata;
    };
    $a5df62242719ee4c$var$get = function(it) {
        return $8b34244876eaafc4$exports(it, $a5df62242719ee4c$var$STATE) ? it[$a5df62242719ee4c$var$STATE] : {};
    };
    $a5df62242719ee4c$var$has = function(it) {
        return $8b34244876eaafc4$exports(it, $a5df62242719ee4c$var$STATE);
    };
}
$a5df62242719ee4c$exports = {
    set: $a5df62242719ee4c$var$set,
    get: $a5df62242719ee4c$var$get,
    has: $a5df62242719ee4c$var$has,
    enforce: $a5df62242719ee4c$var$enforce,
    getterFor: $a5df62242719ee4c$var$getterFor
};


var $c6ea9f3177a80bb0$var$enforceInternalState = $a5df62242719ee4c$exports.enforce;
var $c6ea9f3177a80bb0$var$getInternalState = $a5df62242719ee4c$exports.get;
var $c6ea9f3177a80bb0$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $c6ea9f3177a80bb0$var$defineProperty = Object.defineProperty;
var $c6ea9f3177a80bb0$var$stringSlice = $0921ab61236602a6$exports("".slice);
var $c6ea9f3177a80bb0$var$replace = $0921ab61236602a6$exports("".replace);
var $c6ea9f3177a80bb0$var$join = $0921ab61236602a6$exports([].join);
var $c6ea9f3177a80bb0$var$CONFIGURABLE_LENGTH = $2b526490d9608540$exports && !$3d081374f1421bdf$exports(function() {
    return $c6ea9f3177a80bb0$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $c6ea9f3177a80bb0$var$TEMPLATE = String(String).split("String");
var $c6ea9f3177a80bb0$var$makeBuiltIn = $c6ea9f3177a80bb0$exports = function(value, name, options) {
    if ($c6ea9f3177a80bb0$var$stringSlice($c6ea9f3177a80bb0$var$$String(name), 0, 7) === "Symbol(") name = "[" + $c6ea9f3177a80bb0$var$replace($c6ea9f3177a80bb0$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$8b34244876eaafc4$exports(value, "name") || $c6ea9f3177a80bb0$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($2b526490d9608540$exports) $c6ea9f3177a80bb0$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($c6ea9f3177a80bb0$var$CONFIGURABLE_LENGTH && options && $8b34244876eaafc4$exports(options, "arity") && value.length !== options.arity) $c6ea9f3177a80bb0$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $8b34244876eaafc4$exports(options, "constructor") && options.constructor) {
            if ($2b526490d9608540$exports) $c6ea9f3177a80bb0$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $c6ea9f3177a80bb0$var$enforceInternalState(value);
    if (!$8b34244876eaafc4$exports(state, "source")) state.source = $c6ea9f3177a80bb0$var$join($c6ea9f3177a80bb0$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $c6ea9f3177a80bb0$var$makeBuiltIn(function toString() {
    return $6e7763f81bc2c10c$exports(this) && $c6ea9f3177a80bb0$var$getInternalState(this).source || $23cfe148ce03f637$exports(this);
}, "toString");



$417ec99404391476$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($6e7763f81bc2c10c$exports(value)) $c6ea9f3177a80bb0$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $c93164414b9a83e2$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $02b8c36721c2aeab$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $737fd55f5d0dcf23$exports = {};
"use strict";

var $c720e3778fdb0afe$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $a530298eeb8c84e2$export$2d1720544b23b823;
"use strict";
var $e295b1ef23f64314$exports = {};
"use strict";



var $5a188d265ecb1acb$exports = {};
"use strict";

var $9a7b955c5c00e059$exports = {};
"use strict";
var $c95a0cf69d7c7b60$exports = {};
"use strict";
var $34a9015b83fbbcb8$exports = {};
"use strict";
var $34a9015b83fbbcb8$var$ceil = Math.ceil;
var $34a9015b83fbbcb8$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$34a9015b83fbbcb8$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $34a9015b83fbbcb8$var$floor : $34a9015b83fbbcb8$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$c95a0cf69d7c7b60$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $34a9015b83fbbcb8$exports(number);
};


var $9a7b955c5c00e059$var$max = Math.max;
var $9a7b955c5c00e059$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$9a7b955c5c00e059$exports = function(index, length) {
    var integer = $c95a0cf69d7c7b60$exports(index);
    return integer < 0 ? $9a7b955c5c00e059$var$max(integer + length, 0) : $9a7b955c5c00e059$var$min(integer, length);
};


var $97bedd9bd12f86d9$exports = {};
"use strict";
var $4b28d10bac2a7346$exports = {};
"use strict";

var $4b28d10bac2a7346$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4b28d10bac2a7346$exports = function(argument) {
    var len = $c95a0cf69d7c7b60$exports(argument);
    return len > 0 ? $4b28d10bac2a7346$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$97bedd9bd12f86d9$exports = function(obj) {
    return $4b28d10bac2a7346$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $5a188d265ecb1acb$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5d5e7d3212673f76$exports($this);
        var length = $97bedd9bd12f86d9$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $9a7b955c5c00e059$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$5a188d265ecb1acb$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5a188d265ecb1acb$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5a188d265ecb1acb$var$createMethod(false)
};


var $e295b1ef23f64314$require$indexOf = $5a188d265ecb1acb$exports.indexOf;

var $e295b1ef23f64314$var$push = $0921ab61236602a6$exports([].push);
$e295b1ef23f64314$exports = function(object, names) {
    var O = $5d5e7d3212673f76$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8b34244876eaafc4$exports($5eadc740ac9c4d75$exports, key) && $8b34244876eaafc4$exports(O, key) && $e295b1ef23f64314$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8b34244876eaafc4$exports(O, key = names[i++])) ~$e295b1ef23f64314$require$indexOf(result, key) || $e295b1ef23f64314$var$push(result, key);
    return result;
};


var $9bfa4f49725e80f9$exports = {};
"use strict";
// IE8- don't enum bug keys
$9bfa4f49725e80f9$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $a530298eeb8c84e2$var$hiddenKeys = $9bfa4f49725e80f9$exports.concat("length", "prototype");
$a530298eeb8c84e2$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $e295b1ef23f64314$exports(O, $a530298eeb8c84e2$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $67e3a621e1a4e8eb$export$2d1720544b23b823;
"use strict";
$67e3a621e1a4e8eb$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $c720e3778fdb0afe$var$concat = $0921ab61236602a6$exports([].concat);
// all object keys, includes non-enumerable and symbols
$c720e3778fdb0afe$exports = $3119fc1b69447c5b$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $a530298eeb8c84e2$export$2d1720544b23b823($6be50eb62e6ff895$exports(it));
    var getOwnPropertySymbols = $67e3a621e1a4e8eb$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $c720e3778fdb0afe$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$737fd55f5d0dcf23$exports = function(target, source, exceptions) {
    var keys = $c720e3778fdb0afe$exports(source);
    var defineProperty = $02b8c36721c2aeab$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $c70a379edcf167c9$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8b34244876eaafc4$exports(target, key) && !(exceptions && $8b34244876eaafc4$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $f2b1784d47449e49$exports = {};
"use strict";


var $f2b1784d47449e49$var$replacement = /#|\.prototype\./;
var $f2b1784d47449e49$var$isForced = function(feature, detection) {
    var value = $f2b1784d47449e49$var$data[$f2b1784d47449e49$var$normalize(feature)];
    return value === $f2b1784d47449e49$var$POLYFILL ? true : value === $f2b1784d47449e49$var$NATIVE ? false : $6e7763f81bc2c10c$exports(detection) ? $3d081374f1421bdf$exports(detection) : !!detection;
};
var $f2b1784d47449e49$var$normalize = $f2b1784d47449e49$var$isForced.normalize = function(string) {
    return String(string).replace($f2b1784d47449e49$var$replacement, ".").toLowerCase();
};
var $f2b1784d47449e49$var$data = $f2b1784d47449e49$var$isForced.data = {};
var $f2b1784d47449e49$var$NATIVE = $f2b1784d47449e49$var$isForced.NATIVE = "N";
var $f2b1784d47449e49$var$POLYFILL = $f2b1784d47449e49$var$isForced.POLYFILL = "P";
$f2b1784d47449e49$exports = $f2b1784d47449e49$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $30d519aac5b45306$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $b1d7c5e53f116382$exports;
    else if (STATIC) target = $b1d7c5e53f116382$exports[TARGET] || $c93164414b9a83e2$exports(TARGET, {});
    else target = $b1d7c5e53f116382$exports[TARGET] && $b1d7c5e53f116382$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $30d519aac5b45306$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $f2b1784d47449e49$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $737fd55f5d0dcf23$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $a56870826dd0a5c7$exports(sourceProperty, "sham", true);
        $417ec99404391476$exports(target, key, sourceProperty, options);
    }
};



var $3ea7e04d46b6ac59$exports = {};
"use strict";
var $22301953792fd44d$exports = {};
"use strict";



var $22301953792fd44d$var$userAgentStartsWith = function(string) {
    return $5f06ddb97583150b$exports.slice(0, string.length) === string;
};
$22301953792fd44d$exports = function() {
    if ($22301953792fd44d$var$userAgentStartsWith("Bun/")) return "BUN";
    if ($22301953792fd44d$var$userAgentStartsWith("Cloudflare-Workers")) return "CLOUDFLARE";
    if ($22301953792fd44d$var$userAgentStartsWith("Deno/")) return "DENO";
    if ($22301953792fd44d$var$userAgentStartsWith("Node.js/")) return "NODE";
    if ($b1d7c5e53f116382$exports.Bun && typeof Bun.version == "string") return "BUN";
    if ($b1d7c5e53f116382$exports.Deno && typeof Deno.version == "object") return "DENO";
    if ($167287b07fd6053f$exports($b1d7c5e53f116382$exports.process) === "process") return "NODE";
    if ($b1d7c5e53f116382$exports.window && $b1d7c5e53f116382$exports.document) return "BROWSER";
    return "REST";
}();


$3ea7e04d46b6ac59$exports = $22301953792fd44d$exports === "NODE";





var $79570b52ab311757$exports = {};
"use strict";
var $032e0cdd779077b8$exports = {};
"use strict";


$032e0cdd779077b8$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $0921ab61236602a6$exports($c211b3e7372074ff$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $eb8fefe62015bc3c$exports = {};
"use strict";
var $2322e1323b32617a$exports = {};
"use strict";

$2322e1323b32617a$exports = function(argument) {
    return $b561dc2cbc8c8dc5$exports(argument) || argument === null;
};


var $eb8fefe62015bc3c$var$$String = String;
var $eb8fefe62015bc3c$var$$TypeError = TypeError;
$eb8fefe62015bc3c$exports = function(argument) {
    if ($2322e1323b32617a$exports(argument)) return argument;
    throw new $eb8fefe62015bc3c$var$$TypeError("Can't set " + $eb8fefe62015bc3c$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$79570b52ab311757$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $032e0cdd779077b8$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $cede68d0bab9b76a$exports(O);
        $eb8fefe62015bc3c$exports(proto);
        if (!$b561dc2cbc8c8dc5$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


var $345cd5ffb3d61dae$exports = {};
"use strict";

var $345cd5ffb3d61dae$require$defineProperty = $02b8c36721c2aeab$export$2d1720544b23b823;


var $345cd5ffb3d61dae$var$TO_STRING_TAG = $2ea0e6681cf40c4a$exports("toStringTag");
$345cd5ffb3d61dae$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$8b34244876eaafc4$exports(target, $345cd5ffb3d61dae$var$TO_STRING_TAG)) $345cd5ffb3d61dae$require$defineProperty(target, $345cd5ffb3d61dae$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $383925a3fe31c020$exports = {};
"use strict";

var $298299461f79038e$exports = {};
"use strict";


$298299461f79038e$exports = function(target, name, descriptor) {
    if (descriptor.get) $c6ea9f3177a80bb0$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $c6ea9f3177a80bb0$exports(descriptor.set, name, {
        setter: true
    });
    return $02b8c36721c2aeab$export$2d1720544b23b823(target, name, descriptor);
};




var $383925a3fe31c020$var$SPECIES = $2ea0e6681cf40c4a$exports("species");
$383925a3fe31c020$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $3119fc1b69447c5b$exports(CONSTRUCTOR_NAME);
    if ($2b526490d9608540$exports && Constructor && !Constructor[$383925a3fe31c020$var$SPECIES]) $298299461f79038e$exports(Constructor, $383925a3fe31c020$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};





var $fb18d7eceb1d8579$exports = {};
"use strict";

var $fb18d7eceb1d8579$var$$TypeError = TypeError;
$fb18d7eceb1d8579$exports = function(it, Prototype) {
    if ($5cc1c8753672252f$exports(Prototype, it)) return it;
    throw new $fb18d7eceb1d8579$var$$TypeError("Incorrect invocation");
};


var $871e1cb28a209c65$exports = {};
"use strict";

var $7bf12a9dfc975d71$exports = {};
"use strict";
var $11a3f39cae0b72bd$exports = {};
"use strict";



var $dc8c1109ce58ee6d$exports = {};
"use strict";
var $11540e6f6124a1f2$exports = {};
"use strict";

var $11540e6f6124a1f2$var$TO_STRING_TAG = $2ea0e6681cf40c4a$exports("toStringTag");
var $11540e6f6124a1f2$var$test = {};
$11540e6f6124a1f2$var$test[$11540e6f6124a1f2$var$TO_STRING_TAG] = "z";
$11540e6f6124a1f2$exports = String($11540e6f6124a1f2$var$test) === "[object z]";





var $dc8c1109ce58ee6d$var$TO_STRING_TAG = $2ea0e6681cf40c4a$exports("toStringTag");
var $dc8c1109ce58ee6d$var$$Object = Object;
// ES3 wrong here
var $dc8c1109ce58ee6d$var$CORRECT_ARGUMENTS = $167287b07fd6053f$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $dc8c1109ce58ee6d$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$dc8c1109ce58ee6d$exports = $11540e6f6124a1f2$exports ? $167287b07fd6053f$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $dc8c1109ce58ee6d$var$tryGet(O = $dc8c1109ce58ee6d$var$$Object(it), $dc8c1109ce58ee6d$var$TO_STRING_TAG)) == "string" ? tag : $dc8c1109ce58ee6d$var$CORRECT_ARGUMENTS ? $167287b07fd6053f$exports(O) : (result = $167287b07fd6053f$exports(O)) === "Object" && $6e7763f81bc2c10c$exports(O.callee) ? "Arguments" : result;
};




var $11a3f39cae0b72bd$var$noop = function() {};
var $11a3f39cae0b72bd$var$construct = $3119fc1b69447c5b$exports("Reflect", "construct");
var $11a3f39cae0b72bd$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $11a3f39cae0b72bd$var$exec = $0921ab61236602a6$exports($11a3f39cae0b72bd$var$constructorRegExp.exec);
var $11a3f39cae0b72bd$var$INCORRECT_TO_STRING = !$11a3f39cae0b72bd$var$constructorRegExp.test($11a3f39cae0b72bd$var$noop);
var $11a3f39cae0b72bd$var$isConstructorModern = function isConstructor(argument) {
    if (!$6e7763f81bc2c10c$exports(argument)) return false;
    try {
        $11a3f39cae0b72bd$var$construct($11a3f39cae0b72bd$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $11a3f39cae0b72bd$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$6e7763f81bc2c10c$exports(argument)) return false;
    switch($dc8c1109ce58ee6d$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $11a3f39cae0b72bd$var$INCORRECT_TO_STRING || !!$11a3f39cae0b72bd$var$exec($11a3f39cae0b72bd$var$constructorRegExp, $23cfe148ce03f637$exports(argument));
    } catch (error) {
        return true;
    }
};
$11a3f39cae0b72bd$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$11a3f39cae0b72bd$exports = !$11a3f39cae0b72bd$var$construct || $3d081374f1421bdf$exports(function() {
    var called;
    return $11a3f39cae0b72bd$var$isConstructorModern($11a3f39cae0b72bd$var$isConstructorModern.call) || !$11a3f39cae0b72bd$var$isConstructorModern(Object) || !$11a3f39cae0b72bd$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $11a3f39cae0b72bd$var$isConstructorLegacy : $11a3f39cae0b72bd$var$isConstructorModern;



var $7bf12a9dfc975d71$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$7bf12a9dfc975d71$exports = function(argument) {
    if ($11a3f39cae0b72bd$exports(argument)) return argument;
    throw new $7bf12a9dfc975d71$var$$TypeError($e36a3ffa5631b1a9$exports(argument) + " is not a constructor");
};




var $871e1cb28a209c65$var$SPECIES = $2ea0e6681cf40c4a$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$871e1cb28a209c65$exports = function(O, defaultConstructor) {
    var C = $6be50eb62e6ff895$exports(O).constructor;
    var S;
    return C === undefined || $baca1174ca74a0d3$exports(S = $6be50eb62e6ff895$exports(C)[$871e1cb28a209c65$var$SPECIES]) ? defaultConstructor : $7bf12a9dfc975d71$exports(S);
};


var $971a8fd40cf4793b$exports = {};
"use strict";

var $8c364d4bd4fc3321$exports = {};
"use strict";

var $8c364d4bd4fc3321$var$FunctionPrototype = Function.prototype;
var $8c364d4bd4fc3321$var$apply = $8c364d4bd4fc3321$var$FunctionPrototype.apply;
var $8c364d4bd4fc3321$var$call = $8c364d4bd4fc3321$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$8c364d4bd4fc3321$exports = typeof Reflect == "object" && Reflect.apply || ($2f783e7f9db6c573$exports ? $8c364d4bd4fc3321$var$call.bind($8c364d4bd4fc3321$var$apply) : function() {
    return $8c364d4bd4fc3321$var$call.apply($8c364d4bd4fc3321$var$apply, arguments);
});


var $42108289353d1788$exports = {};
"use strict";
var $f5ccbdc51a6d7ae9$exports = {};
"use strict";


$f5ccbdc51a6d7ae9$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($167287b07fd6053f$exports(fn) === "Function") return $0921ab61236602a6$exports(fn);
};




var $42108289353d1788$var$bind = $f5ccbdc51a6d7ae9$exports($f5ccbdc51a6d7ae9$exports.bind);
// optional / simple context binding
$42108289353d1788$exports = function(fn, that) {
    $c211b3e7372074ff$exports(fn);
    return that === undefined ? fn : $2f783e7f9db6c573$exports ? $42108289353d1788$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $a7ccdb95fb24ee55$exports = {};
"use strict";

$a7ccdb95fb24ee55$exports = $3119fc1b69447c5b$exports("document", "documentElement");


var $164557606eddb50d$exports = {};
"use strict";

$164557606eddb50d$exports = $0921ab61236602a6$exports([].slice);



var $d1773ad8045c1a3f$exports = {};
"use strict";
var $d1773ad8045c1a3f$var$$TypeError = TypeError;
$d1773ad8045c1a3f$exports = function(passed, required) {
    if (passed < required) throw new $d1773ad8045c1a3f$var$$TypeError("Not enough arguments");
    return passed;
};


var $8683828c9c9d6d9b$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$8683828c9c9d6d9b$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($5f06ddb97583150b$exports);



var $971a8fd40cf4793b$var$set = $b1d7c5e53f116382$exports.setImmediate;
var $971a8fd40cf4793b$var$clear = $b1d7c5e53f116382$exports.clearImmediate;
var $971a8fd40cf4793b$var$process = $b1d7c5e53f116382$exports.process;
var $971a8fd40cf4793b$var$Dispatch = $b1d7c5e53f116382$exports.Dispatch;
var $971a8fd40cf4793b$var$Function = $b1d7c5e53f116382$exports.Function;
var $971a8fd40cf4793b$var$MessageChannel = $b1d7c5e53f116382$exports.MessageChannel;
var $971a8fd40cf4793b$var$String = $b1d7c5e53f116382$exports.String;
var $971a8fd40cf4793b$var$counter = 0;
var $971a8fd40cf4793b$var$queue = {};
var $971a8fd40cf4793b$var$ONREADYSTATECHANGE = "onreadystatechange";
var $971a8fd40cf4793b$var$$location, $971a8fd40cf4793b$var$defer, $971a8fd40cf4793b$var$channel, $971a8fd40cf4793b$var$port;
$3d081374f1421bdf$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $971a8fd40cf4793b$var$$location = $b1d7c5e53f116382$exports.location;
});
var $971a8fd40cf4793b$var$run = function(id) {
    if ($8b34244876eaafc4$exports($971a8fd40cf4793b$var$queue, id)) {
        var fn = $971a8fd40cf4793b$var$queue[id];
        delete $971a8fd40cf4793b$var$queue[id];
        fn();
    }
};
var $971a8fd40cf4793b$var$runner = function(id) {
    return function() {
        $971a8fd40cf4793b$var$run(id);
    };
};
var $971a8fd40cf4793b$var$eventListener = function(event) {
    $971a8fd40cf4793b$var$run(event.data);
};
var $971a8fd40cf4793b$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $b1d7c5e53f116382$exports.postMessage($971a8fd40cf4793b$var$String(id), $971a8fd40cf4793b$var$$location.protocol + "//" + $971a8fd40cf4793b$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$971a8fd40cf4793b$var$set || !$971a8fd40cf4793b$var$clear) {
    $971a8fd40cf4793b$var$set = function setImmediate(handler) {
        $d1773ad8045c1a3f$exports(arguments.length, 1);
        var fn = $6e7763f81bc2c10c$exports(handler) ? handler : $971a8fd40cf4793b$var$Function(handler);
        var args = $164557606eddb50d$exports(arguments, 1);
        $971a8fd40cf4793b$var$queue[++$971a8fd40cf4793b$var$counter] = function() {
            $8c364d4bd4fc3321$exports(fn, undefined, args);
        };
        $971a8fd40cf4793b$var$defer($971a8fd40cf4793b$var$counter);
        return $971a8fd40cf4793b$var$counter;
    };
    $971a8fd40cf4793b$var$clear = function clearImmediate(id) {
        delete $971a8fd40cf4793b$var$queue[id];
    };
    // Node.js 0.8-
    if ($3ea7e04d46b6ac59$exports) $971a8fd40cf4793b$var$defer = function(id) {
        $971a8fd40cf4793b$var$process.nextTick($971a8fd40cf4793b$var$runner(id));
    };
    else if ($971a8fd40cf4793b$var$Dispatch && $971a8fd40cf4793b$var$Dispatch.now) $971a8fd40cf4793b$var$defer = function(id) {
        $971a8fd40cf4793b$var$Dispatch.now($971a8fd40cf4793b$var$runner(id));
    };
    else if ($971a8fd40cf4793b$var$MessageChannel && !$8683828c9c9d6d9b$exports) {
        $971a8fd40cf4793b$var$channel = new $971a8fd40cf4793b$var$MessageChannel();
        $971a8fd40cf4793b$var$port = $971a8fd40cf4793b$var$channel.port2;
        $971a8fd40cf4793b$var$channel.port1.onmessage = $971a8fd40cf4793b$var$eventListener;
        $971a8fd40cf4793b$var$defer = $42108289353d1788$exports($971a8fd40cf4793b$var$port.postMessage, $971a8fd40cf4793b$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($b1d7c5e53f116382$exports.addEventListener && $6e7763f81bc2c10c$exports($b1d7c5e53f116382$exports.postMessage) && !$b1d7c5e53f116382$exports.importScripts && $971a8fd40cf4793b$var$$location && $971a8fd40cf4793b$var$$location.protocol !== "file:" && !$3d081374f1421bdf$exports($971a8fd40cf4793b$var$globalPostMessageDefer)) {
        $971a8fd40cf4793b$var$defer = $971a8fd40cf4793b$var$globalPostMessageDefer;
        $b1d7c5e53f116382$exports.addEventListener("message", $971a8fd40cf4793b$var$eventListener, false);
    // IE8-
    } else if ($971a8fd40cf4793b$var$ONREADYSTATECHANGE in $ca5ea25b1e9a59dc$exports("script")) $971a8fd40cf4793b$var$defer = function(id) {
        $a7ccdb95fb24ee55$exports.appendChild($ca5ea25b1e9a59dc$exports("script"))[$971a8fd40cf4793b$var$ONREADYSTATECHANGE] = function() {
            $a7ccdb95fb24ee55$exports.removeChild(this);
            $971a8fd40cf4793b$var$run(id);
        };
    };
    else $971a8fd40cf4793b$var$defer = function(id) {
        setTimeout($971a8fd40cf4793b$var$runner(id), 0);
    };
}
$971a8fd40cf4793b$exports = {
    set: $971a8fd40cf4793b$var$set,
    clear: $971a8fd40cf4793b$var$clear
};


var $7750fff4a0191cff$require$task = $971a8fd40cf4793b$exports.set;
var $8250de4e4fa1404a$exports = {};
"use strict";

var $164d789a27c1c0c9$exports = {};
"use strict";


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $164d789a27c1c0c9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
$164d789a27c1c0c9$exports = function(name) {
    if (!$2b526490d9608540$exports) return $b1d7c5e53f116382$exports[name];
    var descriptor = $164d789a27c1c0c9$var$getOwnPropertyDescriptor($b1d7c5e53f116382$exports, name);
    return descriptor && descriptor.value;
};




var $8250de4e4fa1404a$require$macrotask = $971a8fd40cf4793b$exports.set;
var $b9357d7967629ff7$exports = {};
"use strict";
var $b9357d7967629ff7$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$b9357d7967629ff7$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$b9357d7967629ff7$exports = $b9357d7967629ff7$var$Queue;



var $7057401b8aa97ad6$exports = {};
"use strict";

$7057401b8aa97ad6$exports = /ipad|iphone|ipod/i.test($5f06ddb97583150b$exports) && typeof Pebble != "undefined";


var $01cee6f2d11dcddb$exports = {};
"use strict";

$01cee6f2d11dcddb$exports = /web0s(?!.*chrome)/i.test($5f06ddb97583150b$exports);



var $8250de4e4fa1404a$var$MutationObserver = $b1d7c5e53f116382$exports.MutationObserver || $b1d7c5e53f116382$exports.WebKitMutationObserver;
var $8250de4e4fa1404a$var$document = $b1d7c5e53f116382$exports.document;
var $8250de4e4fa1404a$var$process = $b1d7c5e53f116382$exports.process;
var $8250de4e4fa1404a$var$Promise = $b1d7c5e53f116382$exports.Promise;
var $8250de4e4fa1404a$var$microtask = $164d789a27c1c0c9$exports("queueMicrotask");
var $8250de4e4fa1404a$var$notify, $8250de4e4fa1404a$var$toggle, $8250de4e4fa1404a$var$node, $8250de4e4fa1404a$var$promise, $8250de4e4fa1404a$var$then;
// modern engines have queueMicrotask method
if (!$8250de4e4fa1404a$var$microtask) {
    var $8250de4e4fa1404a$var$queue = new $b9357d7967629ff7$exports();
    var $8250de4e4fa1404a$var$flush = function() {
        var parent, fn;
        if ($3ea7e04d46b6ac59$exports && (parent = $8250de4e4fa1404a$var$process.domain)) parent.exit();
        while(fn = $8250de4e4fa1404a$var$queue.get())try {
            fn();
        } catch (error) {
            if ($8250de4e4fa1404a$var$queue.head) $8250de4e4fa1404a$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$8683828c9c9d6d9b$exports && !$3ea7e04d46b6ac59$exports && !$01cee6f2d11dcddb$exports && $8250de4e4fa1404a$var$MutationObserver && $8250de4e4fa1404a$var$document) {
        $8250de4e4fa1404a$var$toggle = true;
        $8250de4e4fa1404a$var$node = $8250de4e4fa1404a$var$document.createTextNode("");
        new $8250de4e4fa1404a$var$MutationObserver($8250de4e4fa1404a$var$flush).observe($8250de4e4fa1404a$var$node, {
            characterData: true
        });
        $8250de4e4fa1404a$var$notify = function() {
            $8250de4e4fa1404a$var$node.data = $8250de4e4fa1404a$var$toggle = !$8250de4e4fa1404a$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$7057401b8aa97ad6$exports && $8250de4e4fa1404a$var$Promise && $8250de4e4fa1404a$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $8250de4e4fa1404a$var$promise = $8250de4e4fa1404a$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $8250de4e4fa1404a$var$promise.constructor = $8250de4e4fa1404a$var$Promise;
        $8250de4e4fa1404a$var$then = $42108289353d1788$exports($8250de4e4fa1404a$var$promise.then, $8250de4e4fa1404a$var$promise);
        $8250de4e4fa1404a$var$notify = function() {
            $8250de4e4fa1404a$var$then($8250de4e4fa1404a$var$flush);
        };
    // Node.js without promises
    } else if ($3ea7e04d46b6ac59$exports) $8250de4e4fa1404a$var$notify = function() {
        $8250de4e4fa1404a$var$process.nextTick($8250de4e4fa1404a$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $8250de4e4fa1404a$require$macrotask = $42108289353d1788$exports($8250de4e4fa1404a$require$macrotask, $b1d7c5e53f116382$exports);
        $8250de4e4fa1404a$var$notify = function() {
            $8250de4e4fa1404a$require$macrotask($8250de4e4fa1404a$var$flush);
        };
    }
    $8250de4e4fa1404a$var$microtask = function(fn) {
        if (!$8250de4e4fa1404a$var$queue.head) $8250de4e4fa1404a$var$notify();
        $8250de4e4fa1404a$var$queue.add(fn);
    };
}
$8250de4e4fa1404a$exports = $8250de4e4fa1404a$var$microtask;


var $9e1eac0981a3d5cd$exports = {};
"use strict";
$9e1eac0981a3d5cd$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $1254b1029883cc7e$exports = {};
"use strict";
$1254b1029883cc7e$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $7341a0934a816020$exports = {};
"use strict";

$7341a0934a816020$exports = $b1d7c5e53f116382$exports.Promise;


var $ac714721992fd2c9$exports = {};
"use strict";









var $ac714721992fd2c9$var$NativePromisePrototype = $7341a0934a816020$exports && $7341a0934a816020$exports.prototype;
var $ac714721992fd2c9$var$SPECIES = $2ea0e6681cf40c4a$exports("species");
var $ac714721992fd2c9$var$SUBCLASSING = false;
var $ac714721992fd2c9$var$NATIVE_PROMISE_REJECTION_EVENT = $6e7763f81bc2c10c$exports($b1d7c5e53f116382$exports.PromiseRejectionEvent);
var $ac714721992fd2c9$var$FORCED_PROMISE_CONSTRUCTOR = $f2b1784d47449e49$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $23cfe148ce03f637$exports($7341a0934a816020$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($7341a0934a816020$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $95d4009bc473cf63$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($e3ad2e7b360de895$exports && !($ac714721992fd2c9$var$NativePromisePrototype["catch"] && $ac714721992fd2c9$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$95d4009bc473cf63$exports || $95d4009bc473cf63$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $7341a0934a816020$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$ac714721992fd2c9$var$SPECIES] = FakePromise;
        $ac714721992fd2c9$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$ac714721992fd2c9$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($22301953792fd44d$exports === "BROWSER" || $22301953792fd44d$exports === "DENO") && !$ac714721992fd2c9$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$ac714721992fd2c9$exports = {
    CONSTRUCTOR: $ac714721992fd2c9$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $ac714721992fd2c9$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $ac714721992fd2c9$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $d9b538a4fb8633ed$export$2d1720544b23b823;
"use strict";

var $d9b538a4fb8633ed$var$$TypeError = TypeError;
var $d9b538a4fb8633ed$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $d9b538a4fb8633ed$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $c211b3e7372074ff$exports(resolve);
    this.reject = $c211b3e7372074ff$exports(reject);
};
$d9b538a4fb8633ed$export$2d1720544b23b823 = function(C) {
    return new $d9b538a4fb8633ed$var$PromiseCapability(C);
};


var $7750fff4a0191cff$var$PROMISE = "Promise";
var $7750fff4a0191cff$var$FORCED_PROMISE_CONSTRUCTOR = $ac714721992fd2c9$exports.CONSTRUCTOR;
var $7750fff4a0191cff$var$NATIVE_PROMISE_REJECTION_EVENT = $ac714721992fd2c9$exports.REJECTION_EVENT;
var $7750fff4a0191cff$var$NATIVE_PROMISE_SUBCLASSING = $ac714721992fd2c9$exports.SUBCLASSING;
var $7750fff4a0191cff$var$getInternalPromiseState = $a5df62242719ee4c$exports.getterFor($7750fff4a0191cff$var$PROMISE);
var $7750fff4a0191cff$var$setInternalState = $a5df62242719ee4c$exports.set;
var $7750fff4a0191cff$var$NativePromisePrototype = $7341a0934a816020$exports && $7341a0934a816020$exports.prototype;
var $7750fff4a0191cff$var$PromiseConstructor = $7341a0934a816020$exports;
var $7750fff4a0191cff$var$PromisePrototype = $7750fff4a0191cff$var$NativePromisePrototype;
var $7750fff4a0191cff$var$TypeError = $b1d7c5e53f116382$exports.TypeError;
var $7750fff4a0191cff$var$document = $b1d7c5e53f116382$exports.document;
var $7750fff4a0191cff$var$process = $b1d7c5e53f116382$exports.process;
var $7750fff4a0191cff$var$newPromiseCapability = $d9b538a4fb8633ed$export$2d1720544b23b823;
var $7750fff4a0191cff$var$newGenericPromiseCapability = $7750fff4a0191cff$var$newPromiseCapability;
var $7750fff4a0191cff$var$DISPATCH_EVENT = !!($7750fff4a0191cff$var$document && $7750fff4a0191cff$var$document.createEvent && $b1d7c5e53f116382$exports.dispatchEvent);
var $7750fff4a0191cff$var$UNHANDLED_REJECTION = "unhandledrejection";
var $7750fff4a0191cff$var$REJECTION_HANDLED = "rejectionhandled";
var $7750fff4a0191cff$var$PENDING = 0;
var $7750fff4a0191cff$var$FULFILLED = 1;
var $7750fff4a0191cff$var$REJECTED = 2;
var $7750fff4a0191cff$var$HANDLED = 1;
var $7750fff4a0191cff$var$UNHANDLED = 2;
var $7750fff4a0191cff$var$Internal, $7750fff4a0191cff$var$OwnPromiseCapability, $7750fff4a0191cff$var$PromiseWrapper, $7750fff4a0191cff$var$nativeThen;
// helpers
var $7750fff4a0191cff$var$isThenable = function(it) {
    var then;
    return $b561dc2cbc8c8dc5$exports(it) && $6e7763f81bc2c10c$exports(then = it.then) ? then : false;
};
var $7750fff4a0191cff$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $7750fff4a0191cff$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $7750fff4a0191cff$var$UNHANDLED) $7750fff4a0191cff$var$onHandleUnhandled(state);
                state.rejection = $7750fff4a0191cff$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $7750fff4a0191cff$var$TypeError("Promise-chain cycle"));
            else if (then = $7750fff4a0191cff$var$isThenable(result)) $f4e20e30bd7fe607$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $7750fff4a0191cff$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $8250de4e4fa1404a$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$7750fff4a0191cff$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $7750fff4a0191cff$var$onUnhandled(state);
    });
};
var $7750fff4a0191cff$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($7750fff4a0191cff$var$DISPATCH_EVENT) {
        event = $7750fff4a0191cff$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $b1d7c5e53f116382$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$7750fff4a0191cff$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $b1d7c5e53f116382$exports["on" + name])) handler(event);
    else if (name === $7750fff4a0191cff$var$UNHANDLED_REJECTION) $9e1eac0981a3d5cd$exports("Unhandled promise rejection", reason);
};
var $7750fff4a0191cff$var$onUnhandled = function(state) {
    $f4e20e30bd7fe607$exports($7750fff4a0191cff$require$task, $b1d7c5e53f116382$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $7750fff4a0191cff$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $1254b1029883cc7e$exports(function() {
                if ($3ea7e04d46b6ac59$exports) $7750fff4a0191cff$var$process.emit("unhandledRejection", value, promise);
                else $7750fff4a0191cff$var$dispatchEvent($7750fff4a0191cff$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $3ea7e04d46b6ac59$exports || $7750fff4a0191cff$var$isUnhandled(state) ? $7750fff4a0191cff$var$UNHANDLED : $7750fff4a0191cff$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $7750fff4a0191cff$var$isUnhandled = function(state) {
    return state.rejection !== $7750fff4a0191cff$var$HANDLED && !state.parent;
};
var $7750fff4a0191cff$var$onHandleUnhandled = function(state) {
    $f4e20e30bd7fe607$exports($7750fff4a0191cff$require$task, $b1d7c5e53f116382$exports, function() {
        var promise = state.facade;
        if ($3ea7e04d46b6ac59$exports) $7750fff4a0191cff$var$process.emit("rejectionHandled", promise);
        else $7750fff4a0191cff$var$dispatchEvent($7750fff4a0191cff$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $7750fff4a0191cff$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $7750fff4a0191cff$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $7750fff4a0191cff$var$REJECTED;
    $7750fff4a0191cff$var$notify(state, true);
};
var $7750fff4a0191cff$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $7750fff4a0191cff$var$TypeError("Promise can't be resolved itself");
        var then = $7750fff4a0191cff$var$isThenable(value);
        if (then) $8250de4e4fa1404a$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $f4e20e30bd7fe607$exports(then, value, $7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalResolve, wrapper, state), $7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalReject, wrapper, state));
            } catch (error) {
                $7750fff4a0191cff$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $7750fff4a0191cff$var$FULFILLED;
            $7750fff4a0191cff$var$notify(state, false);
        }
    } catch (error) {
        $7750fff4a0191cff$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($7750fff4a0191cff$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $7750fff4a0191cff$var$PromiseConstructor = function Promise(executor) {
        $fb18d7eceb1d8579$exports(this, $7750fff4a0191cff$var$PromisePrototype);
        $c211b3e7372074ff$exports(executor);
        $f4e20e30bd7fe607$exports($7750fff4a0191cff$var$Internal, this);
        var state = $7750fff4a0191cff$var$getInternalPromiseState(this);
        try {
            executor($7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalResolve, state), $7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalReject, state));
        } catch (error) {
            $7750fff4a0191cff$var$internalReject(state, error);
        }
    };
    $7750fff4a0191cff$var$PromisePrototype = $7750fff4a0191cff$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $7750fff4a0191cff$var$Internal = function Promise(executor) {
        $7750fff4a0191cff$var$setInternalState(this, {
            type: $7750fff4a0191cff$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $b9357d7967629ff7$exports(),
            rejection: false,
            state: $7750fff4a0191cff$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $7750fff4a0191cff$var$Internal.prototype = $417ec99404391476$exports($7750fff4a0191cff$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $7750fff4a0191cff$var$getInternalPromiseState(this);
        var reaction = $7750fff4a0191cff$var$newPromiseCapability($871e1cb28a209c65$exports(this, $7750fff4a0191cff$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $6e7763f81bc2c10c$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $6e7763f81bc2c10c$exports(onRejected) && onRejected;
        reaction.domain = $3ea7e04d46b6ac59$exports ? $7750fff4a0191cff$var$process.domain : undefined;
        if (state.state === $7750fff4a0191cff$var$PENDING) state.reactions.add(reaction);
        else $8250de4e4fa1404a$exports(function() {
            $7750fff4a0191cff$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $7750fff4a0191cff$var$OwnPromiseCapability = function() {
        var promise = new $7750fff4a0191cff$var$Internal();
        var state = $7750fff4a0191cff$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalResolve, state);
        this.reject = $7750fff4a0191cff$var$bind($7750fff4a0191cff$var$internalReject, state);
    };
    $d9b538a4fb8633ed$export$2d1720544b23b823 = $7750fff4a0191cff$var$newPromiseCapability = function(C) {
        return C === $7750fff4a0191cff$var$PromiseConstructor || C === $7750fff4a0191cff$var$PromiseWrapper ? new $7750fff4a0191cff$var$OwnPromiseCapability(C) : $7750fff4a0191cff$var$newGenericPromiseCapability(C);
    };
    if (!$e3ad2e7b360de895$exports && $6e7763f81bc2c10c$exports($7341a0934a816020$exports) && $7750fff4a0191cff$var$NativePromisePrototype !== Object.prototype) {
        $7750fff4a0191cff$var$nativeThen = $7750fff4a0191cff$var$NativePromisePrototype.then;
        if (!$7750fff4a0191cff$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $417ec99404391476$exports($7750fff4a0191cff$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $7750fff4a0191cff$var$PromiseConstructor(function(resolve, reject) {
                $f4e20e30bd7fe607$exports($7750fff4a0191cff$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $7750fff4a0191cff$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($79570b52ab311757$exports) $79570b52ab311757$exports($7750fff4a0191cff$var$NativePromisePrototype, $7750fff4a0191cff$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$30d519aac5b45306$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $7750fff4a0191cff$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $7750fff4a0191cff$var$PromiseConstructor
});
$345cd5ffb3d61dae$exports($7750fff4a0191cff$var$PromiseConstructor, $7750fff4a0191cff$var$PROMISE, false, true);
$383925a3fe31c020$exports($7750fff4a0191cff$var$PROMISE);


"use strict";





var $5efd5ec88fefd0a1$exports = {};
"use strict";




var $552590d3bbe6d310$exports = {};
"use strict";

var $793fcd658a874707$exports = {};
"use strict";
$793fcd658a874707$exports = {};


var $552590d3bbe6d310$var$ITERATOR = $2ea0e6681cf40c4a$exports("iterator");
var $552590d3bbe6d310$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$552590d3bbe6d310$exports = function(it) {
    return it !== undefined && ($793fcd658a874707$exports.Array === it || $552590d3bbe6d310$var$ArrayPrototype[$552590d3bbe6d310$var$ITERATOR] === it);
};




var $b8b71f1fccd0013e$exports = {};
"use strict";




var $a6409b85f08d1e69$exports = {};
"use strict";





var $a6409b85f08d1e69$var$ITERATOR = $2ea0e6681cf40c4a$exports("iterator");
$a6409b85f08d1e69$exports = function(it) {
    if (!$baca1174ca74a0d3$exports(it)) return $01f4d421549051f1$exports(it, $a6409b85f08d1e69$var$ITERATOR) || $01f4d421549051f1$exports(it, "@@iterator") || $793fcd658a874707$exports[$dc8c1109ce58ee6d$exports(it)];
};


var $b8b71f1fccd0013e$var$$TypeError = TypeError;
$b8b71f1fccd0013e$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $a6409b85f08d1e69$exports(argument) : usingIterator;
    if ($c211b3e7372074ff$exports(iteratorMethod)) return $6be50eb62e6ff895$exports($f4e20e30bd7fe607$exports(iteratorMethod, argument));
    throw new $b8b71f1fccd0013e$var$$TypeError($e36a3ffa5631b1a9$exports(argument) + " is not iterable");
};



var $af10258bbf3f6cd3$exports = {};
"use strict";



$af10258bbf3f6cd3$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $6be50eb62e6ff895$exports(iterator);
    try {
        innerResult = $01f4d421549051f1$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $f4e20e30bd7fe607$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $6be50eb62e6ff895$exports(innerResult);
    return value;
};


var $5efd5ec88fefd0a1$var$$TypeError = TypeError;
var $5efd5ec88fefd0a1$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $5efd5ec88fefd0a1$var$ResultPrototype = $5efd5ec88fefd0a1$var$Result.prototype;
$5efd5ec88fefd0a1$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $42108289353d1788$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $af10258bbf3f6cd3$exports(iterator, "normal", condition);
        return new $5efd5ec88fefd0a1$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $6be50eb62e6ff895$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $a6409b85f08d1e69$exports(iterable);
        if (!iterFn) throw new $5efd5ec88fefd0a1$var$$TypeError($e36a3ffa5631b1a9$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($552590d3bbe6d310$exports(iterFn)) {
            for(index = 0, length = $97bedd9bd12f86d9$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5cc1c8753672252f$exports($5efd5ec88fefd0a1$var$ResultPrototype, result)) return result;
            }
            return new $5efd5ec88fefd0a1$var$Result(false);
        }
        iterator = $b8b71f1fccd0013e$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $f4e20e30bd7fe607$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $af10258bbf3f6cd3$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5cc1c8753672252f$exports($5efd5ec88fefd0a1$var$ResultPrototype, result)) return result;
    }
    return new $5efd5ec88fefd0a1$var$Result(false);
};


var $a6380fb331798914$exports = {};
"use strict";

var $9e754ac5af7195e2$exports = {};
"use strict";

var $9e754ac5af7195e2$var$ITERATOR = $2ea0e6681cf40c4a$exports("iterator");
var $9e754ac5af7195e2$var$SAFE_CLOSING = false;
try {
    var $9e754ac5af7195e2$var$called = 0;
    var $9e754ac5af7195e2$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$9e754ac5af7195e2$var$called++
            };
        },
        "return": function() {
            $9e754ac5af7195e2$var$SAFE_CLOSING = true;
        }
    };
    $9e754ac5af7195e2$var$iteratorWithReturn[$9e754ac5af7195e2$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($9e754ac5af7195e2$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$9e754ac5af7195e2$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$9e754ac5af7195e2$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$9e754ac5af7195e2$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $a6380fb331798914$require$FORCED_PROMISE_CONSTRUCTOR = $ac714721992fd2c9$exports.CONSTRUCTOR;
$a6380fb331798914$exports = $a6380fb331798914$require$FORCED_PROMISE_CONSTRUCTOR || !$9e754ac5af7195e2$exports(function(iterable) {
    $7341a0934a816020$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$30d519aac5b45306$exports({
    target: "Promise",
    stat: true,
    forced: $a6380fb331798914$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $d9b538a4fb8633ed$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $1254b1029883cc7e$exports(function() {
            var $promiseResolve = $c211b3e7372074ff$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $5efd5ec88fefd0a1$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $f4e20e30bd7fe607$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $4000816bde5129e2$require$FORCED_PROMISE_CONSTRUCTOR = $ac714721992fd2c9$exports.CONSTRUCTOR;




var $4000816bde5129e2$var$NativePromisePrototype = $7341a0934a816020$exports && $7341a0934a816020$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$30d519aac5b45306$exports({
    target: "Promise",
    proto: true,
    forced: $4000816bde5129e2$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$e3ad2e7b360de895$exports && $6e7763f81bc2c10c$exports($7341a0934a816020$exports)) {
    var $4000816bde5129e2$var$method = $3119fc1b69447c5b$exports("Promise").prototype["catch"];
    if ($4000816bde5129e2$var$NativePromisePrototype["catch"] !== $4000816bde5129e2$var$method) $417ec99404391476$exports($4000816bde5129e2$var$NativePromisePrototype, "catch", $4000816bde5129e2$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$30d519aac5b45306$exports({
    target: "Promise",
    stat: true,
    forced: $a6380fb331798914$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $d9b538a4fb8633ed$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $1254b1029883cc7e$exports(function() {
            var $promiseResolve = $c211b3e7372074ff$exports(C.resolve);
            $5efd5ec88fefd0a1$exports(iterable, function(promise) {
                $f4e20e30bd7fe607$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $29215ece375544c1$require$FORCED_PROMISE_CONSTRUCTOR = $ac714721992fd2c9$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$30d519aac5b45306$exports({
    target: "Promise",
    stat: true,
    forced: $29215ece375544c1$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $d9b538a4fb8633ed$export$2d1720544b23b823(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});


"use strict";





var $9a41a8b8556aaca2$require$FORCED_PROMISE_CONSTRUCTOR = $ac714721992fd2c9$exports.CONSTRUCTOR;
var $016d62f3dcb6dc0f$exports = {};
"use strict";



$016d62f3dcb6dc0f$exports = function(C, x) {
    $6be50eb62e6ff895$exports(C);
    if ($b561dc2cbc8c8dc5$exports(x) && x.constructor === C) return x;
    var promiseCapability = $d9b538a4fb8633ed$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $9a41a8b8556aaca2$var$PromiseConstructorWrapper = $3119fc1b69447c5b$exports("Promise");
var $9a41a8b8556aaca2$var$CHECK_WRAPPER = $e3ad2e7b360de895$exports && !$9a41a8b8556aaca2$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$30d519aac5b45306$exports({
    target: "Promise",
    stat: true,
    forced: $e3ad2e7b360de895$exports || $9a41a8b8556aaca2$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $016d62f3dcb6dc0f$exports($9a41a8b8556aaca2$var$CHECK_WRAPPER && this === $9a41a8b8556aaca2$var$PromiseConstructorWrapper ? $7341a0934a816020$exports : this, x);
    }
});




"use strict";


// `Promise.withResolvers` method
// https://tc39.es/ecma262/#sec-promise.withResolvers
$30d519aac5b45306$exports({
    target: "Promise",
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $d9b538a4fb8633ed$export$2d1720544b23b823(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});




var $2e4b2d264cec2c13$exports = {};
"use strict";

$2e4b2d264cec2c13$exports = $b1d7c5e53f116382$exports;


var $9bd74e182967b200$var$Promise = $2e4b2d264cec2c13$exports.Promise;
var $9bd74e182967b200$var$promiseWithResolvers = $9bd74e182967b200$var$Promise.withResolvers;
$9bd74e182967b200$exports = function withResolvers() {
    return $f4e20e30bd7fe607$exports($9bd74e182967b200$var$promiseWithResolvers, $6e7763f81bc2c10c$exports(this) ? this : $9bd74e182967b200$var$Promise);
};



var $gPvyW = parcelRequire("gPvyW");
function $ceb0095e7f0ee041$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ceb0095e7f0ee041$var$$eef213ff4197108b$exports = {};
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$eef213ff4197108b$exports, "Stack", function() {
    return $ceb0095e7f0ee041$export$694e0d28c7ffc90c;
});
const { push: $ceb0095e7f0ee041$var$$eef213ff4197108b$var$push } = Array.prototype;
class $ceb0095e7f0ee041$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $ceb0095e7f0ee041$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports = {};
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $ceb0095e7f0ee041$export$4125cfe7e08e2040;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $ceb0095e7f0ee041$export$aa9d629c530f62a7;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $ceb0095e7f0ee041$export$b725a69477e4d33f;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $ceb0095e7f0ee041$export$eea2c1c5e1a37e50;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $ceb0095e7f0ee041$export$3b629cd0ff482602;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $ceb0095e7f0ee041$export$4f2a8c8c11a6373a;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $ceb0095e7f0ee041$export$bda27a3e49197b9;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $ceb0095e7f0ee041$export$ba14d9a5a581e827;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "iterateFetchBody", function() {
    return $ceb0095e7f0ee041$export$a95ada708dd8b125;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $ceb0095e7f0ee041$export$b7b86d31099674dc;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $ceb0095e7f0ee041$export$b5fe3f66a567bec0;
});
var $ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports = {};
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $ceb0095e7f0ee041$export$b6a9369736b19f4d;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $ceb0095e7f0ee041$export$2c28ab2e118e73f1;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $ceb0095e7f0ee041$export$a0beee2e55fb5dd1;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $ceb0095e7f0ee041$export$dfdc1655ccc5b9cb;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $ceb0095e7f0ee041$export$f8162fcba31fa547;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "FileMethod", function() {
    return $ceb0095e7f0ee041$export$226b21d2db5eaf9f;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $ceb0095e7f0ee041$export$e209cbb66c5b18c;
});
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $ceb0095e7f0ee041$export$8fb536984ec8b4d7;
});
if (typeof globalThis.AbortSignal === "function") {
    /**
     * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/70}
     */ AbortSignal.prototype.throwIfAborted ||= function() {
        const { aborted: aborted, reason: reason = "Aborted" } = this;
        if (!aborted) return;
        throw reason instanceof DOMException ? reason : new DOMException(reason instanceof Error ? reason.message : reason + "", "AbortError");
    };
    /**
     * @see {@link https://github.com/mo/abortcontroller-polyfill/issues/73#issuecomment-2085543258}
     */ AbortSignal.any ||= (iterable)=>{
        const controller = new AbortController();
        function abort() {
            controller.abort(this.reason);
            clean();
        }
        function clean() {
            for (const signal of iterable)signal.removeEventListener("abort", abort);
        }
        for (const signal of iterable)if (signal.aborted) {
            controller.abort(signal.reason);
            break;
        } else signal.addEventListener("abort", abort);
        return controller.signal;
    };
}
async function $ceb0095e7f0ee041$export$b6a9369736b19f4d(text, contentType = "") {
    const [type] = contentType?.split(";") || [];
    return new DOMParser().parseFromString(text, type || "text/html");
}
function $ceb0095e7f0ee041$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== "string" && (0, $gPvyW.likeArray)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === "object") formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $ceb0095e7f0ee041$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? "image/svg" : root instanceof HTMLDocument || root instanceof HTMLElement ? "text/html" : "application/xml",
        data: (0, $gPvyW.stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: "multipart/form-data",
        data: new FormData(root)
    };
    const data = (0, $gPvyW.formToJSON)(root);
    switch(contentType = root.enctype){
        case "text/plain":
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join("\n")
            };
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data) + ""
            };
        default:
            return {
                contentType: "application/json",
                data: JSON.stringify(data)
            };
    }
}
function $ceb0095e7f0ee041$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(";") || [];
    switch(type){
        case "application/x-www-form-urlencoded":
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case "multipart/form-data":
            return {
                data: $ceb0095e7f0ee041$export$2c28ab2e118e73f1(data)
            };
        case "application/json":
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case "text/html":
        case "application/xml":
        case "image/svg":
            return {
                contentType: contentType,
                data: (0, $gPvyW.stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: "application/x-www-form-urlencoded",
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $ceb0095e7f0ee041$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $gPvyW.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: "application/octet-stream",
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: "application/json",
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error("Unserialized Object needs a specific Content-Type");
}
const $ceb0095e7f0ee041$export$f8162fcba31fa547 = (target)=>(0, $gPvyW.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            if (loaded < total) next({
                loaded: loaded,
                total: total
            });
            else {
                if (loaded === total) next({
                    loaded: loaded,
                    total: total
                });
                complete();
            }
        };
        target.addEventListener("progress", handleProgress);
        target.addEventListener("error", error);
        return ()=>{
            target.removeEventListener("progress", handleProgress);
            target.removeEventListener("error", error);
        };
    });
var $ceb0095e7f0ee041$export$226b21d2db5eaf9f;
(function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
})($ceb0095e7f0ee041$export$226b21d2db5eaf9f || ($ceb0095e7f0ee041$export$226b21d2db5eaf9f = {}));
function $ceb0095e7f0ee041$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$ceb0095e7f0ee041$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $ceb0095e7f0ee041$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $ceb0095e7f0ee041$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $ceb0095e7f0ee041$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $ceb0095e7f0ee041$export$e209cbb66c5b18c(raw, "dataURL").result;
        return ($ceb0095e7f0ee041$var$$22de11b45b0eeb97$var$DataURI.exec(text) || "")[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+("0x" + p1)));
    return btoa(text);
}
var $ceb0095e7f0ee041$export$4125cfe7e08e2040;
(function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
})($ceb0095e7f0ee041$export$4125cfe7e08e2040 || ($ceb0095e7f0ee041$export$4125cfe7e08e2040 = {}));
class $ceb0095e7f0ee041$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message);
        this.request = request;
        this.response = response;
    }
}
const $ceb0095e7f0ee041$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $ceb0095e7f0ee041$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $ceb0095e7f0ee041$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $ceb0095e7f0ee041$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes("json")) return (0, $gPvyW.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return $ceb0095e7f0ee041$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    if (contentType.includes("text")) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $ceb0095e7f0ee041$export$4f2a8c8c11a6373a({ method: method = "GET", path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest(), header_list = headers instanceof Array ? headers : headers?.[Symbol.iterator] instanceof Function ? [
        ...headers
    ] : Object.entries(headers);
    const abort = ()=>request.abort();
    signal?.addEventListener("abort", abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $ceb0095e7f0ee041$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== "text" ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        request.open(method, path + "");
        for (const [key, value] of header_list)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        request.send(body);
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader("Content-Type") || "";
        if (typeof body === "string" && !contentType.includes("text")) body = $ceb0095e7f0ee041$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener("abort", abort));
    return {
        response: response,
        upload: $ceb0095e7f0ee041$export$f8162fcba31fa547(request.upload),
        download: $ceb0095e7f0ee041$export$f8162fcba31fa547(request)
    };
}
function $ceb0095e7f0ee041$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === "text" ? {
        ...headers,
        Accept: "text/plain"
    } : responseType === "json" ? {
        ...headers,
        Accept: "application/json"
    } : responseType === "document" ? {
        ...headers,
        Accept: "text/html, application/xhtml+xml, application/xml"
    } : responseType === "arraybuffer" || responseType === "blob" ? {
        ...headers,
        Accept: "application/octet-stream"
    } : headers;
    const responsePromise = fetch(path + "", {
        method: method,
        headers: headers,
        credentials: withCredentials ? "include" : "omit",
        body: body,
        signal: signals[0] && AbortSignal.any(signals)
    });
    return {
        response: $ceb0095e7f0ee041$export$ba14d9a5a581e827(responsePromise, responseType),
        download: $ceb0095e7f0ee041$export$a95ada708dd8b125(responsePromise)
    };
}
async function $ceb0095e7f0ee041$export$ba14d9a5a581e827(responsePromise, responseType) {
    const { status: status, statusText: statusText, headers: headers, body: body } = (await responsePromise).clone();
    const contentType = headers.get("Content-Type") || "";
    const header = $ceb0095e7f0ee041$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join("\n"));
    const rBody = status === 204 ? undefined : await $ceb0095e7f0ee041$export$b7b86d31099674dc(body, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $ceb0095e7f0ee041$export$b7b86d31099674dc(stream, contentType, responseType) {
    const chunks = [];
    for await (const chunk of stream)chunks.push(chunk);
    const blob = new Blob(chunks, {
        type: contentType
    });
    if (responseType === "blob") return blob;
    if (responseType === "arraybuffer") return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === "text") return text;
    return $ceb0095e7f0ee041$export$3b629cd0ff482602(text, contentType);
}
async function* $ceb0095e7f0ee041$export$a95ada708dd8b125(responsePromise) {
    const { headers: headers, body: body } = (await responsePromise).clone();
    const total = +headers.get("Content-Length");
    var loaded = 0;
    for await (const { byteLength: byteLength } of body){
        loaded += byteLength;
        yield {
            total: total,
            loaded: loaded
        };
    }
}
const $ceb0095e7f0ee041$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === "function" ? $ceb0095e7f0ee041$export$4f2a8c8c11a6373a : $ceb0095e7f0ee041$export$bda27a3e49197b9;
var $ceb0095e7f0ee041$var$$cbd22d3323bef9ca$exports = {};
$ceb0095e7f0ee041$var$$parcel$export($ceb0095e7f0ee041$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $ceb0095e7f0ee041$export$45cf759b359d3d24;
});
const { splice: $ceb0095e7f0ee041$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $ceb0095e7f0ee041$export$45cf759b359d3d24 extends $ceb0095e7f0ee041$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $ceb0095e7f0ee041$export$b5fe3f66a567bec0, ...options } = {}){
        super();
        this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = "GET", headers: headers = {}, body: body } = request;
            if (method in $ceb0095e7f0ee041$export$4125cfe7e08e2040 && body && typeof body === "object") {
                const { contentType: contentType, data: data } = $ceb0095e7f0ee041$export$dfdc1655ccc5b9cb(body, headers["Content-Type"]);
                if (contentType) headers["Content-Type"] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $ceb0095e7f0ee041$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + "", this.baseURI) + "";
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $ceb0095e7f0ee041$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: "HEAD",
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: "GET",
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: "POST",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: "PUT",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: "PATCH",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: "DELETE",
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { "Content-Length": length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { "Content-Range": range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split("/").pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}


var $93f5c86195a73c67$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $93f5c86195a73c67$export$388e0302ca0d9a41 = new (0, $ceb0095e7f0ee041$export$45cf759b359d3d24)({
    baseURI: "https://api.github.com/",
    responseType: "json"
});
var $93f5c86195a73c67$export$4dbac9868ca4e7a9;
(function(OwnerType) {
    OwnerType["user"] = "users";
    OwnerType["organization"] = "orgs";
})($93f5c86195a73c67$export$4dbac9868ca4e7a9 || ($93f5c86195a73c67$export$4dbac9868ca4e7a9 = {}));
function $93f5c86195a73c67$export$5f4ed0d56c2c0edf(type, name) {
    return $93f5c86195a73c67$var$__awaiter(this, void 0, void 0, function*() {
        const { body: body } = yield $93f5c86195a73c67$export$388e0302ca0d9a41.get(`${$93f5c86195a73c67$export$4dbac9868ca4e7a9[type]}/${name}`);
        return body;
    });
}
function $93f5c86195a73c67$export$feac2a21aec844b7(owner, name) {
    return $93f5c86195a73c67$var$__awaiter(this, void 0, void 0, function*() {
        const { body: body } = yield $93f5c86195a73c67$export$388e0302ca0d9a41.get(`repos/${owner}/${name}`);
        return body;
    });
}
function $93f5c86195a73c67$export$f594c030cdaac8cb(type_1, owner_1) {
    return $93f5c86195a73c67$var$__awaiter(this, arguments, void 0, function*(type, owner, options = {}) {
        const { body: body } = yield $93f5c86195a73c67$export$388e0302ca0d9a41.get(`${$93f5c86195a73c67$export$4dbac9868ca4e7a9[type]}/${owner}/repos?${new URLSearchParams(options)}`);
        return body;
    });
}
var $93f5c86195a73c67$export$dce4ecf18820e992;
(function(IssueType) {
    IssueType["issue"] = "issues";
    IssueType["pullRequest"] = "pulls";
})($93f5c86195a73c67$export$dce4ecf18820e992 || ($93f5c86195a73c67$export$dce4ecf18820e992 = {}));
var $93f5c86195a73c67$export$65f87b9c38d25dc1;
(function(IssueState) {
    IssueState["open"] = "success";
    IssueState["closed"] = "danger";
    IssueState["merged"] = "primary";
})($93f5c86195a73c67$export$65f87b9c38d25dc1 || ($93f5c86195a73c67$export$65f87b9c38d25dc1 = {}));
function $93f5c86195a73c67$export$34403cb88b30d33b(owner, repository, type, code) {
    return $93f5c86195a73c67$var$__awaiter(this, void 0, void 0, function*() {
        const path = `repos/${owner}/${repository}/${$93f5c86195a73c67$export$dce4ecf18820e992[type]}/${code}`;
        const { body: issue } = yield $93f5c86195a73c67$export$388e0302ca0d9a41.get(path), { body: comment_list } = yield $93f5c86195a73c67$export$388e0302ca0d9a41.get(`${path}/comments`);
        return Object.assign(Object.assign({}, issue), {
            comment_list: comment_list
        });
    });
}
function $93f5c86195a73c67$export$3f41ece7d7128238({ user: user, organization: organization, repository: repository }) {
    const path = repository ? `repos/${user || organization}/${repository}` : user ? `${$93f5c86195a73c67$export$4dbac9868ca4e7a9.user}/${user}` : `${$93f5c86195a73c67$export$4dbac9868ca4e7a9.organization}/${organization}`;
    return $93f5c86195a73c67$export$388e0302ca0d9a41.get(`${path}/events`);
}


var $f68b57c1bffa7338$export$24422be91ad4011f;
var $f68b57c1bffa7338$export$5ebe5f12eb9ba2ff;
var $f68b57c1bffa7338$export$4b2c314c1e3af9c1;
var $f68b57c1bffa7338$export$ed850ea3798df052;
var $f68b57c1bffa7338$export$fb477eb35d1ea3ab;
var $f68b57c1bffa7338$export$d893d220e0f3c593;
var $f68b57c1bffa7338$export$851c90a03ac301b1;
var $f68b57c1bffa7338$export$f1fd2e06bebed142;
var $f68b57c1bffa7338$export$2ebba504546268cd;
$f68b57c1bffa7338$export$24422be91ad4011f = `IiZpua_download`;
$f68b57c1bffa7338$export$5ebe5f12eb9ba2ff = `IiZpua_forks`;
$f68b57c1bffa7338$export$4b2c314c1e3af9c1 = `IiZpua_github-box`;
$f68b57c1bffa7338$export$ed850ea3798df052 = `IiZpua_github-box-content`;
$f68b57c1bffa7338$export$fb477eb35d1ea3ab = `IiZpua_github-box-download`;
$f68b57c1bffa7338$export$d893d220e0f3c593 = `IiZpua_github-box-title`;
$f68b57c1bffa7338$export$851c90a03ac301b1 = `IiZpua_github-stats`;
$f68b57c1bffa7338$export$f1fd2e06bebed142 = `IiZpua_updated`;
$f68b57c1bffa7338$export$2ebba504546268cd = `IiZpua_watchers`;


var $027f146857a71212$exports = {};
$027f146857a71212$exports = new URL("repository.7bf0dc01.png", import.meta.url).toString();


var $549073b6889288a2$exports = {};
$549073b6889288a2$exports = new URL("watch-fork.43f496f1.png", import.meta.url).toString();


var $895b7a52da257d33$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $895b7a52da257d33$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $895b7a52da257d33$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $895b7a52da257d33$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $895b7a52da257d33$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $895b7a52da257d33$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $895b7a52da257d33$export$d9a521d20ad2c28c = (()=>{
    var _GithubRepository_owner_accessor_storage, _GithubRepository_repository_accessor_storage, _GithubRepository_currentRepository_accessor_storage;
    let _classDecorators = [
        (0, $5f04ae9df0cc484b$export$d8556a2a8f973135)({
            tagName: "github-repository"
        }),
        (0, $5f04ae9df0cc484b$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _owner_decorators;
    let _owner_initializers = [];
    let _owner_extraInitializers = [];
    let _repository_decorators;
    let _repository_initializers = [];
    let _repository_extraInitializers = [];
    let _currentRepository_decorators;
    let _currentRepository_initializers = [];
    let _currentRepository_extraInitializers = [];
    var GithubRepository = _classThis = class extends _classSuper {
        get owner() {
            return $895b7a52da257d33$var$__classPrivateFieldGet(this, _GithubRepository_owner_accessor_storage, "f");
        }
        set owner(value) {
            $895b7a52da257d33$var$__classPrivateFieldSet(this, _GithubRepository_owner_accessor_storage, value, "f");
        }
        get repository() {
            return $895b7a52da257d33$var$__classPrivateFieldGet(this, _GithubRepository_repository_accessor_storage, "f");
        }
        set repository(value) {
            $895b7a52da257d33$var$__classPrivateFieldSet(this, _GithubRepository_repository_accessor_storage, value, "f");
        }
        get currentRepository() {
            return $895b7a52da257d33$var$__classPrivateFieldGet(this, _GithubRepository_currentRepository_accessor_storage, "f");
        }
        set currentRepository(value) {
            $895b7a52da257d33$var$__classPrivateFieldSet(this, _GithubRepository_currentRepository_accessor_storage, value, "f");
        }
        connectedCallback() {
            return $895b7a52da257d33$var$__awaiter(this, void 0, void 0, function*() {
                this.currentRepository = yield (0, $93f5c86195a73c67$export$feac2a21aec844b7)(this.owner, this.repository);
            });
        }
        render() {
            const { owner: owner, html_url: html_url, full_name: full_name, name: name, watchers: watchers, forks: forks, description: description, has_wiki: has_wiki, homepage: homepage, default_branch: default_branch, pushed_at: pushed_at } = this.currentRepository;
            return (0, $81404cd24b820a12$exports.jsxs)("main", {
                className: $f68b57c1bffa7338$export$4b2c314c1e3af9c1,
                children: [
                    (0, $81404cd24b820a12$exports.jsxs)("div", {
                        className: $f68b57c1bffa7338$export$d893d220e0f3c593,
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("h3", {
                                className: "p-2",
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("img", {
                                        className: "pe-1",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($027f146857a71212$exports)))
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("a", {
                                        target: "_blank",
                                        href: owner.html_url,
                                        title: `GitHub Homepage of ${owner.login}`,
                                        children: owner.login
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("span", {
                                        children: "/"
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("a", {
                                        className: "fw-bold",
                                        target: "_blank",
                                        href: html_url,
                                        title: `GitHub Homepage of ${full_name}`,
                                        children: name
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsxs)("div", {
                                className: $f68b57c1bffa7338$export$851c90a03ac301b1,
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("a", {
                                        className: $f68b57c1bffa7338$export$2ebba504546268cd,
                                        style: {
                                            backgroundImage: `url("${(0, (/*@__PURE__*/$parcel$interopDefault($549073b6889288a2$exports)))}")`
                                        },
                                        title: "See watchers",
                                        target: "_blank",
                                        href: `https://github.com/${full_name}/watchers`,
                                        children: watchers
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("a", {
                                        className: $f68b57c1bffa7338$export$5ebe5f12eb9ba2ff,
                                        style: {
                                            backgroundImage: `url("${(0, (/*@__PURE__*/$parcel$interopDefault($549073b6889288a2$exports)))}")`
                                        },
                                        title: "See forkers",
                                        target: "_blank",
                                        href: `https://github.com/${full_name}/forks`,
                                        children: forks
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $81404cd24b820a12$exports.jsxs)("div", {
                        className: $f68b57c1bffa7338$export$ed850ea3798df052,
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("p", {
                                className: "m-0 d-flex justify-content-between",
                                children: [
                                    description,
                                    has_wiki && (0, $81404cd24b820a12$exports.jsx)("a", {
                                        target: "_blank",
                                        href: `https://github.com/${full_name}#readme`,
                                        children: "Read More"
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("p", {
                                className: "m-0 fw-bold",
                                children: (0, $81404cd24b820a12$exports.jsx)("a", {
                                    target: "_blank",
                                    href: homepage,
                                    children: homepage
                                })
                            })
                        ]
                    }),
                    (0, $81404cd24b820a12$exports.jsxs)("div", {
                        className: $f68b57c1bffa7338$export$fb477eb35d1ea3ab,
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("div", {
                                className: $f68b57c1bffa7338$export$f1fd2e06bebed142,
                                children: [
                                    "Latest commit to the",
                                    (0, $81404cd24b820a12$exports.jsx)("strong", {
                                        className: "fw-bold text-dark px-1",
                                        children: default_branch
                                    }),
                                    "branch on",
                                    (0, $81404cd24b820a12$exports.jsx)("time", {
                                        dateTime: pushed_at,
                                        className: "p-1",
                                        children: new Date(pushed_at).toLocaleString()
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                className: $f68b57c1bffa7338$export$24422be91ad4011f,
                                title: "Get an archive of this repository",
                                target: "_blank",
                                href: `https://github.com/${full_name}/zipball/${default_branch}`,
                                children: "Download as zip"
                            })
                        ]
                    })
                ]
            });
        }
        constructor(){
            super(...arguments);
            _GithubRepository_owner_accessor_storage.set(this, $895b7a52da257d33$var$__runInitializers(this, _owner_initializers, "TechQuery"));
            _GithubRepository_repository_accessor_storage.set(this, ($895b7a52da257d33$var$__runInitializers(this, _owner_extraInitializers), $895b7a52da257d33$var$__runInitializers(this, _repository_initializers, "GitHub-Web-Widget")));
            _GithubRepository_currentRepository_accessor_storage.set(this, ($895b7a52da257d33$var$__runInitializers(this, _repository_extraInitializers), $895b7a52da257d33$var$__runInitializers(this, _currentRepository_initializers, {
                owner: {},
                name: this.repository,
                full_name: `${this.owner}/${this.repository}`,
                description: "",
                homepage: "",
                default_branch: "master",
                pushed_at: "",
                has_wiki: true,
                watchers: 0,
                forks: 0,
                html_url: ""
            })));
            $895b7a52da257d33$var$__runInitializers(this, _currentRepository_extraInitializers);
        }
    };
    _GithubRepository_owner_accessor_storage = new WeakMap();
    _GithubRepository_repository_accessor_storage = new WeakMap();
    _GithubRepository_currentRepository_accessor_storage = new WeakMap();
    $895b7a52da257d33$var$__setFunctionName(_classThis, "GithubRepository");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _owner_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _repository_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _currentRepository_decorators = [
            (0, $a2E6i.observable)
        ];
        $895b7a52da257d33$var$__esDecorate(_classThis, null, _owner_decorators, {
            kind: "accessor",
            name: "owner",
            static: false,
            private: false,
            access: {
                has: (obj)=>"owner" in obj,
                get: (obj)=>obj.owner,
                set: (obj, value)=>{
                    obj.owner = value;
                }
            },
            metadata: _metadata
        }, _owner_initializers, _owner_extraInitializers);
        $895b7a52da257d33$var$__esDecorate(_classThis, null, _repository_decorators, {
            kind: "accessor",
            name: "repository",
            static: false,
            private: false,
            access: {
                has: (obj)=>"repository" in obj,
                get: (obj)=>obj.repository,
                set: (obj, value)=>{
                    obj.repository = value;
                }
            },
            metadata: _metadata
        }, _repository_initializers, _repository_extraInitializers);
        $895b7a52da257d33$var$__esDecorate(_classThis, null, _currentRepository_decorators, {
            kind: "accessor",
            name: "currentRepository",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentRepository" in obj,
                get: (obj)=>obj.currentRepository,
                set: (obj, value)=>{
                    obj.currentRepository = value;
                }
            },
            metadata: _metadata
        }, _currentRepository_initializers, _currentRepository_extraInitializers);
        $895b7a52da257d33$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GithubRepository = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $895b7a52da257d33$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GithubRepository = _classThis;
})();




var $a2E6i = parcelRequire("a2E6i");

var $2af7d3d6a4beaeca$export$cc81a5c85b55e12c;
var $2af7d3d6a4beaeca$export$db3c28d99448dcff;
$2af7d3d6a4beaeca$export$cc81a5c85b55e12c = `CPtZdW_big`;
$2af7d3d6a4beaeca$export$db3c28d99448dcff = `CPtZdW_logo`;



var $104321ad7e9cf2a6$exports = {};
/**
 * marked v15.0.0 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($104321ad7e9cf2a6$exports);
})($104321ad7e9cf2a6$exports, function(exports1) {
    "use strict";
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    const noopTest = {
        exec: ()=>null
    };
    function edit(regex, opt = "") {
        let source = typeof regex === "string" ? regex : regex.source;
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === "string" ? val : val.source;
                valSource = valSource.replace(other.caret, "$1");
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    const other = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
        hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
        htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
    };
    /**
     * Block-Level Grammar
     */ const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        table: gfmTable,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
        .replace("table", gfmTable) // interrupt paragraphs with table
        .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = "\\p{P}\\p{S}";
    const punctuation = edit(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, _punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAst = edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu") // (6) a***a can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu") // (5) #___# can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\([punct])/, "gu").replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
    const reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape$1,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        escape: edit(escape$1).replace("])", "~|])").getRegex(),
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace("{2,}", "*").getRegex(),
        text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Helpers
     */ const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (other.escapeTest.test(html)) return html.replace(other.escapeReplace, getEscapeReplacement);
        } else {
            if (other.escapeTestNoEncode.test(html)) return html.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(other.percentDecode, "%");
        } catch  {
            return null;
        }
        return href;
    }
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(other.findPipe, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(other.splitPipe);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(other.slashPipe, "|");
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function outputLink(cap, link, raw, lexer, rules) {
        const href = link.href;
        const title = link.title || null;
        const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            const token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: text
        };
    }
    function indentCodeCompensation(raw, text, rules) {
        const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(rules.other.beginningSpace);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (this.rules.other.endingHash.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: rtrim(cap[0], "\n")
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], "\n").split("\n");
                let raw = "";
                let text = "";
                const tokens = [];
                while(lines.length > 0){
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for(i = 0; i < lines.length; i++){
                        // get lines up to a continuation
                        if (this.rules.other.blockquoteStart.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        } else if (!inBlockquote) currentLines.push(lines[i]);
                        else break;
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join("\n");
                    const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                    .replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) break;
                    const lastToken = tokens[tokens.length - 1];
                    if (lastToken?.type === "code") break;
                    else if (lastToken?.type === "blockquote") {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    } else if (lastToken?.type === "list") {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens[tokens.length - 1].raw.length).split("\n");
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: raw,
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                const itemRegex = this.rules.other.listItemRegex(bull);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    let raw = "";
                    let itemContents = "";
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else if (blankLine) indent = cap[1].length + 1;
                    else {
                        indent = cap[2].search(this.rules.other.nonSpaceChar); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                        const hrRegex = this.rules.other.hrRegex(indent);
                        const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                        const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                        const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                                nextLineWithoutTabs = nextLine;
                            } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) break;
                            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = this.rules.other.listIsTask.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
                list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!this.rules.other.tableDelimiter.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
            const rows = cap[3] && cap[3].trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
            const item = {
                type: "table",
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                else item.align.push(null);
            }
            for(let i = 0; i < headers.length; i++)item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: cap[1]
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = this.rules.other.pedanticHrefTitle.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (this.rules.other.startAngleBracket.test(href)) {
                    if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                }, cap[0], this.lexer, this.rules);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer, this.rules);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[1];
                    href = "mailto:" + text;
                } else {
                    text = cap[1];
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[0];
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                    }while (prevCapZero !== cap[0]);
                    text = cap[0];
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                const escaped = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    escaped: escaped
                };
            }
        }
    }
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                other: other,
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(other.carriageReturn, "\n");
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
            let token;
            let lastToken;
            let cutSrc;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken?.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        parser;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(token) {
            return "";
        }
        code({ text: text, lang: lang, escaped: escaped }) {
            const langString = (lang || "").match(other.notSpaceStart)?.[0];
            const code = text.replace(other.endingNewline, "") + "\n";
            if (!langString) return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape(langString) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
        }
        blockquote({ tokens: tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text: text }) {
            return text;
        }
        heading({ tokens: tokens, depth: depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return "<hr>\n";
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = "";
            for(let j = 0; j < token.items.length; j++){
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? "ol" : "ul";
            const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
        }
        listitem(item) {
            let itemBody = "";
            if (item.task) {
                const checkbox = this.checkbox({
                    checked: !!item.checked
                });
                if (item.loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                            item.tokens[0].tokens[0].text = checkbox + " " + escape(item.tokens[0].tokens[0].text);
                            item.tokens[0].tokens[0].escaped = true;
                        }
                    } else item.tokens.unshift({
                        type: "text",
                        raw: checkbox + " ",
                        text: checkbox + " ",
                        escaped: true
                    });
                } else itemBody += checkbox + " ";
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked: checked }) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = "";
            // header
            let cell = "";
            for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
            header += this.tablerow({
                text: cell
            });
            let body = "";
            for(let j = 0; j < token.rows.length; j++){
                const row = token.rows[j];
                cell = "";
                for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                body += this.tablerow({
                    text: cell
                });
            }
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow({ text: text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? "th" : "td";
            const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong({ tokens: tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens: tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text: text }) {
            return `<code>${escape(text, true)}</code>`;
        }
        br(token) {
            return "<br>";
        }
        del({ tokens: tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + escape(title) + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image({ href: href, title: title, text: text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return escape(text);
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${escape(title)}"`;
            out += ">";
            return out;
        }
        text(token) {
            return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape(token.text);
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong({ text: text }) {
            return text;
        }
        em({ text: text }) {
            return text;
        }
        codespan({ text: text }) {
            return text;
        }
        del({ text: text }) {
            return text;
        }
        html({ text: text }) {
            return text;
        }
        text({ text: text }) {
            return text;
        }
        link({ text: text }) {
            return "" + text;
        }
        image({ text: text }) {
            return "" + text;
        }
        br() {
            return "";
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "space":
                        out += this.renderer.space(token);
                        continue;
                    case "hr":
                        out += this.renderer.hr(token);
                        continue;
                    case "heading":
                        out += this.renderer.heading(token);
                        continue;
                    case "code":
                        out += this.renderer.code(token);
                        continue;
                    case "table":
                        out += this.renderer.table(token);
                        continue;
                    case "blockquote":
                        out += this.renderer.blockquote(token);
                        continue;
                    case "list":
                        out += this.renderer.list(token);
                        continue;
                    case "html":
                        out += this.renderer.html(token);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(token);
                        continue;
                    case "text":
                        {
                            let textToken = token;
                            let body = this.renderer.text(textToken);
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + this.renderer.text(textToken);
                            }
                            if (top) out += this.renderer.paragraph({
                                type: "paragraph",
                                raw: body,
                                text: body,
                                tokens: [
                                    {
                                        type: "text",
                                        raw: body,
                                        text: body,
                                        escaped: true
                                    }
                                ]
                            });
                            else out += body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({
                        parser: this
                    }, anyToken);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(anyToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "escape":
                        out += renderer.text(token);
                        break;
                    case "html":
                        out += renderer.html(token);
                        break;
                    case "link":
                        out += renderer.link(token);
                        break;
                    case "image":
                        out += renderer.image(token);
                        break;
                    case "strong":
                        out += renderer.strong(token);
                        break;
                    case "em":
                        out += renderer.em(token);
                        break;
                    case "codespan":
                        out += renderer.codespan(token);
                        break;
                    case "br":
                        out += renderer.br(token);
                        break;
                    case "del":
                        out += renderer.del(token);
                        break;
                    case "text":
                        out += renderer.text(token);
                        break;
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        block;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */ processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */ provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */ provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(prop)) continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(prop)) continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                // throw error in case of non string input
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                const parser = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});


var $9e1eddf1d601d6cb$exports = {};
(function(global, factory) {
    factory($9e1eddf1d601d6cb$exports);
})($9e1eddf1d601d6cb$exports, function(exports1) {
    "use strict";
    function markedHighlight(options) {
        if (typeof options === "function") options = {
            highlight: options
        };
        if (!options || typeof options.highlight !== "function") throw new Error("Must provide highlight function");
        if (typeof options.langPrefix !== "string") options.langPrefix = "language-";
        if (typeof options.emptyLangClass !== "string") options.emptyLangClass = "";
        return {
            async: !!options.async,
            walkTokens (token) {
                if (token.type !== "code") return;
                const lang = getLang(token.lang);
                if (options.async) return Promise.resolve(options.highlight(token.text, lang, token.lang || "")).then(updateToken(token));
                const code = options.highlight(token.text, lang, token.lang || "");
                if (code instanceof Promise) throw new Error("markedHighlight is not set to async but the highlight function is async. Set the async option to true on markedHighlight to await the async highlight function.");
                updateToken(token)(code);
            },
            useNewRenderer: true,
            renderer: {
                code (code, infoString, escaped) {
                    // istanbul ignore next
                    if (typeof code === "object") {
                        escaped = code.escaped;
                        infoString = code.lang;
                        code = code.text;
                    }
                    const lang = getLang(infoString);
                    const classValue = lang ? options.langPrefix + escape(lang) : options.emptyLangClass;
                    const classAttr = classValue ? ` class="${classValue}"` : "";
                    code = code.replace(/\n$/, "");
                    return `<pre><code${classAttr}>${escaped ? code : escape(code, true)}\n</code></pre>`;
                }
            }
        };
    }
    function getLang(lang) {
        return (lang || "").match(/\S*/)[0];
    }
    function updateToken(token) {
        return (code)=>{
            if (typeof code === "string" && code !== token.text) {
                token.escaped = true;
                token.text = code;
            }
        };
    }
    // copied from marked helpers
    const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, "g");
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    exports1.markedHighlight = markedHighlight;
});


var $ba93b61179da023b$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $ba93b61179da023b$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $ba93b61179da023b$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($ba93b61179da023b$var$_self);
if (0, $ba93b61179da023b$exports) $ba93b61179da023b$exports = $ba93b61179da023b$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $ba93b61179da023b$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $ba93b61179da023b$var$Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$ba93b61179da023b$var$Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = $ba93b61179da023b$var$Prism.languages.markup["entity"];
$ba93b61179da023b$var$Prism.languages.markup["doctype"].inside["internal-subset"].inside = $ba93b61179da023b$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$ba93b61179da023b$var$Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty($ba93b61179da023b$var$Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $ba93b61179da023b$var$Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: $ba93b61179da023b$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $ba93b61179da023b$var$Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty($ba93b61179da023b$var$Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $ba93b61179da023b$var$Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: $ba93b61179da023b$var$Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$ba93b61179da023b$var$Prism.languages.html = $ba93b61179da023b$var$Prism.languages.markup;
$ba93b61179da023b$var$Prism.languages.mathml = $ba93b61179da023b$var$Prism.languages.markup;
$ba93b61179da023b$var$Prism.languages.svg = $ba93b61179da023b$var$Prism.languages.markup;
$ba93b61179da023b$var$Prism.languages.xml = $ba93b61179da023b$var$Prism.languages.extend("markup", {});
$ba93b61179da023b$var$Prism.languages.ssml = $ba93b61179da023b$var$Prism.languages.xml;
$ba93b61179da023b$var$Prism.languages.atom = $ba93b61179da023b$var$Prism.languages.xml;
$ba93b61179da023b$var$Prism.languages.rss = $ba93b61179da023b$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})($ba93b61179da023b$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $ba93b61179da023b$var$Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $ba93b61179da023b$var$Prism.languages.javascript = $ba93b61179da023b$var$Prism.languages.extend("clike", {
    "class-name": [
        $ba93b61179da023b$var$Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$ba93b61179da023b$var$Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$ba93b61179da023b$var$Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $ba93b61179da023b$var$Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $ba93b61179da023b$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $ba93b61179da023b$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $ba93b61179da023b$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $ba93b61179da023b$var$Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$ba93b61179da023b$var$Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $ba93b61179da023b$var$Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
$ba93b61179da023b$var$Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if ($ba93b61179da023b$var$Prism.languages.markup) {
    $ba93b61179da023b$var$Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $ba93b61179da023b$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
$ba93b61179da023b$var$Prism.languages.js = $ba93b61179da023b$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $ba93b61179da023b$var$Prism === "undefined" || typeof document === "undefined") return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        "js": "javascript",
        "py": "python",
        "rb": "ruby",
        "ps1": "powershell",
        "psm1": "powershell",
        "sh": "bash",
        "bat": "batch",
        "h": "c",
        "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ":not([" + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $ba93b61179da023b$var$Prism.hooks.add("before-highlightall", function(env) {
        env.selector += ", " + SELECTOR;
    });
    $ba93b61179da023b$var$Prism.hooks.add("before-sanity-check", function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ""; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement("CODE"));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute("data-src");
            var language = env.language;
            if (language === "none") {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    "none"
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $ba93b61179da023b$var$Prism.util.setLanguage(code, language);
            $ba93b61179da023b$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $ba93b61179da023b$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute("data-range"));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join("\n");
                    // add data-start for line numbers
                    if (!pre.hasAttribute("data-start")) pre.setAttribute("data-start", String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $ba93b61179da023b$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $ba93b61179da023b$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$ba93b61179da023b$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $ba93b61179da023b$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
            logged = true;
        }
        $ba93b61179da023b$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


const $5c3171cb4df06a17$export$db8f131360c543a5 = new (0, $104321ad7e9cf2a6$exports.Marked)((0, $9e1eddf1d601d6cb$exports.markedHighlight)({
    highlight (code, language) {
        language = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || "none";
        const Class = `class="language-${language}"`, grammer = (0, $ba93b61179da023b$exports.languages)[language];
        return `<pre ${Class}><code ${Class}>${grammer ? (0, $ba93b61179da023b$exports.highlight)(code, grammer, language) : code}</code></pre>`;
    }
}));


var $a9cbf11fea6644ec$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $a9cbf11fea6644ec$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $a9cbf11fea6644ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a9cbf11fea6644ec$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $a9cbf11fea6644ec$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a9cbf11fea6644ec$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $a9cbf11fea6644ec$export$d3667e5e7566d0b7 = (()=>{
    var _GithubIssue_owner_accessor_storage, _GithubIssue_repository_accessor_storage, _GithubIssue_issue_accessor_storage, _GithubIssue_pull_accessor_storage, _GithubIssue_currentIssue_accessor_storage;
    let _classDecorators = [
        (0, $5f04ae9df0cc484b$export$d8556a2a8f973135)({
            tagName: "github-issue"
        }),
        (0, $5f04ae9df0cc484b$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _owner_decorators;
    let _owner_initializers = [];
    let _owner_extraInitializers = [];
    let _repository_decorators;
    let _repository_initializers = [];
    let _repository_extraInitializers = [];
    let _issue_decorators;
    let _issue_initializers = [];
    let _issue_extraInitializers = [];
    let _pull_decorators;
    let _pull_initializers = [];
    let _pull_extraInitializers = [];
    let _currentIssue_decorators;
    let _currentIssue_initializers = [];
    let _currentIssue_extraInitializers = [];
    var GithubIssue = _classThis = class extends _classSuper {
        get owner() {
            return $a9cbf11fea6644ec$var$__classPrivateFieldGet(this, _GithubIssue_owner_accessor_storage, "f");
        }
        set owner(value) {
            $a9cbf11fea6644ec$var$__classPrivateFieldSet(this, _GithubIssue_owner_accessor_storage, value, "f");
        }
        get repository() {
            return $a9cbf11fea6644ec$var$__classPrivateFieldGet(this, _GithubIssue_repository_accessor_storage, "f");
        }
        set repository(value) {
            $a9cbf11fea6644ec$var$__classPrivateFieldSet(this, _GithubIssue_repository_accessor_storage, value, "f");
        }
        get issue() {
            return $a9cbf11fea6644ec$var$__classPrivateFieldGet(this, _GithubIssue_issue_accessor_storage, "f");
        }
        set issue(value) {
            $a9cbf11fea6644ec$var$__classPrivateFieldSet(this, _GithubIssue_issue_accessor_storage, value, "f");
        }
        get pull() {
            return $a9cbf11fea6644ec$var$__classPrivateFieldGet(this, _GithubIssue_pull_accessor_storage, "f");
        }
        set pull(value) {
            $a9cbf11fea6644ec$var$__classPrivateFieldSet(this, _GithubIssue_pull_accessor_storage, value, "f");
        }
        get currentIssue() {
            return $a9cbf11fea6644ec$var$__classPrivateFieldGet(this, _GithubIssue_currentIssue_accessor_storage, "f");
        }
        set currentIssue(value) {
            $a9cbf11fea6644ec$var$__classPrivateFieldSet(this, _GithubIssue_currentIssue_accessor_storage, value, "f");
        }
        connectedCallback() {
            return $a9cbf11fea6644ec$var$__awaiter(this, void 0, void 0, function*() {
                const issue = yield (0, $93f5c86195a73c67$export$34403cb88b30d33b)(this.owner, this.repository, this.pull ? "pullRequest" : "issue", this.pull || this.issue), repository = yield (0, $93f5c86195a73c67$export$feac2a21aec844b7)(this.owner, this.repository);
                this.currentIssue = Object.assign(Object.assign({}, issue), {
                    repository: repository
                });
            });
        }
        renderComment({ user: user, created_at: created_at, body: body }, top) {
            return (0, $81404cd24b820a12$exports.jsxs)("details", {
                children: [
                    (0, $81404cd24b820a12$exports.jsxs)("summary", {
                        className: "d-flex align-items-center my-3",
                        children: [
                            (0, $81404cd24b820a12$exports.jsx)("img", {
                                className: `px-1 ${$2af7d3d6a4beaeca$export$db3c28d99448dcff}`,
                                src: user.avatar_url
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                className: "px-1",
                                target: "_blank",
                                href: user.html_url,
                                rel: "noreferrer",
                                children: (0, $81404cd24b820a12$exports.jsx)("strong", {
                                    children: user.login
                                })
                            }),
                            (0, $81404cd24b820a12$exports.jsxs)("span", {
                                className: "px-1",
                                children: [
                                    top ? "opened this" : "commented",
                                    " at"
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("time", {
                                className: "px-1",
                                dateTime: created_at,
                                children: new Date(created_at).toLocaleString()
                            })
                        ]
                    }),
                    (0, $81404cd24b820a12$exports.jsx)("div", {
                        className: "markdown-body my-3",
                        innerHTML: (0, $5c3171cb4df06a17$export$db8f131360c543a5).parse(body)
                    })
                ]
            });
        }
        render() {
            const { user: user, state: state, html_url: html_url, title: title, created_at: created_at, body: body, comment_list: comment_list, repository: { owner: owner } } = this.currentIssue;
            return (0, $81404cd24b820a12$exports.jsxs)("div", {
                className: "d-flex my-4",
                children: [
                    (0, $81404cd24b820a12$exports.jsxs)("aside", {
                        className: "d-flex flex-column align-items-center px-3 w-25",
                        children: [
                            (0, $81404cd24b820a12$exports.jsx)("img", {
                                className: `${$2af7d3d6a4beaeca$export$db3c28d99448dcff} ${$2af7d3d6a4beaeca$export$cc81a5c85b55e12c}`,
                                src: owner === null || owner === void 0 ? void 0 : owner.avatar_url
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                target: "_blank",
                                href: owner === null || owner === void 0 ? void 0 : owner.html_url,
                                rel: "noreferrer",
                                children: (0, $81404cd24b820a12$exports.jsx)("strong", {
                                    children: owner === null || owner === void 0 ? void 0 : owner.login
                                })
                            })
                        ]
                    }),
                    (0, $81404cd24b820a12$exports.jsxs)("div", {
                        className: "flex-grow-1",
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("h3", {
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("span", {
                                        className: `badge bg-${(0, $93f5c86195a73c67$export$65f87b9c38d25dc1)[state]} me-3`,
                                        children: state
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("a", {
                                        target: "_blank",
                                        href: html_url,
                                        rel: "noreferrer",
                                        children: title
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsxs)("div", {
                                children: [
                                    this.renderComment({
                                        user: user,
                                        created_at: created_at,
                                        body: body
                                    }, true),
                                    comment_list.map((item)=>this.renderComment(item))
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        constructor(){
            super(...arguments);
            _GithubIssue_owner_accessor_storage.set(this, $a9cbf11fea6644ec$var$__runInitializers(this, _owner_initializers, ""));
            _GithubIssue_repository_accessor_storage.set(this, ($a9cbf11fea6644ec$var$__runInitializers(this, _owner_extraInitializers), $a9cbf11fea6644ec$var$__runInitializers(this, _repository_initializers, "")));
            _GithubIssue_issue_accessor_storage.set(this, ($a9cbf11fea6644ec$var$__runInitializers(this, _repository_extraInitializers), $a9cbf11fea6644ec$var$__runInitializers(this, _issue_initializers, 0)));
            _GithubIssue_pull_accessor_storage.set(this, ($a9cbf11fea6644ec$var$__runInitializers(this, _issue_extraInitializers), $a9cbf11fea6644ec$var$__runInitializers(this, _pull_initializers, 0)));
            _GithubIssue_currentIssue_accessor_storage.set(this, ($a9cbf11fea6644ec$var$__runInitializers(this, _pull_extraInitializers), $a9cbf11fea6644ec$var$__runInitializers(this, _currentIssue_initializers, {
                state: "open",
                title: "",
                body: "",
                created_at: "",
                user: {},
                html_url: "",
                comment_list: [],
                repository: {}
            })));
            $a9cbf11fea6644ec$var$__runInitializers(this, _currentIssue_extraInitializers);
        }
    };
    _GithubIssue_owner_accessor_storage = new WeakMap();
    _GithubIssue_repository_accessor_storage = new WeakMap();
    _GithubIssue_issue_accessor_storage = new WeakMap();
    _GithubIssue_pull_accessor_storage = new WeakMap();
    _GithubIssue_currentIssue_accessor_storage = new WeakMap();
    $a9cbf11fea6644ec$var$__setFunctionName(_classThis, "GithubIssue");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _owner_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _repository_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _issue_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _pull_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _currentIssue_decorators = [
            (0, $a2E6i.observable)
        ];
        $a9cbf11fea6644ec$var$__esDecorate(_classThis, null, _owner_decorators, {
            kind: "accessor",
            name: "owner",
            static: false,
            private: false,
            access: {
                has: (obj)=>"owner" in obj,
                get: (obj)=>obj.owner,
                set: (obj, value)=>{
                    obj.owner = value;
                }
            },
            metadata: _metadata
        }, _owner_initializers, _owner_extraInitializers);
        $a9cbf11fea6644ec$var$__esDecorate(_classThis, null, _repository_decorators, {
            kind: "accessor",
            name: "repository",
            static: false,
            private: false,
            access: {
                has: (obj)=>"repository" in obj,
                get: (obj)=>obj.repository,
                set: (obj, value)=>{
                    obj.repository = value;
                }
            },
            metadata: _metadata
        }, _repository_initializers, _repository_extraInitializers);
        $a9cbf11fea6644ec$var$__esDecorate(_classThis, null, _issue_decorators, {
            kind: "accessor",
            name: "issue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"issue" in obj,
                get: (obj)=>obj.issue,
                set: (obj, value)=>{
                    obj.issue = value;
                }
            },
            metadata: _metadata
        }, _issue_initializers, _issue_extraInitializers);
        $a9cbf11fea6644ec$var$__esDecorate(_classThis, null, _pull_decorators, {
            kind: "accessor",
            name: "pull",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pull" in obj,
                get: (obj)=>obj.pull,
                set: (obj, value)=>{
                    obj.pull = value;
                }
            },
            metadata: _metadata
        }, _pull_initializers, _pull_extraInitializers);
        $a9cbf11fea6644ec$var$__esDecorate(_classThis, null, _currentIssue_decorators, {
            kind: "accessor",
            name: "currentIssue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentIssue" in obj,
                get: (obj)=>obj.currentIssue,
                set: (obj, value)=>{
                    obj.currentIssue = value;
                }
            },
            metadata: _metadata
        }, _currentIssue_initializers, _currentIssue_extraInitializers);
        $a9cbf11fea6644ec$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GithubIssue = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $a9cbf11fea6644ec$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GithubIssue = _classThis;
})();




var $a2E6i = parcelRequire("a2E6i");


var $5c49a8203b49e4a5$export$4c99ddeeb7ba53b1;
var $5c49a8203b49e4a5$export$144db29932b896d9;
var $5c49a8203b49e4a5$export$4a93bdb6fe914b88;
var $5c49a8203b49e4a5$export$7a688d9aee5f0e8a;
var $5c49a8203b49e4a5$export$1aa1a3e63ea41ee3;
var $5c49a8203b49e4a5$export$e6557883bc334625;
var $5c49a8203b49e4a5$export$d3732745fa35b1d4;
var $5c49a8203b49e4a5$export$d4e9b48294707099;
var $5c49a8203b49e4a5$export$ce50894e4933afdd;
var $5c49a8203b49e4a5$export$e2d02a695fd7ee59;
var $5c49a8203b49e4a5$export$8f36e1ff19e9c6c;
$5c49a8203b49e4a5$export$4c99ddeeb7ba53b1 = `BPWP7q_gh-profile-card`;
$5c49a8203b49e4a5$export$144db29932b896d9 = `BPWP7q_profile-avatar`;
$5c49a8203b49e4a5$export$4a93bdb6fe914b88 = `BPWP7q_profile-follow`;
$5c49a8203b49e4a5$export$7a688d9aee5f0e8a = `BPWP7q_profile-followers`;
$5c49a8203b49e4a5$export$1aa1a3e63ea41ee3 = `BPWP7q_profile-languages`;
$5c49a8203b49e4a5$export$e6557883bc334625 = `BPWP7q_profile-name`;
$5c49a8203b49e4a5$export$d3732745fa35b1d4 = `BPWP7q_profile-repos`;
$5c49a8203b49e4a5$export$d4e9b48294707099 = `BPWP7q_repos-header`;
$5c49a8203b49e4a5$export$ce50894e4933afdd = `BPWP7q_repos-name`;
$5c49a8203b49e4a5$export$e2d02a695fd7ee59 = `BPWP7q_repos-star`;
$5c49a8203b49e4a5$export$8f36e1ff19e9c6c = `BPWP7q_repos-updated`;


var $3b7fc863b8681a83$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $3b7fc863b8681a83$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $3b7fc863b8681a83$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3b7fc863b8681a83$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $3b7fc863b8681a83$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $3b7fc863b8681a83$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $3b7fc863b8681a83$export$85d9ef3463ff440b = (()=>{
    var _GithubProfile_user_accessor_storage, _GithubProfile_organization_accessor_storage, _GithubProfile_currentOwner_accessor_storage;
    let _classDecorators = [
        (0, $5f04ae9df0cc484b$export$d8556a2a8f973135)({
            tagName: "github-profile"
        }),
        (0, $5f04ae9df0cc484b$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _user_decorators;
    let _user_initializers = [];
    let _user_extraInitializers = [];
    let _organization_decorators;
    let _organization_initializers = [];
    let _organization_extraInitializers = [];
    let _currentOwner_decorators;
    let _currentOwner_initializers = [];
    let _currentOwner_extraInitializers = [];
    var GithubProfile = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _GithubProfile_user_accessor_storage.set(this, $3b7fc863b8681a83$var$__runInitializers(this, _user_initializers, ""));
            _GithubProfile_organization_accessor_storage.set(this, ($3b7fc863b8681a83$var$__runInitializers(this, _user_extraInitializers), $3b7fc863b8681a83$var$__runInitializers(this, _organization_initializers, "")));
            _GithubProfile_currentOwner_accessor_storage.set(this, ($3b7fc863b8681a83$var$__runInitializers(this, _organization_extraInitializers), $3b7fc863b8681a83$var$__runInitializers(this, _currentOwner_initializers, {
                login: "",
                name: "",
                avatar_url: "",
                html_url: "",
                followers: 0,
                updated_at: "",
                languages: [],
                repositories: []
            })));
            Object.defineProperty(this, "renderRepository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($3b7fc863b8681a83$var$__runInitializers(this, _currentOwner_extraInitializers), ({ html_url: html_url, description: description, name: name, updated_at: updated_at, stargazers_count: stargazers_count })=>(0, $81404cd24b820a12$exports.jsxs)("a", {
                        className: $5c49a8203b49e4a5$export$d3732745fa35b1d4,
                        target: "_blank",
                        href: html_url,
                        title: description,
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("span", {
                                className: "d-flex justify-content-between",
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("span", {
                                        className: $5c49a8203b49e4a5$export$ce50894e4933afdd,
                                        children: name
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("span", {
                                        className: $5c49a8203b49e4a5$export$e2d02a695fd7ee59,
                                        children: stargazers_count
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsxs)("time", {
                                className: $5c49a8203b49e4a5$export$8f36e1ff19e9c6c,
                                dateTime: updated_at,
                                children: [
                                    "Updated:",
                                    new Date(updated_at).toLocaleString()
                                ]
                            })
                        ]
                    }, html_url))
            });
        }
        get user() {
            return $3b7fc863b8681a83$var$__classPrivateFieldGet(this, _GithubProfile_user_accessor_storage, "f");
        }
        set user(value) {
            $3b7fc863b8681a83$var$__classPrivateFieldSet(this, _GithubProfile_user_accessor_storage, value, "f");
        }
        get organization() {
            return $3b7fc863b8681a83$var$__classPrivateFieldGet(this, _GithubProfile_organization_accessor_storage, "f");
        }
        set organization(value) {
            $3b7fc863b8681a83$var$__classPrivateFieldSet(this, _GithubProfile_organization_accessor_storage, value, "f");
        }
        get currentOwner() {
            return $3b7fc863b8681a83$var$__classPrivateFieldGet(this, _GithubProfile_currentOwner_accessor_storage, "f");
        }
        set currentOwner(value) {
            $3b7fc863b8681a83$var$__classPrivateFieldSet(this, _GithubProfile_currentOwner_accessor_storage, value, "f");
        }
        connectedCallback() {
            return $3b7fc863b8681a83$var$__awaiter(this, void 0, void 0, function*() {
                const { user: user, organization: organization } = this;
                const owner = yield user ? (0, $93f5c86195a73c67$export$5f4ed0d56c2c0edf)("user", user) : (0, $93f5c86195a73c67$export$5f4ed0d56c2c0edf)("organization", organization), sort = "updated";
                let list = yield user ? (0, $93f5c86195a73c67$export$f594c030cdaac8cb)("user", user, {
                    sort: sort
                }) : (0, $93f5c86195a73c67$export$f594c030cdaac8cb)("organization", organization, {
                    sort: sort
                });
                list = list.filter(({ fork: fork })=>!fork);
                const repositories = list.filter(({ stargazers_count: stargazers_count })=>stargazers_count).sort((A, B)=>B.stargazers_count - A.stargazers_count).slice(0, 5), languages = [
                    ...new Set(list.map(({ language: language })=>language))
                ].filter(Boolean);
                this.currentOwner = Object.assign(Object.assign({}, owner), {
                    languages: languages,
                    repositories: repositories
                });
            });
        }
        render() {
            const { avatar_url: avatar_url, html_url: html_url, name: name, login: login, followers: followers, languages: languages, repositories: repositories } = this.currentOwner;
            return (0, $81404cd24b820a12$exports.jsxs)("div", {
                className: $5c49a8203b49e4a5$export$4c99ddeeb7ba53b1,
                children: [
                    (0, $81404cd24b820a12$exports.jsxs)("header", {
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("header", {
                                className: "d-flex justify-content-between",
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("img", {
                                        className: $5c49a8203b49e4a5$export$144db29932b896d9,
                                        src: avatar_url
                                    }),
                                    (0, $81404cd24b820a12$exports.jsxs)("div", {
                                        children: [
                                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                                className: $5c49a8203b49e4a5$export$e6557883bc334625,
                                                target: "_blank",
                                                href: html_url,
                                                children: name
                                            }),
                                            (0, $81404cd24b820a12$exports.jsxs)("div", {
                                                className: "d-flex justify-content-between mt-1",
                                                children: [
                                                    (0, $81404cd24b820a12$exports.jsxs)("a", {
                                                        className: $5c49a8203b49e4a5$export$4a93bdb6fe914b88,
                                                        target: "_blank",
                                                        href: html_url,
                                                        children: [
                                                            "Follow @",
                                                            login
                                                        ]
                                                    }),
                                                    (0, $81404cd24b820a12$exports.jsx)("span", {
                                                        className: $5c49a8203b49e4a5$export$7a688d9aee5f0e8a,
                                                        children: followers
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("ul", {
                                className: $5c49a8203b49e4a5$export$1aa1a3e63ea41ee3,
                                children: languages.map((name)=>(0, $81404cd24b820a12$exports.jsx)("li", {
                                        children: name
                                    }, name))
                            })
                        ]
                    }),
                    (0, $81404cd24b820a12$exports.jsxs)("section", {
                        children: [
                            (0, $81404cd24b820a12$exports.jsx)("header", {
                                className: $5c49a8203b49e4a5$export$d4e9b48294707099,
                                children: "Most popular original repositories"
                            }),
                            repositories.map(this.renderRepository)
                        ]
                    })
                ]
            });
        }
    };
    _GithubProfile_user_accessor_storage = new WeakMap();
    _GithubProfile_organization_accessor_storage = new WeakMap();
    _GithubProfile_currentOwner_accessor_storage = new WeakMap();
    $3b7fc863b8681a83$var$__setFunctionName(_classThis, "GithubProfile");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _user_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _organization_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _currentOwner_decorators = [
            (0, $a2E6i.observable)
        ];
        $3b7fc863b8681a83$var$__esDecorate(_classThis, null, _user_decorators, {
            kind: "accessor",
            name: "user",
            static: false,
            private: false,
            access: {
                has: (obj)=>"user" in obj,
                get: (obj)=>obj.user,
                set: (obj, value)=>{
                    obj.user = value;
                }
            },
            metadata: _metadata
        }, _user_initializers, _user_extraInitializers);
        $3b7fc863b8681a83$var$__esDecorate(_classThis, null, _organization_decorators, {
            kind: "accessor",
            name: "organization",
            static: false,
            private: false,
            access: {
                has: (obj)=>"organization" in obj,
                get: (obj)=>obj.organization,
                set: (obj, value)=>{
                    obj.organization = value;
                }
            },
            metadata: _metadata
        }, _organization_initializers, _organization_extraInitializers);
        $3b7fc863b8681a83$var$__esDecorate(_classThis, null, _currentOwner_decorators, {
            kind: "accessor",
            name: "currentOwner",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOwner" in obj,
                get: (obj)=>obj.currentOwner,
                set: (obj, value)=>{
                    obj.currentOwner = value;
                }
            },
            metadata: _metadata
        }, _currentOwner_initializers, _currentOwner_extraInitializers);
        $3b7fc863b8681a83$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GithubProfile = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $3b7fc863b8681a83$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GithubProfile = _classThis;
})();




var $a2E6i = parcelRequire("a2E6i");



var $dda6f88a82a5bc76$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $dda6f88a82a5bc76$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $dda6f88a82a5bc76$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dda6f88a82a5bc76$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $dda6f88a82a5bc76$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $dda6f88a82a5bc76$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $dda6f88a82a5bc76$export$8bf8693277f735ca = (()=>{
    var _GithubEvents_user_accessor_storage, _GithubEvents_organization_accessor_storage, _GithubEvents_repository_accessor_storage, _GithubEvents_end_accessor_storage, _GithubEvents_list_accessor_storage;
    let _classDecorators = [
        (0, $5f04ae9df0cc484b$export$d8556a2a8f973135)({
            tagName: "github-events"
        }),
        (0, $5f04ae9df0cc484b$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _user_decorators;
    let _user_initializers = [];
    let _user_extraInitializers = [];
    let _organization_decorators;
    let _organization_initializers = [];
    let _organization_extraInitializers = [];
    let _repository_decorators;
    let _repository_initializers = [];
    let _repository_extraInitializers = [];
    let _end_decorators;
    let _end_initializers = [];
    let _end_extraInitializers = [];
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    var GithubEvents = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _GithubEvents_user_accessor_storage.set(this, $dda6f88a82a5bc76$var$__runInitializers(this, _user_initializers, ""));
            _GithubEvents_organization_accessor_storage.set(this, ($dda6f88a82a5bc76$var$__runInitializers(this, _user_extraInitializers), $dda6f88a82a5bc76$var$__runInitializers(this, _organization_initializers, "EasyWebApp")));
            _GithubEvents_repository_accessor_storage.set(this, ($dda6f88a82a5bc76$var$__runInitializers(this, _organization_extraInitializers), $dda6f88a82a5bc76$var$__runInitializers(this, _repository_initializers, "")));
            _GithubEvents_end_accessor_storage.set(this, ($dda6f88a82a5bc76$var$__runInitializers(this, _repository_extraInitializers), $dda6f88a82a5bc76$var$__runInitializers(this, _end_initializers, false)));
            _GithubEvents_list_accessor_storage.set(this, ($dda6f88a82a5bc76$var$__runInitializers(this, _end_extraInitializers), $dda6f88a82a5bc76$var$__runInitializers(this, _list_initializers, [])));
            Object.defineProperty(this, "loading", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($dda6f88a82a5bc76$var$__runInitializers(this, _list_extraInitializers), false)
            });
            Object.defineProperty(this, "nextPage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "loadMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (bottom)=>new IntersectionObserver((_, observer)=>{
                        if (!this.end) {
                            if (!this.loading) this.loadPage();
                        } else observer.disconnect();
                    }).observe(bottom)
            });
            Object.defineProperty(this, "renderPayload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ ref: ref, master_branch: master_branch, issue: issue, pull_request: pull_request, release: release, member: member, pages: pages })=>{
                    var _a, _b;
                    return (0, $81404cd24b820a12$exports.jsxs)((0, $81404cd24b820a12$exports.Fragment), {
                        children: [
                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                target: "_blank",
                                href: (_a = issue || pull_request || release || member) === null || _a === void 0 ? void 0 : _a.html_url,
                                children: ref || master_branch || ((_b = issue || pull_request) === null || _b === void 0 ? void 0 : _b.title) || (release === null || release === void 0 ? void 0 : release.name) || (member === null || member === void 0 ? void 0 : member.login)
                            }),
                            (0, $81404cd24b820a12$exports.jsx)("ol", {
                                children: pages === null || pages === void 0 ? void 0 : pages.map(({ action: action, html_url: html_url, summary: summary, sha: sha, title: title })=>(0, $81404cd24b820a12$exports.jsxs)("li", {
                                        children: [
                                            action,
                                            (0, $81404cd24b820a12$exports.jsx)("a", {
                                                target: "_blank",
                                                href: html_url,
                                                title: summary || sha,
                                                children: title
                                            })
                                        ]
                                    }))
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(this, "renderEvent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ actor: actor, repo: repo, created_at: created_at, payload: payload, type: type })=>(0, $81404cd24b820a12$exports.jsxs)("li", {
                        className: "d-flex align-items-center my-3",
                        children: [
                            (0, $81404cd24b820a12$exports.jsxs)("a", {
                                className: "text-center w-25",
                                target: "_blank",
                                href: `https://github.com/${actor.login}`,
                                title: actor.login,
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("img", {
                                        className: `${$2af7d3d6a4beaeca$export$db3c28d99448dcff} ${$2af7d3d6a4beaeca$export$cc81a5c85b55e12c}`,
                                        src: actor.avatar_url
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("div", {
                                        children: actor.display_login
                                    })
                                ]
                            }),
                            (0, $81404cd24b820a12$exports.jsxs)("div", {
                                children: [
                                    (0, $81404cd24b820a12$exports.jsx)("h4", {
                                        children: (0, $81404cd24b820a12$exports.jsx)("a", {
                                            target: "_blank",
                                            href: `https://github.com/${repo.name}`,
                                            children: repo.name
                                        })
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("time", {
                                        className: "pe-1",
                                        dateTime: created_at,
                                        children: new Date(created_at).toLocaleString()
                                    }),
                                    (0, $81404cd24b820a12$exports.jsx)("strong", {
                                        className: "pe-1",
                                        children: payload.action || type.replace("Event", "")
                                    }),
                                    this.renderPayload(payload)
                                ]
                            })
                        ]
                    }, created_at)
            });
        }
        get user() {
            return $dda6f88a82a5bc76$var$__classPrivateFieldGet(this, _GithubEvents_user_accessor_storage, "f");
        }
        set user(value) {
            $dda6f88a82a5bc76$var$__classPrivateFieldSet(this, _GithubEvents_user_accessor_storage, value, "f");
        }
        get organization() {
            return $dda6f88a82a5bc76$var$__classPrivateFieldGet(this, _GithubEvents_organization_accessor_storage, "f");
        }
        set organization(value) {
            $dda6f88a82a5bc76$var$__classPrivateFieldSet(this, _GithubEvents_organization_accessor_storage, value, "f");
        }
        get repository() {
            return $dda6f88a82a5bc76$var$__classPrivateFieldGet(this, _GithubEvents_repository_accessor_storage, "f");
        }
        set repository(value) {
            $dda6f88a82a5bc76$var$__classPrivateFieldSet(this, _GithubEvents_repository_accessor_storage, value, "f");
        }
        get end() {
            return $dda6f88a82a5bc76$var$__classPrivateFieldGet(this, _GithubEvents_end_accessor_storage, "f");
        }
        set end(value) {
            $dda6f88a82a5bc76$var$__classPrivateFieldSet(this, _GithubEvents_end_accessor_storage, value, "f");
        }
        get list() {
            return $dda6f88a82a5bc76$var$__classPrivateFieldGet(this, _GithubEvents_list_accessor_storage, "f");
        }
        set list(value) {
            $dda6f88a82a5bc76$var$__classPrivateFieldSet(this, _GithubEvents_list_accessor_storage, value, "f");
        }
        loadPage() {
            return $dda6f88a82a5bc76$var$__awaiter(this, void 0, void 0, function*() {
                this.loading = true;
                const { headers: headers, body: body } = yield !this.nextPage ? (0, $93f5c86195a73c67$export$3f41ece7d7128238)(this) : (0, $93f5c86195a73c67$export$388e0302ca0d9a41).get(this.nextPage);
                const { next: next } = headers.Link;
                if (next) this.nextPage = next.URI;
                else this.end = true;
                this.list = [
                    ...this.list,
                    ...body
                ];
                this.loading = false;
            });
        }
        render() {
            const { list: list } = this;
            return (0, $81404cd24b820a12$exports.jsxs)("div", {
                children: [
                    (0, $81404cd24b820a12$exports.jsx)("ul", {
                        className: "list-unstyled",
                        children: list.map(this.renderEvent)
                    }),
                    (0, $81404cd24b820a12$exports.jsx)("p", {
                        className: "text-center",
                        ref: this.loadMore,
                        children: this.end ? "No more" : "Loading"
                    })
                ]
            });
        }
    };
    _GithubEvents_user_accessor_storage = new WeakMap();
    _GithubEvents_organization_accessor_storage = new WeakMap();
    _GithubEvents_repository_accessor_storage = new WeakMap();
    _GithubEvents_end_accessor_storage = new WeakMap();
    _GithubEvents_list_accessor_storage = new WeakMap();
    $dda6f88a82a5bc76$var$__setFunctionName(_classThis, "GithubEvents");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _user_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _organization_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _repository_decorators = [
            (0, $5f04ae9df0cc484b$export$af4b9a83f4b00434),
            (0, $a2E6i.observable)
        ];
        _end_decorators = [
            (0, $a2E6i.observable)
        ];
        _list_decorators = [
            (0, $a2E6i.observable)
        ];
        $dda6f88a82a5bc76$var$__esDecorate(_classThis, null, _user_decorators, {
            kind: "accessor",
            name: "user",
            static: false,
            private: false,
            access: {
                has: (obj)=>"user" in obj,
                get: (obj)=>obj.user,
                set: (obj, value)=>{
                    obj.user = value;
                }
            },
            metadata: _metadata
        }, _user_initializers, _user_extraInitializers);
        $dda6f88a82a5bc76$var$__esDecorate(_classThis, null, _organization_decorators, {
            kind: "accessor",
            name: "organization",
            static: false,
            private: false,
            access: {
                has: (obj)=>"organization" in obj,
                get: (obj)=>obj.organization,
                set: (obj, value)=>{
                    obj.organization = value;
                }
            },
            metadata: _metadata
        }, _organization_initializers, _organization_extraInitializers);
        $dda6f88a82a5bc76$var$__esDecorate(_classThis, null, _repository_decorators, {
            kind: "accessor",
            name: "repository",
            static: false,
            private: false,
            access: {
                has: (obj)=>"repository" in obj,
                get: (obj)=>obj.repository,
                set: (obj, value)=>{
                    obj.repository = value;
                }
            },
            metadata: _metadata
        }, _repository_initializers, _repository_extraInitializers);
        $dda6f88a82a5bc76$var$__esDecorate(_classThis, null, _end_decorators, {
            kind: "accessor",
            name: "end",
            static: false,
            private: false,
            access: {
                has: (obj)=>"end" in obj,
                get: (obj)=>obj.end,
                set: (obj, value)=>{
                    obj.end = value;
                }
            },
            metadata: _metadata
        }, _end_initializers, _end_extraInitializers);
        $dda6f88a82a5bc76$var$__esDecorate(_classThis, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        $dda6f88a82a5bc76$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GithubEvents = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $dda6f88a82a5bc76$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GithubEvents = _classThis;
})();





(0, $a2E6i.configure)({
    enforceActions: "never"
});
new (0, $750599b2838f6371$exports.DOMRenderer)().render((0, $81404cd24b820a12$exports.jsxs)("main", {
    className: "container",
    children: [
        (0, $81404cd24b820a12$exports.jsx)("h1", {
            children: "GitHub Web Widget"
        }),
        (0, $81404cd24b820a12$exports.jsxs)("section", {
            children: [
                (0, $81404cd24b820a12$exports.jsx)("h2", {
                    children: "Command Line"
                }),
                (0, $81404cd24b820a12$exports.jsx)((0, $c16a839cb8b1bd69$export$4e979e05ed1000ce), {
                    text: "npm install github-web-widget"
                })
            ]
        }),
        (0, $81404cd24b820a12$exports.jsxs)("section", {
            children: [
                (0, $81404cd24b820a12$exports.jsx)("h2", {
                    children: "Repository"
                }),
                (0, $81404cd24b820a12$exports.jsx)((0, $895b7a52da257d33$export$d9a521d20ad2c28c), {
                    owner: "EasyWebApp",
                    repository: "WebCell"
                })
            ]
        }),
        (0, $81404cd24b820a12$exports.jsxs)("section", {
            children: [
                (0, $81404cd24b820a12$exports.jsx)("h2", {
                    children: "Issue"
                }),
                (0, $81404cd24b820a12$exports.jsx)((0, $a9cbf11fea6644ec$export$d3667e5e7566d0b7), {
                    owner: "jsdom",
                    repository: "w3c-xmlserializer",
                    issue: 2
                })
            ]
        }),
        (0, $81404cd24b820a12$exports.jsxs)("section", {
            children: [
                (0, $81404cd24b820a12$exports.jsx)("h2", {
                    children: "Profile"
                }),
                (0, $81404cd24b820a12$exports.jsx)((0, $3b7fc863b8681a83$export$85d9ef3463ff440b), {
                    user: "TechQuery"
                })
            ]
        }),
        (0, $81404cd24b820a12$exports.jsxs)("section", {
            children: [
                (0, $81404cd24b820a12$exports.jsx)("h2", {
                    children: "Event Flow"
                }),
                (0, $81404cd24b820a12$exports.jsx)((0, $dda6f88a82a5bc76$export$8bf8693277f735ca), {})
            ]
        })
    ]
}));


//# sourceMappingURL=index.2e988ea1.js.map
